// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `img {
  max-width: 100%;
}

.flex {
  display: flex;
  flex-wrap: wrap;
}

.dir-col {
  flex-direction: column;
}

.dir-col-rev {
  flex-direction: column-reverse;
}

.mh-full {
  min-height: 100%;
}

.mt-auto {
  margin-top: auto;
}

.bt-0 {
  border-top: 0;
}

.bb-0 {
  border-bottom: 0;
}

.fn-body h1,
.fn-body h2,
.fn-body h3,
.fn-body h4,
.fn-body h5,
.fn-body h6 {
  --hGap: 10px;
  font-family: "Museo-700";
  color: #6d6e71;
  margin-bottom: var(--hGap);
  margin-top: 0;
}
.fn-body h1:last-child,
.fn-body h2:last-child,
.fn-body h3:last-child,
.fn-body h4:last-child,
.fn-body h5:last-child,
.fn-body h6:last-child {
  margin-bottom: 0;
}
.fn-body h1,
.fn-body .h1-text {
  font-size: 44px;
  line-height: 1.1;
}
@media only screen and (max-width: 767px) {
  .fn-body h1,
  .fn-body .h1-text {
    font-size: 38px;
  }
}
.fn-body h2,
.fn-body .h2-text {
  font-size: 38px;
  line-height: 1.2;
}
@media only screen and (max-width: 767px) {
  .fn-body h2,
  .fn-body .h2-text {
    font-size: 32px;
  }
}
.fn-body h3,
.fn-body .h3-text {
  font-size: 32px;
  line-height: 1.2;
}
@media only screen and (max-width: 767px) {
  .fn-body h3,
  .fn-body .h3-text {
    font-size: 24px;
  }
}
.fn-body h4,
.fn-body .h4-text {
  font-size: 24px;
  line-height: 1.2;
}
.fn-body h5,
.fn-body .h5-text {
  font-size: 18px;
  line-height: 1.2;
}
.fn-body h6,
.fn-body .h6-text {
  font-size: 16px;
  line-height: 1.3;
}
.fn-body p {
  font-size: 18px;
  line-height: 1.6;
  color: #6a6a6a;
  margin-top: 0;
  margin-bottom: 10px;
}
.fn-body p:last-child {
  margin-bottom: 0;
}
@media only screen and (max-width: 767px) {
  .fn-body p {
    font-size: 16px;
  }
}
.fn-body ul,
.fn-body ol {
  padding: 0;
  margin: 0;
}
.fn-body sup {
  font-size: 0.7em;
  position: relative;
  top: 5px;
  display: inline-block;
  vertical-align: top;
}

.bg-grey {
  background-color: #eee;
}

.fn-container {
  max-width: 1080px;
  width: calc(100% - 30px);
  margin-inline: auto;
}
@media only screen and (min-width: 992px) {
  .fn-container {
    margin-left: 0;
  }
}
.fn-container--fluid {
  max-width: 1200px;
}
.fn-container--small {
  max-width: 820px;
  width: 100%;
}

.text-center {
  text-align: center;
}
.text-right {
  text-align: right;
}

.d-none {
  display: none;
}

.section-title {
  text-align: center;
}
.section-title:not(:last-child) {
  margin-bottom: 40px;
}
.section-title h2:not(:last-child) {
  margin-block-end: 20px;
}
.section-title p {
  max-width: 900px;
  width: 100%;
  margin-inline: auto;
  font-size: 22px;
}
.section-title p:not(:last-child) {
  margin-block-end: 20px;
}
@media only screen and (max-width: 767px) {
  .section-title p {
    font-size: 18px;
  }
}
.section-title .section-title__linkcontainer {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}
.section-title .section-title__linkcontainer:not(:last-child) {
  margin-block-end: 20px;
}
.section-title .section-title__linkcontainer > * {
  margin: 5px;
}
.section-title .section-title__linkcontainer .fn-btn {
  padding-block: 6px;
  padding-inline: 13px;
  font-size: 12px;
  font-family: "MuseoSans-300";
}

.section-padding {
  padding-block: 60px;
}
@media only screen and (max-width: 767px) {
  .section-padding {
    padding-block: 40px;
  }
}
.section-padding-small {
  padding-block: 30px;
}
.section-padding-all {
  padding: 60px;
}
@media only screen and (max-width: 767px) {
  .section-padding-all {
    padding: 30px;
  }
}
.section-padding-all-small {
  padding: 30px;
}

.headline {
  --lineSize: 10px;
  width: -moz-fit-content;
  width: fit-content;
  padding-block-end: calc(10px + var(--lineSize));
  margin-inline: auto;
  position: relative;
}
.headline--small-border {
  --lineSize: 6px;
}
.headline:not(:last-child) {
  margin-bottom: calc(var(--hGap) * 2.5);
}
.headline::before {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: var(--lineSize);
  background: linear-gradient(90deg, rgb(0, 173, 208) 0%, rgb(0, 173, 208) 25%, rgb(255, 121, 0) 25%, rgb(255, 121, 0) 50%, rgb(105, 190, 40) 50%, rgb(105, 190, 40) 75%, rgb(245, 67, 89) 75%, rgb(245, 67, 89) 100%);
}

.custom-list li {
  font-size: 18px;
  line-height: 1.4;
  color: #6a6a6a;
  list-style: none;
  position: relative;
  padding-left: 15px;
}
.custom-list li:not(:last-child) {
  margin-bottom: 4px;
}
.custom-list li::before {
  content: "";
  position: absolute;
  top: 10px;
  left: 0;
  width: 3px;
  height: 3px;
  background-color: var(--clrProfile);
}

.color-clarify {
  --clrProfile: rgb(0, 173, 208);
}

.color-ideate {
  --clrProfile: rgb(255, 121, 0);
}

.color-develop {
  --clrProfile: rgb(105, 190, 40);
}

.color-implement {
  --clrProfile: rgb(245, 67, 89);
}

.fn-btn {
  padding-block: 20px;
  padding-inline: 28px;
  background-color: rgb(105, 190, 40);
  color: #fff;
  font-size: 18px;
  line-height: 1.2;
  display: inline-block;
  font-family: "Museo-700";
  text-decoration: none;
  word-break: break-all;
  text-align: center;
  transition: background-color 0.3s;
}
.fn-btn:focus {
  outline: 1px dashed #6a6a6a;
  outline-offset: 4px;
}
.fn-btn:hover {
  background-color: #6d6e71;
  color: #fff;
}
.fn-btn--sm {
  font-size: 14px;
  padding-block: 10px;
  padding-inline: 20px;
}
.fn-btn--grey {
  background-color: #f1f1f2;
  color: #6d6e71;
}
.fn-btn--ongoing {
  background-color: #f8ac59;
  color: #fff;
}
.fn-btn--ongoing i {
  animation: spin 0.3s infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.color-clarify {
  --clrProfile: rgb(0, 173, 208);
}

.color-ideate {
  --clrProfile: rgb(255, 121, 0);
}

.color-develop {
  --clrProfile: rgb(105, 190, 40);
}

.color-implement {
  --clrProfile: rgb(245, 67, 89);
}

.w-4 {
  width: 33.3333333333%;
}

.w-3 {
  width: 25%;
}
.w-3--wd {
  width: 33.3333333333%;
}

.w-6 {
  width: 50%;
}

.fn-row {
  --rGap: 15px;
  --rGap-minus: calc(-1 * var(--rGap));
  display: flex;
  flex-wrap: wrap;
  margin-inline: var(--rGap-minus);
}
.fn-row--col-gap-exist .fn-col {
  margin-bottom: 30px;
}
.fn-col {
  padding-inline: var(--rGap);
}
.fn-justify-center {
  justify-content: center;
}
.fn-items-center {
  align-items: center;
}

.mx-auto {
  margin-inline: auto;
}
.ml-auto {
  margin-inline-start: auto;
}
.ml-0 {
  margin-inline-start: 0;
}
.mr-auto {
  margin-inline-end: auto;
}
.mr-0 {
  margin-inline-end: 0;
}

img {
  max-width: 100%;
}

.flex {
  display: flex;
  flex-wrap: wrap;
}

.dir-col {
  flex-direction: column;
}

.dir-col-rev {
  flex-direction: column-reverse;
}

.mh-full {
  min-height: 100%;
}

.mt-auto {
  margin-top: auto;
}

.bt-0 {
  border-top: 0;
}

.bb-0 {
  border-bottom: 0;
}

.fn-body h1,
.fn-body h2,
.fn-body h3,
.fn-body h4,
.fn-body h5,
.fn-body h6 {
  --hGap: 10px;
  font-family: "Museo-700";
  color: #6d6e71;
  margin-bottom: var(--hGap);
  margin-top: 0;
}
.fn-body h1:last-child,
.fn-body h2:last-child,
.fn-body h3:last-child,
.fn-body h4:last-child,
.fn-body h5:last-child,
.fn-body h6:last-child {
  margin-bottom: 0;
}
.fn-body h1,
.fn-body .h1-text {
  font-size: 44px;
  line-height: 1.1;
}
@media only screen and (max-width: 767px) {
  .fn-body h1,
  .fn-body .h1-text {
    font-size: 38px;
  }
}
.fn-body h2,
.fn-body .h2-text {
  font-size: 38px;
  line-height: 1.2;
}
@media only screen and (max-width: 767px) {
  .fn-body h2,
  .fn-body .h2-text {
    font-size: 32px;
  }
}
.fn-body h3,
.fn-body .h3-text {
  font-size: 32px;
  line-height: 1.2;
}
@media only screen and (max-width: 767px) {
  .fn-body h3,
  .fn-body .h3-text {
    font-size: 24px;
  }
}
.fn-body h4,
.fn-body .h4-text {
  font-size: 24px;
  line-height: 1.2;
}
.fn-body h5,
.fn-body .h5-text {
  font-size: 18px;
  line-height: 1.2;
}
.fn-body h6,
.fn-body .h6-text {
  font-size: 16px;
  line-height: 1.3;
}
.fn-body p {
  font-size: 18px;
  line-height: 1.6;
  color: #6a6a6a;
  margin-top: 0;
  margin-bottom: 10px;
}
.fn-body p:last-child {
  margin-bottom: 0;
}
@media only screen and (max-width: 767px) {
  .fn-body p {
    font-size: 16px;
  }
}
.fn-body ul,
.fn-body ol {
  padding: 0;
  margin: 0;
}
.fn-body sup {
  font-size: 0.7em;
  position: relative;
  top: 5px;
  display: inline-block;
  vertical-align: top;
}

.bg-grey {
  background-color: #eee;
}

.fn-container {
  max-width: 1080px;
  width: calc(100% - 30px);
  margin-inline: auto;
}
@media only screen and (min-width: 992px) {
  .fn-container {
    margin-left: 0;
  }
}
.fn-container--fluid {
  max-width: 1200px;
}
.fn-container--small {
  max-width: 820px;
  width: 100%;
}

.text-center {
  text-align: center;
}
.text-right {
  text-align: right;
}

.d-none {
  display: none;
}

.section-title {
  text-align: center;
}
.section-title:not(:last-child) {
  margin-bottom: 40px;
}
.section-title h2:not(:last-child) {
  margin-block-end: 20px;
}
.section-title p {
  max-width: 900px;
  width: 100%;
  margin-inline: auto;
  font-size: 22px;
}
.section-title p:not(:last-child) {
  margin-block-end: 20px;
}
@media only screen and (max-width: 767px) {
  .section-title p {
    font-size: 18px;
  }
}
.section-title .section-title__linkcontainer {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}
.section-title .section-title__linkcontainer:not(:last-child) {
  margin-block-end: 20px;
}
.section-title .section-title__linkcontainer > * {
  margin: 5px;
}
.section-title .section-title__linkcontainer .fn-btn {
  padding-block: 6px;
  padding-inline: 13px;
  font-size: 12px;
  font-family: "MuseoSans-300";
}

.section-padding {
  padding-block: 60px;
}
@media only screen and (max-width: 767px) {
  .section-padding {
    padding-block: 40px;
  }
}
.section-padding-small {
  padding-block: 30px;
}
.section-padding-all {
  padding: 60px;
}
@media only screen and (max-width: 767px) {
  .section-padding-all {
    padding: 30px;
  }
}
.section-padding-all-small {
  padding: 30px;
}

.headline {
  --lineSize: 10px;
  width: -moz-fit-content;
  width: fit-content;
  padding-block-end: calc(10px + var(--lineSize));
  margin-inline: auto;
  position: relative;
}
.headline--small-border {
  --lineSize: 6px;
}
.headline:not(:last-child) {
  margin-bottom: calc(var(--hGap) * 2.5);
}
.headline::before {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: var(--lineSize);
  background: linear-gradient(90deg, rgb(0, 173, 208) 0%, rgb(0, 173, 208) 25%, rgb(255, 121, 0) 25%, rgb(255, 121, 0) 50%, rgb(105, 190, 40) 50%, rgb(105, 190, 40) 75%, rgb(245, 67, 89) 75%, rgb(245, 67, 89) 100%);
}

.custom-list li {
  font-size: 18px;
  line-height: 1.4;
  color: #6a6a6a;
  list-style: none;
  position: relative;
  padding-left: 15px;
}
.custom-list li:not(:last-child) {
  margin-bottom: 4px;
}
.custom-list li::before {
  content: "";
  position: absolute;
  top: 10px;
  left: 0;
  width: 3px;
  height: 3px;
  background-color: var(--clrProfile);
}

.color-clarify {
  --clrProfile: rgb(0, 173, 208);
}

.color-ideate {
  --clrProfile: rgb(255, 121, 0);
}

.color-develop {
  --clrProfile: rgb(105, 190, 40);
}

.color-implement {
  --clrProfile: rgb(245, 67, 89);
}

.fn-btn {
  padding-block: 20px;
  padding-inline: 28px;
  background-color: rgb(105, 190, 40);
  color: #fff;
  font-size: 18px;
  line-height: 1.2;
  display: inline-block;
  font-family: "Museo-700";
  text-decoration: none;
  word-break: break-all;
  text-align: center;
  transition: background-color 0.3s;
}
.fn-btn:focus {
  outline: 1px dashed #6a6a6a;
  outline-offset: 4px;
}
.fn-btn:hover {
  background-color: #6d6e71;
  color: #fff;
}
.fn-btn--sm {
  font-size: 14px;
  padding-block: 10px;
  padding-inline: 20px;
}
.fn-btn--grey {
  background-color: #f1f1f2;
  color: #6d6e71;
}
.fn-btn--ongoing {
  background-color: #f8ac59;
  color: #fff;
}
.fn-btn--ongoing i {
  animation: spin 0.3s infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.color-clarify {
  --clrProfile: rgb(0, 173, 208);
}

.color-ideate {
  --clrProfile: rgb(255, 121, 0);
}

.color-develop {
  --clrProfile: rgb(105, 190, 40);
}

.color-implement {
  --clrProfile: rgb(245, 67, 89);
}

.w-4 {
  width: 33.3333333333%;
}

.w-3 {
  width: 25%;
}
.w-3--wd {
  width: 33.3333333333%;
}

.w-6 {
  width: 50%;
}

.fn-row {
  --rGap: 15px;
  --rGap-minus: calc(-1 * var(--rGap));
  display: flex;
  flex-wrap: wrap;
  margin-inline: var(--rGap-minus);
}
.fn-row--col-gap-exist .fn-col {
  margin-bottom: 30px;
}
.fn-col {
  padding-inline: var(--rGap);
}
.fn-justify-center {
  justify-content: center;
}
.fn-items-center {
  align-items: center;
}

.mx-auto {
  margin-inline: auto;
}
.ml-auto {
  margin-inline-start: auto;
}
.ml-0 {
  margin-inline-start: 0;
}
.mr-auto {
  margin-inline-end: auto;
}
.mr-0 {
  margin-inline-end: 0;
}

::ng-deep #holder > li {
  padding: 5px;
  margin: 2px;
  display: inline-block;
  border-color: #ddd;
}

::ng-deep #holder > li[data-page] {
  border: solid #a0a0a0 1px;
  border-radius: 5px;
}

::ng-deep #holder > li.separator:before {
  content: "...";
}

::ng-deep #holder > li.active {
  background-color: #f4f4f4;
  color: inherit;
}

::ng-deep #holder > li[data-page]:hover {
  cursor: pointer;
}

.groups {
  margin-left: 15px;
  margin-bottom: 10px;
}

.reset-input th {
  position: relative;
}
.reset-input th input[type=search] {
  width: 100% !important;
}
.reset-input th .reset-close {
  display: none;
  position: absolute;
  top: 0;
  right: 25px;
  bottom: 0;
  margin: auto;
  border-radius: 50%;
  background: #ddd;
  border: none !important;
  text-align: center;
  font-size: 14px;
  padding: 0px !important;
  height: 16px !important;
  width: 16px !important;
  color: #fff;
  line-height: 1.2 !important;
  font-family: Arial !important;
  transform: rotate(45deg) !important;
  -webkit-transform: rotate(45deg) !important;
}
.reset-input th:hover .reset-close {
  display: block;
}

.tva__head {
  min-height: 84px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  border: 1px solid #e7eaec;
  border-radius: 4px;
  margin-inline: 15px;
  padding: 17px 35px;
}
.tva__head i:hover {
  color: rgb(105, 190, 40);
}
@media only screen and (max-width: 767px) {
  .tva__head {
    padding-inline: 20px;
  }
}
.tva__head--border-0 {
  border: 0;
}
.tva__head--type-1 {
  padding: 8px 27px;
  min-height: auto;
}
@media only screen and (max-width: 767px) {
  .tva__head--type-1 {
    padding-inline: 20px;
  }
}
.tva__head--type-1 .tva__cta__hd h5 {
  font-size: 16px;
  font-weight: 700;
}
.tva__head--brb-0 {
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
.tva__head .f-m-bottom-0 + span {
  font-weight: bold;
  font-size: 12px;
}
.tva__head .f-m-bottom-0 + span img {
  width: 40px;
  margin-left: 6px;
}
.tva__cta__hd {
  width: 100%;
}
.tva__cta__hd h5 {
  font-size: 24px;
  font-weight: 700;
  color: #676a6c;
  margin-top: 0;
}
.tva__cta__hd h5.tva__head_subtitle {
  font-size: 16px;
}
.tva__cta__hd small {
  font-size: 14px;
}
.tva__cta__btn {
  display: inline-block;
}
.tva__cta__btn--comp a {
  background-color: transparent;
  padding: 0;
  color: #676a6c;
  border-color: #e7eaec;
}
.tva__cta__btn--comp a span {
  display: inline-block;
  padding: 5px 12px;
}
.tva__cta__btn--comp a span:first-child {
  border-right: 1px solid #e7eaec;
}
.tva__bot table {
  border: 1px solid #e7eaec;
  border-collapse: collapse;
}
.tva__bot table thead tr:first-child {
  background-color: #f1f1f2;
}
.tva__bot table thead tr input[type=checkbox] {
  border: 1px solid #e7eaec;
}
.tva__bot table thead tr th {
  border: 0;
}
.tva__bot table input[type=checkbox] {
  display: none;
}
.tva__bot table input[type=checkbox] + label {
  position: relative;
  cursor: pointer;
}
.tva__bot table input[type=checkbox] + label::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  height: 10px;
  width: 10px;
  border: 1px solid #e7eaec;
  border-radius: 3px;
}
.tva__bot table input[type=checkbox]:checked + label::after {
  content: "";
  position: absolute;
  left: 4px;
  top: 3px;
  border-right: 2px solid #e7eaec;
  border-bottom: 2px solid #e7eaec;
  rotate: 45deg;
  height: 4px;
  width: 2px;
}

.back {
  background-color: #fff;
  color: #676a6c;
  border: 0;
}

._mb_5 {
  margin-bottom: 5px;
}

._bg_neutral_light {
  background-color: #f1f1f2;
}

._color_body_content {
  color: #676a6c;
}

.lead, .teams .title-case.role span, .teams__profile span.lead {
  font-size: 8px;
  font-weight: 700;
  display: inline-block;
  padding: 2px 4px;
  background-color: #676a6c;
  border-radius: 2px;
  color: #fff;
}
.lead--round {
  background-color: #fff !important;
  color: #676a6c !important;
  border-radius: 50% !important;
  border: 1px solid #e7eaec !important;
}

::ng-deep.userProfile {
  border: 2px solid #f1f1f2;
  border-radius: 4px;
  border-top: 0;
}
::ng-deep.userProfile--brt-0 {
  border-top-right-radius: 0;
  border-top-left-radius: 0;
}
::ng-deep.userProfile--bdr-0 {
  border: 0;
}
@media only screen and (max-width: 1199px) {
  ::ng-deep.userProfile__top-row > div {
    width: 100%;
  }
}
::ng-deep.userProfile__team {
  padding-inline: 8px;
}
::ng-deep.userProfile__team__accord {
  border: 1px solid #e7eaec;
  border-radius: 4px;
  border-top: 0;
  min-height: 100%;
}
::ng-deep.userProfile__team__accord--zindex {
  position: relative;
  z-index: 999;
}
::ng-deep.userProfile__team__accord--mr {
  margin-right: 2%;
}
::ng-deep.userProfile__team__accord_header {
  background-color: #f1f1f2;
  padding: 10px 19px;
  min-height: 38px;
  display: flex;
  align-items: center;
}
::ng-deep.userProfile__team__accord_header--posZind {
  position: relative;
  z-index: 999;
}
::ng-deep.userProfile__team__accord_header h5 {
  color: #676a6c;
  margin-top: 0;
  font-size: 14px;
}
::ng-deep.userProfile__team__accord_body {
  padding: 13px 18px;
  position: relative;
}
::ng-deep.userProfile__team__accord_body > :not(:last-child), ::ng-deep.userProfile__team__accord_body_list > :not(:last-child) {
  margin-bottom: 15px;
}
::ng-deep.userProfile__team__accord_body_list:not(:last-child) {
  margin-bottom: 7px !important;
}
::ng-deep.userProfile__team__accord_body_list {
  max-height: 146px;
  overflow: hidden;
  transition: all ease 0.5s;
}
::ng-deep.userProfile__team__accord_body_list.active {
  max-height: none;
}
::ng-deep.userProfile__team__accord_body * {
  margin-top: 0;
}
::ng-deep.userProfile__team__accord_body a {
  color: #676a6c;
}
::ng-deep.userProfile__team__accord_body ul,
::ng-deep.userProfile__team__accord_body ol {
  margin: 0 0 0 14px;
  padding: 0;
}
::ng-deep.userProfile__team__accord_body ul > :not(:last-child),
::ng-deep.userProfile__team__accord_body ol > :not(:last-child) {
  margin-bottom: 10px;
}
::ng-deep.userProfile__team__accord_body h5 {
  font-weight: 700;
  font-size: 14px;
}
::ng-deep.userProfile__team__accord_body p,
::ng-deep.userProfile__team__accord_body li {
  font-weight: 600;
  font-size: 12px;
}
::ng-deep.userProfile__team__accord_body .active + .userProfile__team__accord_body_show_more_button {
  position: static;
  background-color: transparent;
  padding-top: 0;
}
::ng-deep.userProfile__team__accord_body_show_more_button {
  text-align: center;
  position: absolute;
  bottom: 10px;
  right: 0;
  left: 0;
  background: linear-gradient(180deg, transparent, #fff);
  padding-top: 10px;
}
::ng-deep.userProfile__team__accord_body_exter_links > :not(:last-child) {
  border-bottom: 1px solid #e7eaec;
  margin-bottom: 4px;
  padding-bottom: 7px;
}
@media only screen and (max-width: 767px) {
  ::ng-deep.userProfile__team__accord_body_exter_links > div > div {
    flex: none;
    width: 100%;
    text-align: left;
  }
}
::ng-deep.userProfile__team__accord_body_exter_links a:hover i {
  color: rgb(105, 190, 40);
}
::ng-deep.userProfile__team__accord_body_exter_links a i {
  transition: 300ms;
}
::ng-deep.userProfile__team__accord_body_groups {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-gap: 20px;
}
@media only screen and (max-width: 1199px) {
  ::ng-deep.userProfile__team__accord_body_groups {
    grid-template-columns: repeat(2, 1fr);
  }
}
::ng-deep.userProfile__team__accord_body_groups .clarify .userProfile__team__accord_body_groups_header {
  background-color: rgb(0, 173, 208);
}
::ng-deep.userProfile__team__accord_body_groups .clarify h5 {
  color: #676a6c;
  font-weight: 600;
}
::ng-deep.userProfile__team__accord_body_groups .clarify h5 span {
  color: rgb(0, 173, 208);
}
::ng-deep.userProfile__team__accord_body_groups .ideate .userProfile__team__accord_body_groups_header {
  background-color: rgb(255, 121, 0);
}
::ng-deep.userProfile__team__accord_body_groups .ideate h5 {
  color: #676a6c;
  font-weight: 600;
}
::ng-deep.userProfile__team__accord_body_groups .ideate h5 span {
  color: rgb(255, 121, 0);
}
::ng-deep.userProfile__team__accord_body_groups .develop .userProfile__team__accord_body_groups_header {
  background-color: rgb(105, 190, 40);
}
::ng-deep.userProfile__team__accord_body_groups .develop h5 {
  color: #676a6c;
  font-weight: 600;
}
::ng-deep.userProfile__team__accord_body_groups .develop h5 span {
  color: rgb(105, 190, 40);
}
::ng-deep.userProfile__team__accord_body_groups .implement .userProfile__team__accord_body_groups_header {
  background-color: rgb(245, 67, 89);
}
::ng-deep.userProfile__team__accord_body_groups .implement h5 {
  color: #676a6c;
  font-weight: 600;
}
::ng-deep.userProfile__team__accord_body_groups .implement h5 span {
  color: rgb(245, 67, 89);
}
::ng-deep.userProfile__team__accord_body_groups_header {
  padding: 6px 10px;
  border-radius: 2px;
  background-color: var(--group_clr);
  font-size: 14px;
  font-weight: 600;
  color: #fff;
}
::ng-deep.userProfile__team__accord_body_groups_header:not(:last-child) {
  margin-bottom: 15px;
}
::ng-deep.userProfile__team__accord_body_groups h5 {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  grid-gap: 3px;
}
::ng-deep.userProfile__team__accord_body_groups h5:not(:last-child) {
  margin-bottom: 5px;
}
::ng-deep.userProfile__team__accord_body_groups h5 span {
  width: 18px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  aspect-ratio: 1;
  border-radius: 50%;
  background: #f1f1f2;
  font-size: 0.8em;
}
::ng-deep.userProfile__team__accord_body_groups ul {
  margin: 0;
  padding: 0;
  list-style: none;
}
::ng-deep.userProfile__team__accord_body_groups ul:not(:last-child) {
  margin-bottom: 15px;
}
::ng-deep.userProfile__team__accord_body_groups ul li:not(:last-child) {
  margin-bottom: 3px;
}
::ng-deep.userProfile__team__spcltxt {
  font-size: 12px;
  padding: 10px 16px;
  font-style: italic;
}
::ng-deep.userProfile__graph .wrapper-content--pd-0 {
  padding: 0;
}
::ng-deep.userProfile__graph_header {
  background-color: #f1f1f2;
  padding: 9px 17px;
  font-size: 14px;
  font-weight: 700;
  color: #676a6c;
  border-radius: 5px 5px 0 0;
}
::ng-deep.userProfile__graph_header span {
  font-weight: 600;
}
::ng-deep.userProfile__graph_header span .tooltip-text {
  display: none;
}
::ng-deep.userProfile__graph_header span.info-text {
  position: relative;
}
::ng-deep.userProfile__graph_header span.info-text:hover {
  cursor: pointer;
}
::ng-deep.userProfile__graph_header span.info-text:hover .tooltip-text {
  display: none;
  position: absolute;
  display: inline-block;
  min-width: 240px;
  bottom: calc(100% + 10px);
  background-color: #fff;
  left: 50%;
  transform: translateX(-50%);
  padding: 5px;
  border-radius: 4px;
  text-align: center;
  z-index: 99;
}
::ng-deep.userProfile__graph_header span.info-text:hover .tooltip-text::before {
  content: "";
  width: 16px;
  height: 8px;
  clip-path: polygon(0 0, 100% 0, 50% 100%);
  background-color: #fff;
  position: absolute;
  top: 99%;
  left: 50%;
  transform: translateX(-50%);
}
::ng-deep.userProfile__graph__plan {
  width: 85%;
  margin-left: auto;
}
::ng-deep.userProfile__graph__plan h5 {
  font-size: 14px;
  font-weight: 600;
  border-bottom: 1px solid #e7eaec;
  padding-bottom: 10px;
  margin: 0;
}
::ng-deep.userProfile__graph__plan-pf {
  color: #676a6c;
  opacity: 0.6;
}
::ng-deep.userProfile__graph__plan-pf .teams__profile_inner {
  padding-inline: 5px;
  border-right: 1px solid #e7eaec;
}
::ng-deep.userProfile__graph__plan-pf .teams__profile_inner:last-child {
  border-right: 0;
}
::ng-deep.userProfile__graph__plan-pf .teams__profile_inner .nobg {
  background-color: transparent !important;
  font-weight: 400 !important;
}
::ng-deep.userProfile__graph__plan--our {
  position: relative;
  z-index: 999;
}
::ng-deep.userProfile__graph__plan--our h5 {
  padding-bottom: 0;
  border: 0;
}
::ng-deep.userProfile__graph__plan--our textarea {
  border: 1px solid #e7eaec;
}
::ng-deep.userProfile__graph__plan--our .cross_icn {
  width: 22px;
  height: 22px;
  border: 1px solid #e7eaec;
  position: relative;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 5px;
}
::ng-deep.userProfile__graph__plan--our .cancel_btn {
  color: #676a6c;
  border: 0;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 14px;
  font-weight: 700;
  transition: all ease 0.3s;
  padding-right: 7px;
}
::ng-deep.userProfile__graph__plan--our .save_btn {
  display: inline-block;
  font-size: 10px;
  font-weight: bold;
  border: 1px solid #e7eaec;
  border-radius: 20px;
  padding: 3px 6px;
}
::ng-deep.userProfile__graph__lead {
  width: 87%;
  margin-left: auto;
}
::ng-deep.userProfile .team-compo {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  grid-gap: 30px;
}
::ng-deep.userProfile .team-compo .profile-section {
  margin-bottom: 0;
  flex: 1.2;
}
::ng-deep.userProfile .team-compo .below-chart {
  flex: 1;
  box-shadow: none;
  border-radius: 4px;
}
@media only screen and (max-width: 991px) {
  ::ng-deep.userProfile .team-compo .below-chart {
    flex: auto;
  }
}
::ng-deep.userProfile .team-graph .chart-container {
  max-width: 100% !important;
}

.teams_cont--mxwd {
  max-width: 357px;
}
.teams__row-autofit {
  display: grid;
  margin: 0;
  grid-template-columns: repeat(auto-fit, minmax(0, 230px));
  grid-gap: calc(2 * var(--gap-default));
}
@media only screen and (max-width: 767px) {
  .teams__row-autofit {
    grid-template-columns: 1fr;
  }
}
.teams__col-autofit {
  width: 100% !important;
  padding-inline: 0;
}
.teams--b-e {
  border: 2px solid #f1f1f2;
  border-radius: 4px;
}
.teams--brt-0 {
  border-top-right-radius: 0;
  border-top-left-radius: 0;
}
@media only screen and (max-width: 1600px) {
  .teams__col-4 {
    width: 50%;
  }
}
@media only screen and (max-width: 1199px) {
  .teams__col-4 {
    width: 100%;
  }
}
@media only screen and (max-width: 1199px) {
  .teams__col-6 {
    width: 100%;
  }
}
.teams__cell {
  min-height: 100%;
  display: flex;
  flex-direction: column;
}
@media only screen and (max-width: 767px) {
  .teams__cell {
    margin-right: 0;
  }
}
.teams__cell:hover .teams__header_btn {
  opacity: 1;
  background-color: rgb(105, 190, 40);
}
.teams__header {
  background-color: #f1f1f2;
  padding: 9px 15px 9px 18px;
  border-radius: 5px 5px 0 0;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  grid-gap: 10px;
}
.teams__header--wbg {
  background-color: #fff;
}
.teams__header--bdr {
  border: 1px solid #e7eaec;
}
.teams__header_title {
  font-size: 12px;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  color: #676a6c;
  font-weight: 700;
  flex: 1;
}
.teams__header_title--capsbrk {
  text-transform: capitalize;
  word-break: break-all;
}
.teams__header_title .tm_name:hover .short_name {
  display: none;
}
.teams__header_title .tm_name:hover .full_name {
  display: inline-block;
}
.teams__header_title .tm_name .full_name {
  display: none;
}
.teams__header_title__contr {
  gap: 10px;
}
.teams__header_title__contr .roster {
  color: #fff;
  background-color: #676a6c;
  border: 1px solid #d9d9d9;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  text-align: center;
  font-size: 10px;
  padding-top: 1px;
}
.teams__header_title__contr .roster__name {
  display: none;
  width: 150px;
  color: #676a6c;
  background-color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 6px;
  box-shadow: 0 0 18px rgba(0, 0, 0, 0.1);
  font-size: 13px;
  font-family: "Open Sans", sans-serif;
  line-height: 1.5;
  position: absolute;
  top: -35px;
  left: -16px;
  z-index: 1;
}
.teams__header_title__contr .roster:hover .roster__name {
  display: block;
}
.teams__header_btn {
  background-color: #d9d9d9;
  color: #fff;
  font-weight: 700;
  opacity: 0.6;
  font-size: 10px;
}
.teams__header button {
  background-color: #fff;
  border-radius: 2px;
  padding: 4px 9px;
  font-size: 8px;
  font-weight: 700;
  color: #676a6c;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  padding: 4px 9px;
}
.teams__header .disable {
  opacity: 0.5;
  cursor: not-allowed;
}
.teams__profile {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  grid-gap: 10px 20px;
  padding: 13px 19px 10px;
}
.teams__profile--pd {
  padding-top: 20px;
  padding-bottom: 0;
  min-height: 46px;
}
.teams__profile--bdrtop {
  border-top: 1px solid #e7eaec;
}
.teams__profile--nflx {
  display: block;
  padding: 13px 9px 10px;
}
.teams__profile_inner {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  grid-gap: 10px;
}
.teams__profile_inner__pfn {
  line-height: 1;
}
.teams__profile_inner .nobg {
  background-color: #fff;
  font-weight: normal;
  padding: 0;
  display: inline-block;
}
.teams__profile_inner--rytbdr {
  border-right: 1px solid #e7eaec;
}
.teams__profile_inner--rytbdr:last-child {
  border-right: 0;
}
.teams__profile_inner ::ng-deep .profile_types {
  margin-left: 0;
}
.teams__profile_inner--gap5 {
  grid-gap: 5px;
}
.teams__profile_inner--gap5 .trans_scale {
  transform: scale(0.8);
}
.teams__profile_inner span {
  display: inline-block;
  background-color: #d4d4d4;
  color: #676a6c;
  padding: 4px;
  font-size: 10px;
  border-radius: 2px;
  font-weight: 700;
  text-align: center;
}
.teams__profile_inner span.txt {
  background-color: transparent;
  display: block;
  padding: 0;
  text-align: left;
  font-weight: 400;
}
@media only screen and (max-width: 991px) {
  .teams__profile_inner {
    width: 100%;
  }
}
.teams__profile_inner--usrPf {
  width: 90%;
  margin-left: auto;
  padding-top: 11px;
}
.teams__profile img {
  margin-right: 5px;
  width: 35px;
}
.teams__profile_name {
  color: #676a6c;
  font-size: 12px;
  font-weight: 700;
}
@media only screen and (max-width: 991px) {
  .teams__profile span.lead, .teams__profile .teams .title-case.role span, .teams .title-case.role .teams__profile span {
    margin-left: auto;
  }
}
.teams__tab_table {
  padding: 20px;
}
.teams__tab_table ::ng-deep table {
  padding: 0;
  border: 1px solid #e7eaec;
  border-collapse: collapse;
  min-width: 450px;
}
.teams__tab_table ::ng-deep table th,
.teams__tab_table ::ng-deep table td {
  border: 1px solid #e7eaec !important;
  padding: 5px;
  font-size: 12px;
}
.teams__tab_table ::ng-deep table th:not(:first-child),
.teams__tab_table ::ng-deep table td:not(:first-child) {
  text-align: center;
}
.teams__tab_table ::ng-deep table td {
  font-weight: 600;
}
.teams__tab_table ::ng-deep table .records_select {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  grid-gap: 5px;
  margin-bottom: 0;
}
.teams__tab_table ::ng-deep table .records_select label {
  margin-bottom: 0;
}
.teams__tab_table ::ng-deep table select {
  width: min(70px, 100%);
}
.teams__tab_table ::ng-deep table select:focus {
  outline: none;
}
.teams__tab_content {
  padding: 20px;
}
.teams__tab_content ::ng-deep .team-tls {
  padding: 0;
}
.teams__tab_content ::ng-deep .team-tls__inner {
  padding-inline: 0;
}
.teams__tab_content ::ng-deep .team-tls__inner:not(:last-child) {
  margin-bottom: 10px;
}
.teams__tab_content ::ng-deep .team-tls__inner * {
  font-size: 12px;
  font-weight: 600;
}
.teams__tab_content ::ng-deep .team-tls ul {
  margin: 0;
  padding: 0 0 0 24px;
}
.teams__tab_content ::ng-deep .team-tls ul li:not(:last-child) {
  margin-bottom: 5px;
}
::ng-deep .teams__buttons {
  display: flex;
  flex-wrap: wrap;
  border-top: 1px solid #e7eaec;
  border-bottom: 1px solid #e7eaec;
}
::ng-deep .teams__buttons button {
  flex: 1;
  border: 0;
  color: #676a6c;
  text-align: center;
  font-size: 10px;
  font-weight: 600;
  padding: 12px;
  background-color: transparent;
  cursor: pointer;
  position: relative;
}
::ng-deep .teams__buttons button:hover {
  background-color: #e7eaec;
}
::ng-deep .teams__buttons button.active::after {
  content: "";
  position: absolute;
  bottom: 0;
  right: 0;
  left: 0;
  height: 2px;
  background-color: rgb(105, 190, 40);
  opacity: 1;
}
::ng-deep .teams__buttons button:not(:last-child) {
  border-right: 1px solid #e7eaec;
}
.teams .profile_types.no-profile {
  background-image: none !important;
  width: auto;
}
.teams .profile_types.no-profile::after {
  color: #676a6c;
  background-color: #d9d9d9;
  content: "No profile";
  padding: 5px 8px;
  font-size: 10px;
  left: -10px;
  position: relative;
  top: -6px;
}
.teams ::ng-deep .team-graph--wd {
  width: 80%;
}
.teams ::ng-deep .team-graph--ma {
  margin: 0 auto;
}
.teams ::ng-deep .team-graph--mva {
  margin: auto 0;
}
.teams ::ng-deep .team-graph.wrapper-content {
  padding: 16px 16px 0;
  margin-bottom: 11px;
}
.teams__plan {
  z-index: 99;
  border-top: 1px solid #e7eaec;
}
.teams__plan h5 {
  font-size: 14px;
  font-weight: 600;
}
.teams__plan p {
  font-size: 12px;
  opacity: 0.6;
}
.teams__plan textarea {
  border: 1px solid #e7eaec;
  width: 100%;
  padding: 10px;
  resize: vertical;
  font-size: 10px;
}
.teams__plan textarea:focus {
  outline: none;
}
.teams__plan--wd {
  max-width: 85%;
  margin-left: auto;
}
.teams__plan--pdt {
  padding-top: 36px;
}
.teams__plan--bdr {
  border: 1px solid #e7eaec;
  border-top: 0;
  padding-inline: 10px;
}
.teams__plan__my:not(:last-child) {
  padding-bottom: 12px;
}
.teams__plan__my i {
  font-size: 10px !important;
}
.teams__plan__my h5 {
  margin: 0;
  font-size: 10px;
}
.teams__plan__my .save_btn {
  display: inline-block;
  font-size: 10px;
  font-weight: bold;
  border: 1px solid #e7eaec;
  border-radius: 20px;
  padding: 3px 6px;
}
.teams__plan__my .cross_icn {
  width: 22px;
  height: 22px;
  border: 1px solid #e7eaec;
  position: relative;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 5px;
}
.teams__plan__my .cancel_btn {
  color: #676a6c;
  border: 0;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 14px;
  font-weight: 700;
  transition: all ease 0.3s;
  padding-right: 7px;
}
.teams__plan__my--bdr {
  border-bottom: 1px solid #e7eaec;
}
.teams__plan__my--indiv h5,
.teams__plan__my--indiv i {
  font-size: 14px !important;
}
.teams__plan__my--indiv textarea {
  font-size: 12px;
}
.teams__plan__our {
  padding-bottom: 10px;
}
.teams__plan__svd {
  border: 1px solid #e7eaec;
  padding: 10px 5px;
  border-radius: 5px;
}
.teams__body {
  border: 1px solid #e7eaec;
  border-top: 0;
  display: flex;
  flex-direction: column;
  flex: 1;
}
.teams__body--nobdr {
  border: 0;
}
.teams .team-table {
  padding: 10px;
}
.teams .team-table-bg ::ng-deep .hide-ratio h5 {
  display: none;
}
.teams .team-table-bg ::ng-deep .show-counter {
  display: flex;
  justify-content: center;
}
.teams .team-table-bg ::ng-deep .show-counter.high-clarify h5, .teams .team-table-bg ::ng-deep .show-counter.low-clarify h5 {
  border: 5px solid rgb(0, 173, 208);
  background-color: rgb(0, 173, 208);
  color: rgb(0, 173, 208) !important;
  text-shadow: none !important;
}
.teams .team-table-bg ::ng-deep .show-counter.high-ideate h5, .teams .team-table-bg ::ng-deep .show-counter.low-ideate h5 {
  border: 5px solid rgb(255, 121, 0);
  background-color: rgb(255, 121, 0);
  color: rgb(255, 121, 0) !important;
  text-shadow: none !important;
}
.teams .team-table-bg ::ng-deep .show-counter.high-develop h5, .teams .team-table-bg ::ng-deep .show-counter.low-develop h5 {
  border: 5px solid rgb(105, 190, 40);
  background-color: rgb(105, 190, 40);
  color: rgb(105, 190, 40) !important;
  text-shadow: none !important;
}
.teams .team-table-bg ::ng-deep .show-counter.high-implement h5, .teams .team-table-bg ::ng-deep .show-counter.low-implement h5 {
  border: 5px solid rgb(245, 67, 89);
  background-color: rgb(245, 67, 89);
  color: rgb(245, 67, 89) !important;
  text-shadow: none !important;
}
.teams .team-table-bg ::ng-deep .show-counter h5 {
  height: 30px !important;
  width: 30px !important;
  border-radius: 50%;
  margin-inline: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 10px !important;
}
@media screen and (max-width: 480px) {
  .teams .team-table-bg ::ng-deep .show-counter h5 {
    height: 20px !important;
    width: 20px !important;
  }
}
.teams .team-table-bg ::ng-deep .high-clarify.common-high.common-profile._bg_changer {
  background-color: #d9d9d9 !important;
}
.teams .team-table-bg ::ng-deep .high-ideate.common-high.common-profile._bg_changer {
  background-color: #d9d9d9 !important;
}
.teams .team-table-bg ::ng-deep .high-develop.common-high.common-profile._bg_changer {
  background-color: #d9d9d9 !important;
}
.teams .team-table-bg ::ng-deep .high-implement.common-high.common-profile._bg_changer {
  background-color: #d9d9d9 !important;
}
.teams .team-table-bg ::ng-deep .low-clarify.common-low.common-profile._bg_changer {
  background-color: #d9d9d9 !important;
}
.teams .team-table-bg ::ng-deep .low-ideate.common-low.common-profile._bg_changer {
  background-color: #d9d9d9 !important;
}
.teams .team-table-bg ::ng-deep .low-develop.common-low.common-profile._bg_changer {
  background-color: #d9d9d9 !important;
}
.teams .team-table-bg ::ng-deep .low-implement.common-low.common-profile._bg_changer {
  background-color: #d9d9d9 !important;
}
.teams .team-table img {
  width: 17%;
}
.teams .team-table table {
  border: 2px solid #f1f1f2;
  border-right: 0;
}
.teams .team-table table thead {
  background-color: #e7eaec;
  padding: 7px;
  font-size: 12px;
}
.teams .team-table table tbody tr td {
  width: 33.3333333333%;
  border-right: 2px solid #f1f1f2;
  padding: 7px;
}
.teams ::ng-deep.ibox {
  border: 0;
}
.teams ::ng-deep.ibox-title {
  border-top: 0;
  padding: 8px 18px;
  min-height: auto;
  background-color: #f1f1f2;
  border-radius: 4px 4px 0 0;
}
.teams ::ng-deep.ibox-title h5 {
  float: none;
  font-size: 12px;
  font-weight: 700;
}
.teams ::ng-deep.ibox-title h5:last-child {
  margin-bottom: 0;
}
.teams ::ng-deep.ibox-title--fx h5 {
  display: flex;
}
.teams ::ng-deep.ibox-content {
  padding: 0;
  border: 1px solid #e7eaec;
  border-radius: 0 0 4px 4px;
}
.teams ::ng-deep.ibox-content table {
  margin-bottom: 0;
}
.teams ::ng-deep.ibox-content table th {
  font-size: 10px;
  color: #676a6c;
}
.teams ::ng-deep.ibox-content table th .soryby_outer {
  display: inline-flex;
  flex-direction: column;
  height: 12px;
  line-height: 1;
  position: relative;
  width: 10px;
  top: 2px;
}
.teams ::ng-deep.ibox-content table th .soryby_outer > div {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
}
.teams ::ng-deep.ibox-content table th .soryby_outer > div:nth-child(1) {
  top: 0;
}
.teams ::ng-deep.ibox-content table th .soryby_outer > div:nth-child(2) {
  bottom: 0;
}
.teams ::ng-deep.ibox-content table td {
  color: #676a6c;
}
.teams ::ng-deep.ibox-content table td.title-case span {
  border-radius: 2px;
  background-color: #676a6c;
  color: #fff;
  padding: 2px 4px 3px;
  font-size: 10px;
  font-weight: 700;
}
.teams ::ng-deep.ibox-content table td.one_one_adv a {
  display: inline-block;
  border: 2px solid rgb(105, 190, 40);
  color: rgb(105, 190, 40);
  font-weight: 700;
  padding: 4px 10px;
  border-radius: 4px;
  font-size: clamp(10px, 1vw, 14px);
  text-align: center;
  min-width: 100px;
}
.teams ::ng-deep.ibox-content table td.one_one_adv a:hover {
  background-color: rgb(105, 190, 40);
  color: #fff;
}
.teams ::ng-deep.ibox-content table td a {
  color: inherit;
}
.teams ::ng-deep.ibox-content table td .no_pf {
  display: inline-block;
  background-color: #d4d4d4;
  color: #676a6c;
  padding: 4px;
  font-size: 10px;
  border-radius: 2px;
  font-weight: 700;
  text-align: center;
}
.teams ::ng-deep.ibox-content table .records_select {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  grid-gap: 5px;
  margin-bottom: 0;
}
.teams ::ng-deep.ibox-content table .records_select label {
  margin-bottom: 0;
}
.teams ::ng-deep.ibox-content table .records_select select {
  width: min(70px, 100%);
}

::ng-deep .for-team-compo {
  display: none;
}

.f-m-inline-0 {
  margin-inline: 0 !important;
}

@media screen and (max-width: 1024px) {
  .f-col-sm-12 {
    width: 100%;
  }
}
span.sortby {
  left: 0px;
  width: 100%;
  height: 100%;
  z-index: 99999;
  text-align: right;
  position: absolute;
  padding-right: 14px;
}

.art_dropdown_right .circle__dropdown, ::ng-deep.team_meet__col_art_grid.p_id_15 .implement .circle__dropdown, ::ng-deep.team_meet__col_art_grid.p_id_15 .develop .circle__dropdown, ::ng-deep.team_meet__col_art_grid.p_id_13 .circle__dropdown, ::ng-deep.team_meet__col_art_grid.p_id_14 .circle.implement .circle__dropdown, ::ng-deep.team_meet__col_art_grid.p_id_4 .implement .circle__dropdown, ::ng-deep.team_meet__col_art_grid.p_id_12 .implement .circle__dropdown, ::ng-deep.team_meet__col_art_grid.p_id_10 .circle__dropdown, ::ng-deep.team_meet__col_art_grid.p_id_9 .implement .circle__dropdown, ::ng-deep.team_meet__col_art_grid.p_id_7 .implement .circle__dropdown {
  right: 0;
  left: auto;
}
.art_dropdown_right .circle__dropdown::after, ::ng-deep.team_meet__col_art_grid.p_id_15 .implement .circle__dropdown::after, ::ng-deep.team_meet__col_art_grid.p_id_15 .develop .circle__dropdown::after, ::ng-deep.team_meet__col_art_grid.p_id_13 .circle__dropdown::after, ::ng-deep.team_meet__col_art_grid.p_id_14 .circle.implement .circle__dropdown::after, ::ng-deep.team_meet__col_art_grid.p_id_4 .implement .circle__dropdown::after, ::ng-deep.team_meet__col_art_grid.p_id_12 .implement .circle__dropdown::after, ::ng-deep.team_meet__col_art_grid.p_id_10 .circle__dropdown::after, ::ng-deep.team_meet__col_art_grid.p_id_9 .implement .circle__dropdown::after, ::ng-deep.team_meet__col_art_grid.p_id_7 .implement .circle__dropdown::after {
  right: 17%;
  left: auto;
}

.art_dropdown_bottom .circle__dropdown, ::ng-deep.team_meet__col_art_grid.p_id_14 .circle.develop .circle__dropdown {
  top: calc(100% + 10px);
  right: 0;
  bottom: auto;
  left: auto;
}
.art_dropdown_bottom .circle__dropdown::after, ::ng-deep.team_meet__col_art_grid.p_id_14 .circle.develop .circle__dropdown::after {
  top: auto;
  right: 17%;
  bottom: 99%;
  left: auto;
  clip-path: polygon(50% 0, 100% 100%, 0 100%);
}

::ng-deep.team_meet {
  padding-block: 29px;
}
::ng-deep.team_meet--pd {
  padding-left: 3%;
  padding-right: 7%;
}
::ng-deep.team_meet > *:not(:last-child) {
  margin-bottom: 42px;
}
::ng-deep.team_meet__block {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
}
@media only screen and (max-width: 1199px) {
  ::ng-deep.team_meet__block {
    grid-template-columns: 1fr;
    grid-row-gap: 30px;
  }
}
::ng-deep.team_meet__col {
  padding: 49px 35px;
}
@media only screen and (max-width: 767px) {
  ::ng-deep.team_meet__col {
    padding: 15px;
  }
}
::ng-deep.team_meet__col > :not(:last-child) {
  margin-bottom: 22px;
}
::ng-deep.team_meet__col--left {
  border-radius: 4px 0px 0px 4px;
  background-color: #f1f1f2;
}
@media only screen and (max-width: 767px) {
  ::ng-deep.team_meet__col--left {
    border-radius: 4px;
  }
}
::ng-deep.team_meet__col--right {
  border-radius: 0px 4px 4px 0px;
  border: 1px solid #e7eaec;
}
@media only screen and (max-width: 767px) {
  ::ng-deep.team_meet__col--right {
    border-radius: 4px;
  }
}
::ng-deep.team_meet__col--right .team_meet__col_art {
  border: 1px solid #e7eaec;
}
::ng-deep.team_meet__col_header {
  display: flex;
  flex-wrap: wrap;
  grid-gap: 20px;
}
::ng-deep.team_meet__col_header_left {
  flex: 1;
}
::ng-deep.team_meet__col_header_left h2 {
  font-size: 24px;
  font-weight: 700;
  color: #676a6c;
}
::ng-deep.team_meet__col_header_left h2 span {
  display: block;
  font-size: 16px;
  line-height: 1.5;
}
::ng-deep.team_meet__col_header_right {
  width: 125px;
}
::ng-deep.team_meet__col_desc p,
::ng-deep.team_meet__col_desc li {
  color: #5c5d60;
  font-size: 14px;
  font-weight: 600;
  line-height: 157%;
}
::ng-deep.team_meet__col_desc p a,
::ng-deep.team_meet__col_desc li a {
  text-decoration: underline;
}
::ng-deep.team_meet__col_desc p button,
::ng-deep.team_meet__col_desc li button {
  background-color: transparent;
  border: 0;
  color: #337ab7;
  cursor: pointer;
}
::ng-deep.team_meet__col_art {
  border-radius: 4px;
  background-color: #fff;
}
::ng-deep.team_meet__col_art_header {
  border-bottom: 1px solid #e7eaec;
  padding: 10px 22px;
  color: #676a6c;
  font-size: 14px;
  font-weight: 700;
}
::ng-deep.team_meet__col_art_body {
  padding: clamp(20px, 6vw, 90px) 16px;
  text-align: center;
}
::ng-deep.team_meet__col_art_body img {
  max-width: 715px;
  width: 100%;
  display: block;
  margin-inline: auto;
}
::ng-deep.team_meet__col_art_body_wrapper {
  max-width: 715px;
  width: 100%;
  margin-inline: auto;
}
::ng-deep.team_meet__col_art_body_inner {
  margin-top: clamp(140px, 11vw, 150px);
  position: relative;
  padding-bottom: 28%;
}
::ng-deep.team_meet__col_art_grid {
  --lineHeight: 16%;
  --line_top_to_bottom: rotate(30deg);
  --line_bottom_to_top: rotate(-30deg);
  display: grid;
  grid-template-columns: repeat(4, 12%);
  justify-content: space-between;
  grid-gap: 20px;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
}
::ng-deep.team_meet__col_art_grid.p_id_7 .clarify {
  background-color: rgb(0, 173, 208);
  align-self: start;
}
::ng-deep.team_meet__col_art_grid.p_id_7 .clarify::before {
  transform: var(--line_top_to_bottom);
}
::ng-deep.team_meet__col_art_grid.p_id_7 .clarify .circle__dropdown {
  background-color: rgb(0, 173, 208);
  display: block;
}
::ng-deep.team_meet__col_art_grid.p_id_7 .develop::before {
  transform: var(--line_bottom_to_top);
}
::ng-deep.team_meet__col_art_grid.p_id_7 .implement {
  background-color: rgb(245, 67, 89);
  align-self: start;
}
::ng-deep.team_meet__col_art_grid.p_id_7 .implement .circle__dropdown {
  background-color: rgb(245, 67, 89);
  display: block;
}
::ng-deep.team_meet__col_art_grid.p_id_6 .clarify {
  background-color: rgb(0, 173, 208);
  align-self: start;
}
::ng-deep.team_meet__col_art_grid.p_id_6 .clarify::before {
  transform: var(--line_top_to_bottom);
}
::ng-deep.team_meet__col_art_grid.p_id_6 .clarify .circle__dropdown {
  display: block;
}
::ng-deep.team_meet__col_art_grid.p_id_6 .ideate::before {
  transform: var(--line_bottom_to_top);
}
::ng-deep.team_meet__col_art_grid.p_id_6 .develop {
  background-color: rgb(105, 190, 40);
  align-self: start;
}
::ng-deep.team_meet__col_art_grid.p_id_6 .develop::before {
  transform: var(--line_top_to_bottom);
}
::ng-deep.team_meet__col_art_grid.p_id_6 .develop .circle__dropdown {
  display: block;
}
::ng-deep.team_meet__col_art_grid.p_id_1 .clarify {
  background-color: rgb(0, 173, 208);
  align-self: start;
}
::ng-deep.team_meet__col_art_grid.p_id_1 .clarify::before {
  transform: var(--line_top_to_bottom);
}
::ng-deep.team_meet__col_art_grid.p_id_1 .clarify .circle__dropdown {
  display: block;
}
::ng-deep.team_meet__col_art_grid.p_id_3 .ideate::before {
  transform: var(--line_bottom_to_top);
}
::ng-deep.team_meet__col_art_grid.p_id_3 .develop {
  background-color: rgb(105, 190, 40);
  align-self: start;
}
::ng-deep.team_meet__col_art_grid.p_id_3 .develop::before {
  transform: var(--line_top_to_bottom);
}
::ng-deep.team_meet__col_art_grid.p_id_3 .develop .circle__dropdown {
  display: block;
}
::ng-deep.team_meet__col_art_grid.p_id_9 .clarify::before {
  transform: var(--line_bottom_to_top);
}
::ng-deep.team_meet__col_art_grid.p_id_9 .ideate {
  background-color: rgb(255, 121, 0);
  align-self: start;
}
::ng-deep.team_meet__col_art_grid.p_id_9 .ideate::before {
  transform: var(--line_top_to_bottom);
}
::ng-deep.team_meet__col_art_grid.p_id_9 .ideate .circle__dropdown {
  display: block;
}
::ng-deep.team_meet__col_art_grid.p_id_9 .develop::before {
  transform: var(--line_bottom_to_top);
}
::ng-deep.team_meet__col_art_grid.p_id_9 .implement {
  background-color: rgb(245, 67, 89);
  align-self: start;
}
::ng-deep.team_meet__col_art_grid.p_id_9 .implement .circle__dropdown {
  display: block;
}
::ng-deep.team_meet__col_art_grid.p_id_5 .clarify {
  background-color: rgb(0, 173, 208);
  align-self: start;
}
::ng-deep.team_meet__col_art_grid.p_id_5 .clarify .circle__dropdown {
  display: block;
}
::ng-deep.team_meet__col_art_grid.p_id_5 .ideate {
  background-color: rgb(255, 121, 0);
  align-self: start;
}
::ng-deep.team_meet__col_art_grid.p_id_5 .ideate .circle__dropdown {
  display: block;
}
::ng-deep.team_meet__col_art_grid.p_id_5 .ideate::before {
  transform: var(--line_top_to_bottom);
}
::ng-deep.team_meet__col_art_grid.p_id_10 .ideate::before {
  transform: var(--line_bottom_to_top);
}
::ng-deep.team_meet__col_art_grid.p_id_10 .develop {
  background-color: rgb(105, 190, 40);
  align-self: start;
}
::ng-deep.team_meet__col_art_grid.p_id_10 .develop .circle__dropdown {
  display: block;
}
::ng-deep.team_meet__col_art_grid.p_id_10 .implement {
  background-color: rgb(245, 67, 89);
  align-self: start;
}
::ng-deep.team_meet__col_art_grid.p_id_10 .implement .circle__dropdown {
  display: block;
}
::ng-deep.team_meet__col_art_grid.p_id_11 .clarify {
  background-color: rgb(0, 173, 208);
  align-self: start;
}
::ng-deep.team_meet__col_art_grid.p_id_11 .clarify .circle__dropdown {
  display: block;
}
::ng-deep.team_meet__col_art_grid.p_id_11 .ideate {
  background-color: rgb(255, 121, 0);
  align-self: start;
}
::ng-deep.team_meet__col_art_grid.p_id_11 .ideate .circle__dropdown {
  display: block;
}
::ng-deep.team_meet__col_art_grid.p_id_11 .develop {
  background-color: rgb(105, 190, 40);
  align-self: start;
}
::ng-deep.team_meet__col_art_grid.p_id_11 .develop .circle__dropdown {
  display: block;
}
::ng-deep.team_meet__col_art_grid.p_id_11 .develop::before {
  transform: var(--line_top_to_bottom);
}
::ng-deep.team_meet__col_art_grid.p_id_12 .clarify {
  background-color: rgb(0, 173, 208);
  align-self: start;
}
::ng-deep.team_meet__col_art_grid.p_id_12 .clarify .circle__dropdown {
  display: block;
}
::ng-deep.team_meet__col_art_grid.p_id_12 .ideate {
  background-color: rgb(255, 121, 0);
  align-self: start;
}
::ng-deep.team_meet__col_art_grid.p_id_12 .ideate .circle__dropdown {
  display: block;
}
::ng-deep.team_meet__col_art_grid.p_id_12 .ideate::before {
  transform: var(--line_top_to_bottom);
}
::ng-deep.team_meet__col_art_grid.p_id_12 .develop::before {
  transform: var(--line_bottom_to_top);
}
::ng-deep.team_meet__col_art_grid.p_id_12 .implement {
  background-color: rgb(245, 67, 89);
  align-self: start;
}
::ng-deep.team_meet__col_art_grid.p_id_12 .implement .circle__dropdown {
  display: block;
}
::ng-deep.team_meet__col_art_grid.p_id_2 .clarify::before {
  transform: var(--line_bottom_to_top);
}
::ng-deep.team_meet__col_art_grid.p_id_2 .ideate {
  background-color: rgb(255, 121, 0);
  align-self: start;
}
::ng-deep.team_meet__col_art_grid.p_id_2 .ideate .circle__dropdown {
  display: block;
}
::ng-deep.team_meet__col_art_grid.p_id_2 .ideate::before {
  transform: var(--line_top_to_bottom);
}
::ng-deep.team_meet__col_art_grid.p_id_4 .develop::before {
  transform: var(--line_bottom_to_top);
}
::ng-deep.team_meet__col_art_grid.p_id_4 .implement {
  background-color: rgb(245, 67, 89);
  align-self: start;
}
::ng-deep.team_meet__col_art_grid.p_id_4 .implement .circle__dropdown {
  display: block;
}
::ng-deep.team_meet__col_art_grid.p_id_14 .circle_dropdown_integrator {
  display: block;
}
::ng-deep.team_meet__col_art_grid.p_id_14 .circle {
  align-self: start;
}
::ng-deep.team_meet__col_art_grid.p_id_13 .clarify::before {
  transform: var(--line_bottom_to_top);
}
::ng-deep.team_meet__col_art_grid.p_id_13 .ideate {
  background-color: rgb(255, 121, 0);
  align-self: start;
}
::ng-deep.team_meet__col_art_grid.p_id_13 .ideate .circle__dropdown {
  display: block;
}
::ng-deep.team_meet__col_art_grid.p_id_13 .develop {
  background-color: rgb(105, 190, 40);
  align-self: start;
}
::ng-deep.team_meet__col_art_grid.p_id_13 .develop .circle__dropdown {
  display: block;
}
::ng-deep.team_meet__col_art_grid.p_id_13 .implement {
  background-color: rgb(245, 67, 89);
  align-self: start;
}
::ng-deep.team_meet__col_art_grid.p_id_13 .implement .circle__dropdown {
  display: block;
}
::ng-deep.team_meet__col_art_grid.p_id_15 .clarify {
  background-color: rgb(0, 173, 208);
  align-self: start;
}
::ng-deep.team_meet__col_art_grid.p_id_15 .clarify::before {
  transform: var(--line_top_to_bottom);
}
::ng-deep.team_meet__col_art_grid.p_id_15 .clarify .circle__dropdown {
  display: block;
}
::ng-deep.team_meet__col_art_grid.p_id_15 .ideate::before {
  transform: var(--line_bottom_to_top);
}
::ng-deep.team_meet__col_art_grid.p_id_15 .develop {
  background-color: rgb(105, 190, 40);
  align-self: start;
}
::ng-deep.team_meet__col_art_grid.p_id_15 .develop .circle__dropdown {
  display: block;
}
::ng-deep.team_meet__col_art_grid.p_id_15 .implement {
  background-color: rgb(245, 67, 89);
  align-self: start;
}
::ng-deep.team_meet__col_art_grid.p_id_15 .implement .circle__dropdown {
  display: block;
}
::ng-deep.team_meet__col_art_grid.p_id_8 .clarify::before {
  transform: var(--line_bottom_to_top);
}
::ng-deep.team_meet__col_art_grid.p_id_8 .ideate {
  background-color: rgb(255, 121, 0);
  align-self: start;
}
::ng-deep.team_meet__col_art_grid.p_id_8 .ideate .circle__dropdown {
  display: block;
}
::ng-deep.team_meet__col_art_grid.p_id_8 .develop {
  background-color: rgb(105, 190, 40);
  align-self: start;
}
::ng-deep.team_meet__col_art_grid.p_id_8 .develop::before {
  transform: var(--line_top_to_bottom);
}
::ng-deep.team_meet__col_art_grid.p_id_8 .develop .circle__dropdown {
  display: block;
}
::ng-deep.team_meet__col_art .circle {
  width: 100%;
  aspect-ratio: 1;
  background: #f1f1f2;
  border-radius: 50%;
  align-self: end;
  position: relative;
}
::ng-deep.team_meet__col_art .circle:not(:last-child)::before {
  content: "";
  position: absolute;
  top: calc(50% - var(--lineHeight) / 2);
  height: var(--lineHeight);
  margin-block: auto;
  width: 235%;
  background: #f1f1f2;
  z-index: -1;
  transform-origin: left;
}
::ng-deep.team_meet__col_art .circle.clarify .circle__dropdown {
  background-color: rgb(0, 173, 208);
}
::ng-deep.team_meet__col_art .circle.ideate .circle__dropdown {
  background-color: rgb(255, 121, 0);
}
::ng-deep.team_meet__col_art .circle.develop .circle__dropdown {
  background-color: rgb(105, 190, 40);
}
::ng-deep.team_meet__col_art .circle.implement .circle__dropdown {
  background-color: rgb(245, 67, 89);
}
::ng-deep.team_meet__col_art .circle__dropdown {
  position: absolute;
  bottom: calc(100% + 10px);
  padding: 7px;
  border-radius: 5px;
  text-align: left;
  background: #f1f1f2;
  width: 230%;
  display: none;
}
::ng-deep.team_meet__col_art .circle__dropdown::after {
  content: "";
  position: absolute;
  top: 99%;
  left: 15%;
  width: 20px;
  height: 8px;
  background-color: inherit;
  clip-path: polygon(0 0, 100% 0, 50% 100%);
}
::ng-deep.team_meet__col_art .circle__dropdown > *:first-child {
  margin-top: 0;
}
::ng-deep.team_meet__col_art .circle__dropdown > *:last-child {
  margin-bottom: 0;
}
::ng-deep.team_meet__col_art .circle__dropdown ul,
::ng-deep.team_meet__col_art .circle__dropdown ol {
  padding-left: 0;
}
::ng-deep.team_meet__col_art .circle__dropdown li {
  position: relative;
  list-style: none;
  padding-left: 8px;
}
::ng-deep.team_meet__col_art .circle__dropdown li::before {
  content: "";
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 0;
  width: 4px;
  aspect-ratio: 1;
  background-color: #fff;
  border-radius: 50%;
}
::ng-deep.team_meet__col_art .circle__dropdown p,
::ng-deep.team_meet__col_art .circle__dropdown li {
  font-size: clamp(8px, 1vw, 14px);
  line-height: 1.3;
  font-weight: 600;
  color: #fff;
}
::ng-deep.team_meet__col_art .circle__dropdown p:not(:last-child),
::ng-deep.team_meet__col_art .circle__dropdown li:not(:last-child) {
  margin-bottom: 5px;
}
::ng-deep.team_meet__col_art .circle_dropdown_integrator {
  position: absolute;
  bottom: calc(100% + 20px);
  left: 50%;
  transform: translateX(-50%);
  padding: 7px;
  border-radius: 5px;
  text-align: left;
  background: #676a6c;
  width: 27.597%;
  display: none;
}
::ng-deep.team_meet__col_art .circle_dropdown_integrator::after {
  content: "";
  position: absolute;
  top: 99%;
  left: 50%;
  transform: translateX(-50%);
  width: 20px;
  height: 8px;
  background-color: inherit;
  clip-path: polygon(0 0, 100% 0, 50% 100%);
}
::ng-deep.team_meet__col_art .circle_dropdown_integrator > *:first-child {
  margin-top: 0;
}
::ng-deep.team_meet__col_art .circle_dropdown_integrator > *:last-child {
  margin-bottom: 0;
}
::ng-deep.team_meet__col_art .circle_dropdown_integrator ul,
::ng-deep.team_meet__col_art .circle_dropdown_integrator ol {
  padding-left: 0;
}
::ng-deep.team_meet__col_art .circle_dropdown_integrator li {
  position: relative;
  list-style: none;
  padding-left: 8px;
}
::ng-deep.team_meet__col_art .circle_dropdown_integrator li::before {
  content: "";
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 0;
  width: 4px;
  aspect-ratio: 1;
  background-color: #fff;
  border-radius: 50%;
}
::ng-deep.team_meet__col_art .circle_dropdown_integrator p,
::ng-deep.team_meet__col_art .circle_dropdown_integrator li {
  font-size: clamp(8px, 1vw, 14px);
  line-height: 1.3;
  font-weight: 600;
  color: #fff;
}
::ng-deep.team_meet__col_art .circle_dropdown_integrator p:not(:last-child),
::ng-deep.team_meet__col_art .circle_dropdown_integrator li:not(:last-child) {
  margin-bottom: 5px;
}
::ng-deep.team_meet__challenges_header {
  border-radius: 4px 4px 0px 0px;
  background-color: #f1f1f2;
  padding: 9px 22px;
}
::ng-deep.team_meet__challenges_header > :last-child {
  margin-bottom: 0;
}
::ng-deep.team_meet__challenges_header h2 {
  font-size: 16px;
  font-weight: 700;
  color: #676a6c;
}
::ng-deep.team_meet__challenges_grid {
  --col_per_row: 4;
  display: grid;
  grid-template-columns: repeat(var(--col_per_row), 1fr);
  grid-gap: 18px;
  padding: 25px 41px;
  border: 1px solid #e7eaec;
  border-top: 0;
  border-radius: 0 0 4px 4px;
}
@media only screen and (max-width: 1199px) {
  ::ng-deep.team_meet__challenges_grid {
    --col_per_row: 2;
  }
}
@media only screen and (max-width: 767px) {
  ::ng-deep.team_meet__challenges_grid {
    --col_per_row: 1;
    padding: 20px;
  }
}
::ng-deep.team_meet__challenges_col {
  border-radius: 4px;
  border: 1px solid #e7eaec;
  background-color: #fff;
  padding: 27px 20px 30px;
  text-align: center;
}
::ng-deep.team_meet__challenges_col > :last-child {
  margin-bottom: 0;
}
::ng-deep.team_meet__challenges_col h3 {
  font-size: 16px;
  text-transform: uppercase;
  font-weight: 700;
}
::ng-deep.team_meet__challenges_col h3:not(:last-child) {
  margin-bottom: 18px;
}
::ng-deep.team_meet__challenges_col.clarify .team_meet__challenges_profile div.high {
  background-color: rgb(0, 173, 208);
}
::ng-deep.team_meet__challenges_col.ideate .team_meet__challenges_profile div.high {
  background-color: rgb(255, 121, 0);
}
::ng-deep.team_meet__challenges_col.develop .team_meet__challenges_profile div.high {
  background-color: rgb(105, 190, 40);
}
::ng-deep.team_meet__challenges_col.implement .team_meet__challenges_profile div.high {
  background-color: rgb(245, 67, 89);
}
::ng-deep.team_meet__challenges_profile {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 10px;
  width: 111px;
  margin-inline: auto;
}
::ng-deep.team_meet__challenges_profile > div {
  aspect-ratio: 1;
  border-radius: 50%;
  background-color: #d9d9d9;
}
::ng-deep.team_meet__challenges_integrator {
  border: 1px solid #e7eaec;
  border-radius: 0 0 4px 4px;
}
::ng-deep.team_meet__challenges_integrator_inner {
  padding: 25px 41px;
}
::ng-deep.team_meet__challenges_integrator_inner > :not(:last-child) {
  margin-bottom: 27px;
  padding-bottom: 27px;
  border-bottom: 1px solid #e7eaec;
}
::ng-deep.team_meet__challenges_integrator_grid {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  width: min(1400px, 100%);
  margin-inline: auto;
  grid-row-gap: 10px;
}
@media only screen and (max-width: 991px) {
  ::ng-deep.team_meet__challenges_integrator_grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 30px;
  }
}
@media only screen and (max-width: 767px) {
  ::ng-deep.team_meet__challenges_integrator_grid {
    grid-template-columns: repeat(1, 1fr);
  }
}
::ng-deep.team_meet__challenges_integrator_col {
  width: 111px;
  text-align: center;
}
@media only screen and (max-width: 991px) {
  ::ng-deep.team_meet__challenges_integrator_col {
    width: 100%;
  }
}
::ng-deep.team_meet__challenges_integrator_col h3 {
  font-size: 16px;
  text-transform: uppercase;
  font-weight: 700;
}
::ng-deep.team_meet__challenges_integrator_col h3:not(:last-child) {
  margin-bottom: 16px;
}
::ng-deep.team_meet__challenges_integrator_profile {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 10px;
  width: 111px;
  margin-inline: auto;
}
::ng-deep.team_meet__challenges_integrator_profile > div {
  aspect-ratio: 1;
  background-color: #676a6c;
  border-radius: 50%;
}
::ng-deep.team_meet__challenges_integrator_profile.clarify div.high {
  background-color: rgb(0, 173, 208);
}
::ng-deep.team_meet__challenges_integrator_profile.ideate div.high {
  background-color: rgb(255, 121, 0);
}
::ng-deep.team_meet__challenges_integrator_profile.develop div.high {
  background-color: rgb(105, 190, 40);
}
::ng-deep.team_meet__challenges_integrator_profile.implement div.high {
  background-color: rgb(245, 67, 89);
}
::ng-deep.team_meet__challenges_integrator_info {
  text-align: center;
  width: min(647px, 100%);
  margin-inline: auto;
}
::ng-deep.team_meet__challenges_integrator_info p {
  font-size: 14px;
  font-weight: 600;
  color: #676a6c;
}
::ng-deep.team_meet__agreement_header {
  border-radius: 4px 4px 0px 0px;
  background-color: #f1f1f2;
  padding: 9px 22px;
}
::ng-deep.team_meet__agreement_header h3 {
  font-size: 16px;
  font-weight: 700;
  color: #676a6c;
}
::ng-deep.team_meet__agreement_body {
  border-radius: 0px 0px 4px 4px;
  border: 1px solid #e7eaec;
}
::ng-deep.team_meet__agreement_tab_nav ul {
  padding: 0;
  margin: 0;
  display: flex;
  flex-wrap: wrap;
  border-bottom: 1px solid #e7eaec;
}
::ng-deep.team_meet__agreement_tab_nav ul li {
  list-style: none;
}
@media only screen and (max-width: 767px) {
  ::ng-deep.team_meet__agreement_tab_nav ul li {
    width: 100%;
  }
}
@media only screen and (min-width: 768px) {
  ::ng-deep.team_meet__agreement_tab_nav ul li:not(:last-child) {
    border-right: 1px solid #e7eaec;
  }
}
::ng-deep.team_meet__agreement_tab_nav button {
  color: #676a6c;
  font-size: 12px;
  font-weight: 600;
  opacity: 0.9;
  min-width: 219px;
  border: 0;
  background-color: transparent;
  padding: 9px 23px;
  position: relative;
  border-radius: 0;
  cursor: pointer;
}
@media only screen and (max-width: 767px) {
  ::ng-deep.team_meet__agreement_tab_nav button {
    width: 100%;
  }
}
::ng-deep.team_meet__agreement_tab_nav button.active {
  font-weight: 700;
}
::ng-deep.team_meet__agreement_tab_nav button.active::after {
  opacity: 1;
}
::ng-deep.team_meet__agreement_tab_nav button::after {
  content: "";
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgb(105, 190, 40);
  height: 2px;
  opacity: 0;
}
::ng-deep.team_meet__agreement_tab_content {
  padding: 24px 20px;
}
::ng-deep.team_meet__agreement_tab_content form > *:not(:last-child) {
  margin-bottom: 16px;
}
::ng-deep.team_meet__agreement_tab_content input,
::ng-deep.team_meet__agreement_tab_content textarea {
  border-radius: 4px;
  border: 1px solid #e7eaec;
  height: 122px;
  resize: none;
  padding: 11px 15px;
  width: 100%;
}
::ng-deep.team_meet__agreement_tab_content input:focus,
::ng-deep.team_meet__agreement_tab_content textarea:focus {
  outline: none;
}
::ng-deep.team_meet__agreement_tab_content input {
  height: 34px;
}
::ng-deep.team_meet__agreement_tab_content input[type=submit] {
  border-radius: 4px;
  background: rgb(105, 190, 40);
  font-size: 14px;
  font-weight: 600;
  text-align: center;
  color: #fff;
  border: 0;
  width: auto;
  padding: 7px 27px;
  cursor: pointer;
  transition: 0.3s;
}
::ng-deep.team_meet__agreement_tab_content input[type=submit]:hover {
  background-color: #676a6c;
}

::ng-deep._no_profile_ {
  height: 18px;
  width: 18px;
  border-radius: 50%;
  color: #ff485c;
  font-size: 8px;
  background: #f1f1f2;
}
::ng-deep._no_profile_._bgw_ {
  background-color: #fff;
}

::ng-deep.missing-profiles {
  background-color: #d9d9d9;
}
::ng-deep.missing-profiles h5,
::ng-deep.missing-profiles i {
  color: #676a6c;
}

.advice_sidebar {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  overflow-y: auto;
  width: calc(100% - 70px);
  max-width: 240px;
  background-color: #fff;
  z-index: 999;
  box-shadow: 0px 4px 24px 0px rgba(0, 0, 0, 0.05);
}
.advice_sidebar__wrapper {
  padding: 10px;
}
.advice_sidebar__header {
  background-color: #f1f1f2;
  padding: 10px 35px 10px 15px;
  border-radius: 4px;
  font-size: 16px;
  font-weight: 700;
  color: #676a6c;
  position: relative;
}
.advice_sidebar__header:not(:last-child) {
  margin-bottom: 15px;
}
.advice_sidebar__list {
  padding-inline: 15px;
}
.advice_sidebar__list > :not(:last-child) {
  margin-bottom: 15px;
}
.advice_sidebar__list h5 {
  font-weight: 700;
  font-size: 14px;
  margin-top: 0;
}
.advice_sidebar__list h5:not(:last-child) {
  margin-bottom: 5px;
}
.advice_sidebar__list ul {
  margin: 0;
  padding: 0;
  list-style: none;
}
.advice_sidebar__list p,
.advice_sidebar__list li {
  font-weight: 600;
  font-size: 12px;
}
.advice_sidebar__list p:not(:last-child),
.advice_sidebar__list li:not(:last-child) {
  margin-bottom: 10px;
}
.advice_sidebar__close {
  --line_thickness: 2px;
  --line_length: 70%;
  position: absolute;
  top: 0;
  bottom: 0;
  right: 10px;
  margin-block: auto;
  width: 18px;
  aspect-ratio: 1;
  background-color: transparent;
  border: 0;
  padding: 0;
  cursor: pointer;
}
.advice_sidebar__close:hover > div::before, .advice_sidebar__close:hover > div::after {
  background-color: rgb(105, 190, 40);
}
.advice_sidebar__close div {
  position: absolute;
  inset: 0;
  transform: rotate(45deg);
}
.advice_sidebar__close div::before, .advice_sidebar__close div::after {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: #676a6c;
  transition: all ease 0.3s;
}
.advice_sidebar__close div::before {
  width: var(--line_thickness);
  height: var(--line_length);
}
.advice_sidebar__close div::after {
  width: var(--line_length);
  height: var(--line_thickness);
}

::ng-deep.fa-chevron-up {
  transition: all 0.3s ease;
}
::ng-deep.fa-chevron-up.active {
  transform: rotate(180deg);
}

.txt_trnsfrm {
  text-transform: capitalize;
}

.counter {
  display: block;
  text-align: left;
  font-weight: normal;
  padding-top: 2px;
  font-size: 10px;
}

.gap10 {
  gap: 10px;
}

.orgs_team {
  padding-block: 10px 48px;
}
.orgs_team--pdt0 {
  padding-top: 0;
}
.orgs_team__view {
  gap: 10px;
}
.orgs_team__view > div {
  background-color: #fff;
  color: #676a6c;
  border: 1px solid #e7eaec;
  padding-inline: 6px;
  border-radius: 4px;
}
.orgs_team__view > div.active {
  background-color: #676a6c;
  color: #fff;
  border-color: #676a6c;
}
.orgs_team__view .f-btn {
  display: flex;
  align-items: center;
  padding-block: 3px;
  border-radius: 4px;
  gap: 8px;
  font-weight: 500;
  padding-inline: 10px;
}
.orgs_team__invite select {
  width: 100%;
  padding-block: 7px;
  border: 1px solid #e7eaec;
  border-radius: 5px;
}
.orgs_team__tab {
  border-bottom: 1px solid #e7eaec;
}
.orgs_team__tab--txt {
  font-size: 16px;
  font-weight: 700;
}
.orgs_team__tab ul {
  padding: 0;
  margin: 0;
}
.orgs_team__tab li {
  list-style: none;
  position: relative;
}
.orgs_team__tab li:not(:last-child) {
  margin-right: 16px;
  padding-right: 18px;
}
.orgs_team__tab li:not(:last-child)::after {
  content: "";
  position: absolute;
  top: 0;
  bottom: -1px;
  right: 0;
  margin-block: auto;
  width: 1px;
  height: 18px;
  background-color: #e7eaec;
}
.orgs_team__tab li.active button {
  font-weight: 700;
}
.orgs_team__tab li.active button::after {
  display: block;
}
.orgs_team__tab li button {
  font-size: 16px;
  font-weight: 500;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  border: 0;
  padding: 16px 0;
  background-color: transparent;
  position: relative;
  color: #676a6c;
  transition: all ease 0.3s;
}
.orgs_team__tab li button:hover {
  color: #9a9d9f;
}
.orgs_team__tab li button::after {
  content: "";
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  height: 2px;
  background-color: #74bf24;
  display: none;
}
.orgs_team__branch {
  background-color: #f1f1f2;
  border: 1px solid #e7eaec;
  border-radius: 4px;
  padding: 14px 18px;
}
@media only screen and (max-width: 767px) {
  .orgs_team__branch {
    padding: 10px;
  }
}
.orgs_team__branch_srch {
  background-color: #fff;
  padding: 6px 7px;
  border-radius: 4px;
  position: relative;
}
.orgs_team__branch_srch > div {
  gap: 10px;
}
.orgs_team__branch_srch_inp {
  border: 1px solid #e7eaec;
  border-radius: 4px;
  max-width: 200px;
  flex-grow: 1;
  padding: 8px;
}
@media only screen and (max-width: 991px) {
  .orgs_team__branch_srch_inp {
    width: 100%;
    max-width: none;
  }
}
.orgs_team__branch_srch_inp + div {
  flex-grow: 1;
}
.orgs_team__branch_srch_inp + div input {
  width: 100%;
  height: 100%;
  padding: 8px;
  font-weight: 600;
  border: 1px solid #e7eaec;
  outline: 0;
}
.orgs_team__branch_srch_inp h3 {
  margin: 0;
}
.orgs_team__branch_srch_inp select {
  border: 0;
  font-weight: 600;
  color: #676a6c;
}
.orgs_team__branch_srch_sort {
  background-color: transparent;
  border-right: 1px solid;
  padding: 4px 6px;
  margin-right: 4px;
}
.orgs_team__branch_srch_sort--nobdr {
  border-right: 0;
}
.orgs_team__branch_srch_sort--pl0 {
  padding-left: 0;
}
.orgs_team__branch_srch_sort:hover span {
  position: absolute;
  display: inline-block;
  top: -33px;
  left: -5px;
  padding: 1px 6px 2px;
  background: #676a6c;
  color: #fff;
  border-radius: 4px;
  min-width: 42px;
  text-align: center;
}
.orgs_team__branch_srch_sort:hover span::after {
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-top: 10px solid #676a6c;
  margin: 2rem;
  content: "";
  position: absolute;
  left: -22px;
  top: -11px;
}
.orgs_team__branch_srch_sort span {
  display: none;
}
.orgs_team__branch_srch_sort img {
  max-width: 15px;
  min-height: 15px;
}
.orgs_team__branch_srch button {
  border: 0;
  border-radius: 50%;
}
.orgs_team__branch_hdr {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  grid-gap: 10px;
  padding: 10px 20px 10px 0;
  position: relative;
}
.orgs_team__branch_hdr:not(:last-child) {
  margin-bottom: 15px;
}
.orgs_team__branch_hdr--mpb0 {
  margin-bottom: 0px !important;
  padding-bottom: 0 !important;
}
.orgs_team__branch_hdr_title {
  font-size: 14px;
  line-height: 1.3;
  font-weight: 700;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  display: flex;
  flex-wrap: wrap;
  grid-gap: 4px;
  margin-right: auto;
}
@media only screen and (max-width: 767px) {
  .orgs_team__branch_hdr_title {
    width: 100%;
  }
}
.orgs_team__branch_hdr_title i {
  font-size: 20px;
}
.orgs_team__branch_hdr_title .fmt {
  font-size: 12px;
  font-weight: 600;
}
.orgs_team__branch_hdr_search, .orgs_team__branch_hdr_sorting, .orgs_team__branch_hdr_filter {
  position: relative;
}
.orgs_team__branch_hdr_search:hover > button, .orgs_team__branch_hdr_sorting:hover > button, .orgs_team__branch_hdr_filter:hover > button {
  border-color: #e7eaec;
  background-color: transparent;
}
.orgs_team__branch_hdr_search > button, .orgs_team__branch_hdr_sorting > button, .orgs_team__branch_hdr_filter > button {
  background-color: #fff;
  border: 1px solid #fff;
  border-radius: 4px;
  padding: 4px 10px;
  font-size: 12px;
  font-weight: 600;
  color: #676a6c;
  transition: 0.3s;
}
.orgs_team__branch_hdr_search > button.no_profile_link, .orgs_team__branch_hdr_sorting > button.no_profile_link, .orgs_team__branch_hdr_filter > button.no_profile_link {
  background-color: transparent;
  border: 0;
  padding: 0;
  font-size: 14px;
}
.orgs_team__branch_hdr_search .orgs_team__branch_hdr_search_body {
  display: block;
}
.orgs_team__branch_hdr_sorting:hover > .orgs_team__branch_hdr_sorting_body, .orgs_team__branch_hdr_sorting:hover > .orgs_team__branch_hdr_filter_body, .orgs_team__branch_hdr_filter:hover > .orgs_team__branch_hdr_sorting_body, .orgs_team__branch_hdr_filter:hover > .orgs_team__branch_hdr_filter_body {
  display: block;
}
.orgs_team__branch_hdr_search_body, .orgs_team__branch_hdr_sorting_body, .orgs_team__branch_hdr_filter_body {
  position: absolute;
  top: 100%;
  right: -45px;
  padding-top: 26px;
  z-index: 100;
  display: none;
}
.orgs_team__branch_hdr_search_body ul, .orgs_team__branch_hdr_sorting_body ul, .orgs_team__branch_hdr_filter_body ul {
  width: 100%;
  background-color: #fff;
  list-style: none;
  margin: 0;
  padding: 0;
  box-shadow: 0px 3px 7px rgba(0, 0, 0, 0.17);
  white-space: nowrap;
  position: relative;
  border-radius: 4px;
  min-width: 152px;
}
.orgs_team__branch_hdr_search_body ul::before, .orgs_team__branch_hdr_sorting_body ul::before, .orgs_team__branch_hdr_filter_body ul::before {
  content: "";
  position: absolute;
  right: 59px;
  bottom: 99%;
  background-color: #fff;
  width: 25px;
  height: 12px;
  clip-path: polygon(0 100%, 50% 0, 100% 100%);
}
.orgs_team__branch_hdr_search_body li:not(:last-child), .orgs_team__branch_hdr_sorting_body li:not(:last-child), .orgs_team__branch_hdr_filter_body li:not(:last-child) {
  border-bottom: 1px solid #e7eaec;
}
.orgs_team__branch_hdr_search_body button, .orgs_team__branch_hdr_sorting_body button, .orgs_team__branch_hdr_filter_body button {
  border: 0;
  padding: 13px 17px;
  background-color: transparent;
  font-size: 12px;
  font-weight: 600;
  color: #676a6c;
  width: 100%;
  text-align: left;
  display: flex;
  align-items: center;
  grid-gap: 10px;
}
.orgs_team__branch_hdr_search_body button span, .orgs_team__branch_hdr_sorting_body button span, .orgs_team__branch_hdr_filter_body button span {
  width: 20px;
  height: 20px;
  background: #e7eaec;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  font-size: 10px;
  margin-left: auto;
}
.orgs_team__branch_hdr_search_body button:hover, .orgs_team__branch_hdr_sorting_body button:hover, .orgs_team__branch_hdr_filter_body button:hover {
  border-color: #e7eaec;
  background-color: transparent;
}
.orgs_team__branch_hdr_search_body:hover > .orgs_team__branch_hdr_search_body_body, .orgs_team__branch_hdr_search_body:hover > .orgs_team__branch_hdr_sorting_body_body, .orgs_team__branch_hdr_search_body:hover > .orgs_team__branch_hdr_filter_body_body, .orgs_team__branch_hdr_sorting_body:hover > .orgs_team__branch_hdr_search_body_body, .orgs_team__branch_hdr_sorting_body:hover > .orgs_team__branch_hdr_sorting_body_body, .orgs_team__branch_hdr_sorting_body:hover > .orgs_team__branch_hdr_filter_body_body, .orgs_team__branch_hdr_filter_body:hover > .orgs_team__branch_hdr_search_body_body, .orgs_team__branch_hdr_filter_body:hover > .orgs_team__branch_hdr_sorting_body_body, .orgs_team__branch_hdr_filter_body:hover > .orgs_team__branch_hdr_filter_body_body {
  display: block;
}
.orgs_team__branch_hdr_search_body, .orgs_team__branch_hdr_sorting_body, .orgs_team__branch_hdr_filter_body {
  position: absolute;
  top: 100%;
  right: -45px;
  padding-top: 26px;
  z-index: 100;
  display: none;
}
.orgs_team__branch_hdr_search_body ul, .orgs_team__branch_hdr_sorting_body ul, .orgs_team__branch_hdr_filter_body ul {
  width: 100%;
  background-color: #fff;
  list-style: none;
  margin: 0;
  padding: 0;
  box-shadow: 0px 3px 7px rgba(0, 0, 0, 0.17);
  white-space: nowrap;
  position: relative;
  border-radius: 4px;
  min-width: 152px;
}
.orgs_team__branch_hdr_search_body ul::before, .orgs_team__branch_hdr_sorting_body ul::before, .orgs_team__branch_hdr_filter_body ul::before {
  content: "";
  position: absolute;
  right: 59px;
  bottom: 99%;
  background-color: #fff;
  width: 25px;
  height: 12px;
  clip-path: polygon(0 100%, 50% 0, 100% 100%);
}
.orgs_team__branch_hdr_search_body li:not(:last-child), .orgs_team__branch_hdr_sorting_body li:not(:last-child), .orgs_team__branch_hdr_filter_body li:not(:last-child) {
  border-bottom: 1px solid #e7eaec;
}
.orgs_team__branch_hdr_search_body button,
.orgs_team__branch_hdr_search_body a, .orgs_team__branch_hdr_sorting_body button,
.orgs_team__branch_hdr_sorting_body a, .orgs_team__branch_hdr_filter_body button,
.orgs_team__branch_hdr_filter_body a {
  border: 0;
  padding: 13px 17px;
  background-color: transparent;
  font-size: 12px;
  font-weight: 600;
  color: #676a6c;
  width: 100%;
  text-align: left;
  display: flex;
  align-items: center;
  grid-gap: 10px;
}
.orgs_team__branch_hdr_search_body button span,
.orgs_team__branch_hdr_search_body a span, .orgs_team__branch_hdr_sorting_body button span,
.orgs_team__branch_hdr_sorting_body a span, .orgs_team__branch_hdr_filter_body button span,
.orgs_team__branch_hdr_filter_body a span {
  width: 20px;
  height: 20px;
  background: #e7eaec;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  font-size: 10px;
  margin-left: auto;
}
.orgs_team__branch_hdr_search_body button:hover,
.orgs_team__branch_hdr_search_body a:hover, .orgs_team__branch_hdr_sorting_body button:hover,
.orgs_team__branch_hdr_sorting_body a:hover, .orgs_team__branch_hdr_filter_body button:hover,
.orgs_team__branch_hdr_filter_body a:hover {
  color: rgb(105, 190, 40);
}
@media only screen and (max-width: 767px) {
  .orgs_team__branch_hdr_search_body {
    right: auto;
    left: 0;
  }
}
.orgs_team__branch_hdr_search_body_form {
  list-style: none;
  white-space: nowrap;
  position: relative;
  min-width: 300px;
}
@media only screen and (max-width: 1600px) {
  .orgs_team__branch_hdr_search_body_form {
    min-width: 200px;
  }
}
.orgs_team__branch_hdr_search_body_form::before {
  content: "";
  position: absolute;
  right: 49px;
  bottom: 99%;
  background-color: #fff;
  width: 25px;
  height: 12px;
  clip-path: polygon(0 100%, 50% 0, 100% 100%);
}
@media only screen and (max-width: 767px) {
  .orgs_team__branch_hdr_search_body_form::before {
    right: auto;
    left: 10px;
  }
}
.orgs_team__branch_hdr_search_body_form input {
  width: 100%;
  height: 45px;
  border: 0;
  outline: none;
  border-radius: 4px;
  background-color: #fff;
  color: rgba(103, 106, 108, 0.3);
  box-shadow: 0px 3px 7px rgba(0, 0, 0, 0.17);
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 12px;
  font-weight: 600;
  padding: 15px;
  padding-right: 60px;
}
.orgs_team__branch_hdr_search_body_clear_button {
  position: absolute;
  top: 5px;
  right: 0px;
  background-color: transparent !important;
  width: 26px !important;
  height: 26px;
  border-radius: 50%;
  padding: 0 !important;
}
.orgs_team__branch_hdr_search_body_clear_button i {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.orgs_team__branch_hdr_dropdown_2 {
  position: absolute;
  top: 29%;
  transform: translateY(-29%);
  right: 0;
}
.orgs_team__branch_hdr_dropdown_2 > button {
  border: 0;
  background-color: transparent;
  padding: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: 0.3s;
}
.orgs_team__branch_hdr_dropdown_2 > button:hover {
  color: rgb(105, 190, 40);
}
.orgs_team__branch_body > :not(:last-child) {
  margin-bottom: 15px;
}
.orgs_team__branch_list .f-d-none {
  display: none;
}
.orgs_team__branch_item {
  display: flex;
  align-items: center;
  grid-gap: 12px;
  background-color: #fff;
  padding: 15px 19px;
  border: 1px solid #e7eaec;
  border-top: 0;
  transition: all ease 0.3s;
}
.orgs_team__branch_item:hover {
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.05);
}
.orgs_team__branch_title {
  display: flex;
  align-items: center;
  grid-gap: 8px;
  margin-right: auto;
  width: 88%;
}
.orgs_team__branch_title--wd {
  width: 100%;
}
@media only screen and (max-width: 767px) {
  .orgs_team__branch_title {
    width: 100%;
    max-width: 150px;
  }
}
.orgs_team__branch_title_name {
  font-size: 14px;
  line-height: 1.3;
  font-weight: 600;
  color: #676a6c;
  text-transform: capitalize;
  gap: 8px;
}
.orgs_team__branch_title_name input[type=checkbox] {
  accent-color: #639935;
}
.orgs_team__branch_title_name.active {
  font-weight: 700;
}
@media only screen and (max-width: 767px) {
  .orgs_team__branch_title_name {
    width: 100%;
  }
}
.orgs_team__branch_title_study {
  background-color: #676a6c;
  padding: 1px 6px;
  border-radius: 5px;
  color: #fff;
  font-size: 12px;
  font-weight: 600;
}
.orgs_team__branch_title_utype {
  background-color: #f1f1f2;
  padding: 1px 6px;
  border-radius: 5px;
  color: #676a6c;
  font-size: 12px;
  font-weight: 600;
}
.orgs_team__branch_title_utype--bgw {
  background-color: #fff;
}
.orgs_team__branch_title_utype--mail {
  margin-left: auto;
}
.orgs_team__branch_title_utype--mail .full-mail {
  display: none;
}
.orgs_team__branch_title_utype--mail:hover .short-mail {
  display: none;
}
.orgs_team__branch_title_utype--mail:hover .full-mail {
  display: inline-block;
  transition: all 300ms ease;
}
.orgs_team__branch_count {
  font-size: 10px;
  font-weight: 600;
  color: #676a6c;
  background-color: #f1f1f2;
  border-radius: 2px;
  padding: 3px 7px;
  position: relative;
}
.orgs_team__branch_count ul {
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  color: #676a6c;
  background-color: #fff;
  padding: 6px;
  box-shadow: 0 0 18px rgba(0, 0, 0, 0.1);
  font-size: 13px;
  z-index: 1;
  display: none;
  min-width: 130px;
  padding-left: 20px;
  margin: 0;
}
.orgs_team__branch_count:hover > ul {
  display: block;
}
.orgs_team__branch_dropdown {
  position: relative;
}
.orgs_team__branch_dropdown:hover > .orgs_team__branch_dropdown:hover_button span {
  background-color: rgb(105, 190, 40);
}
.orgs_team__branch_dropdown:hover > .orgs_team__branch_dropdown_body {
  display: block;
}
.orgs_team__branch_dropdown > button {
  border: 0;
  padding: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  grid-gap: 2px;
  background-color: transparent;
  width: 20px;
  aspect-ratio: 1;
  border-radius: 50%;
}
.orgs_team__branch_dropdown > button span {
  display: block;
  width: 2px;
  aspect-ratio: 1;
  background-color: #676a6c;
  border-radius: 50%;
}
.orgs_team__branch_dropdown_body {
  position: absolute;
  top: 100%;
  right: -5px;
  padding-top: 12px;
  z-index: 100;
  display: none;
}
.orgs_team__branch_dropdown_body ul {
  width: 100%;
  background-color: #fff;
  list-style: none;
  margin: 0;
  padding: 0;
  box-shadow: 0px 1px 15px rgba(0, 0, 0, 0.17);
  white-space: nowrap;
  position: relative;
  min-width: 130px;
  border-radius: 4px;
}
.orgs_team__branch_dropdown_body ul::before {
  content: "";
  position: absolute;
  right: 7px;
  bottom: 100%;
  background-color: #fff;
  width: 16px;
  height: 9px;
  clip-path: polygon(0 100%, 50% 0, 100% 100%);
}
.orgs_team__branch_dropdown_body li {
  position: relative;
}
.orgs_team__branch_dropdown_body li:hover > .orgs_team__branch_dropdown_body_2 {
  display: block;
}
.orgs_team__branch_dropdown_body li:not(:last-child) {
  border-bottom: 1px solid #e7eaec;
}
.orgs_team__branch_dropdown_body li button,
.orgs_team__branch_dropdown_body li a {
  border: 0;
  padding: 13px 17px;
  background-color: transparent;
  font-size: 12px;
  font-weight: 600;
  color: #676a6c;
  width: 100%;
  text-align: left;
  display: block;
}
.orgs_team__branch_dropdown_body li button:hover,
.orgs_team__branch_dropdown_body li a:hover {
  color: rgb(105, 190, 40);
}
.orgs_team__branch_dropdown_body_2 {
  position: absolute;
  top: 0;
  right: 100%;
  padding-right: 12px;
  display: none;
}
.orgs_team__branch_dropdown_body_2 ul::before {
  clip-path: polygon(0 0, 100% 50%, 0 100%);
  left: 100%;
  top: 11px;
  width: 9px;
  height: 14px;
}
.orgs_team__branch_dropdown_body .disabled {
  cursor: not-allowed;
  opacity: 0.7;
}
.orgs_team__branch_load_more {
  padding: 0;
  background-color: transparent;
  border: 0;
  font-size: 14px;
  font-weight: 600;
  color: #676a6c;
  width: 100%;
  text-align: center;
}
.orgs_team__branch_load_more i {
  transition: 0.3s;
}
.orgs_team__branch_load_more:hover {
  color: rgb(105, 190, 40);
}
.orgs_team__branch_load_more:hover > i {
  transform: rotate(360deg);
}
.orgs_team__block_row {
  grid-row-gap: 30px;
}
.orgs_team__block_row .f-col-5 {
  width: 37%;
}
@media only screen and (max-width: 1600px) {
  .orgs_team__block_row .f-col-5 {
    width: 520px;
  }
}
@media only screen and (max-width: 1199px) {
  .orgs_team__block_row .f-col-5 {
    width: 45%;
  }
}
@media only screen and (max-width: 991px) {
  .orgs_team__block_row .f-col-5 {
    width: 100%;
    padding-left: 15px;
  }
}
.orgs_team__block_row .f-col-7 {
  width: 63%;
}
@media only screen and (max-width: 1600px) {
  .orgs_team__block_row .f-col-7 {
    width: calc(100% - 520px);
  }
}
@media only screen and (max-width: 1199px) {
  .orgs_team__block_row .f-col-7 {
    width: 55%;
  }
}
@media only screen and (max-width: 991px) {
  .orgs_team__block_row .f-col-7 {
    width: 100%;
  }
}
@media only screen and (max-width: 1199px) {
  .orgs_team__block_row > div {
    width: 100%;
  }
}
.orgs_team__block_btn {
  width: 100%;
  text-align: right;
  padding-block: 10px;
}
.orgs_team__block_btn button {
  background-color: transparent;
  border: 0;
  color: #676a6c;
  font-weight: 500;
  margin-right: 0;
}
.orgs_team__list_row {
  grid-row-gap: 20px;
}
@media (max-width: 1399px) {
  .orgs_team__list_row .f-col-4 {
    width: 50%;
  }
}
@media (max-width: 1800px) {
  .orgs_team__list_row .f-col-3 {
    width: 33.3333333333%;
  }
}
@media only screen and (max-width: 1350px) {
  .orgs_team__list_row .f-col-3 {
    width: 50%;
  }
}
@media only screen and (max-width: 767px) {
  .orgs_team__list_row .f-col-3 {
    width: 100%;
  }
}
.orgs_team__members {
  border: 1px solid #e7eaec;
  border-radius: 4px;
}
.orgs_team__members_body {
  display: flex;
  flex-wrap: wrap;
  max-height: 249px;
  overflow-y: auto;
}
.orgs_team__members_body--of {
  overflow-y: auto;
  max-height: 249px;
}
.orgs_team__members_body--ofh {
  max-height: none;
  overflow-y: visible;
}
.orgs_team__members_body--mh_increased {
  max-height: 498px;
}
.orgs_team__members_body_item {
  order: 2;
}
.orgs_team__members_body_item.active {
  order: 1;
  border-bottom: 1px solid #e7eaec;
}
.orgs_team__members_hdr {
  background-color: #f1f1f2;
  padding: 10px 15px;
  grid-gap: 7px;
}
.orgs_team__members_hdr_content {
  font-size: 14px;
  font-weight: 700;
  line-height: 1.3;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  margin-right: auto;
  text-transform: capitalize;
  display: flex;
  gap: 5px;
  align-items: center;
  flex: 1;
}
.orgs_team__members_hdr_content span {
  font-size: 12px;
  font-weight: 600;
}
.orgs_team__members_hdr_content span.full-mail {
  display: none;
}
.orgs_team__members_hdr_content span.short-mail {
  display: block;
}
.orgs_team__members_hdr_content--name:hover .full-mail {
  display: block;
}
.orgs_team__members_hdr_content--name:hover .short-mail {
  display: none;
}
.orgs_team__members_hdr_dropdown_1 {
  position: relative;
}
.orgs_team__members_hdr_dropdown_1:hover > button {
  background-color: transparent;
}
.orgs_team__members_hdr_dropdown_1:hover > .orgs_team__members_hdr_dropdown_1_body {
  display: block;
}
.orgs_team__members_hdr_dropdown_1 > button, .orgs_team__members_hdr_dropdown_1 > a {
  width: 18px;
  height: 19px;
  padding: 2px;
  background-color: #fff;
  border: 1px solid #e7eaec;
  border-radius: 3px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  grid-gap: 2px;
}
.orgs_team__members_hdr_dropdown_1 > button:hover, .orgs_team__members_hdr_dropdown_1 > a:hover {
  background-color: rgb(105, 190, 40);
  border-color: rgb(105, 190, 40);
}
.orgs_team__members_hdr_dropdown_1 > button:hover span, .orgs_team__members_hdr_dropdown_1 > a:hover span {
  background-color: #fff;
}
.orgs_team__members_hdr_dropdown_1 > button span, .orgs_team__members_hdr_dropdown_1 > a span {
  display: block;
  width: 2px;
  aspect-ratio: 1;
  background-color: #676a6c;
  border-radius: 50%;
}
.orgs_team__members_hdr_dropdown_1_body {
  position: absolute;
  top: 100%;
  right: -21px;
  min-width: 133px;
  padding-top: 13px;
  display: none;
  z-index: 9;
}
.orgs_team__members_hdr_dropdown_1_body ul {
  width: 100%;
  background-color: #fff;
  list-style: none;
  margin: 0;
  padding: 0;
  box-shadow: 0px 3px 7px rgba(0, 0, 0, 0.17);
  white-space: nowrap;
  position: relative;
  border-radius: 4px;
}
.orgs_team__members_hdr_dropdown_1_body ul::before {
  content: "";
  position: absolute;
  right: 20px;
  bottom: 100%;
  background-color: #fff;
  width: 20px;
  height: 10px;
  clip-path: polygon(0 100%, 50% 0, 100% 100%);
}
.orgs_team__members_hdr_dropdown_1_body li:not(:last-child) {
  border-bottom: 1px solid #e7eaec;
}
.orgs_team__members_hdr_dropdown_1_body li:not(.orgs_team__members_hdr_dropdown_1_body_add_btn) button, .orgs_team__members_hdr_dropdown_1_body li:not(.orgs_team__members_hdr_dropdown_1_body_add_btn) a {
  border: 0;
  padding: 13px 17px;
  background-color: transparent;
  font-size: 12px;
  font-weight: 600;
  color: #676a6c;
  width: 100%;
  text-align: left;
  display: inline-block;
}
.orgs_team__members_hdr_dropdown_1_body li:not(.orgs_team__members_hdr_dropdown_1_body_add_btn) button:hover, .orgs_team__members_hdr_dropdown_1_body li:not(.orgs_team__members_hdr_dropdown_1_body_add_btn) a:hover {
  color: rgb(105, 190, 40);
}
.orgs_team__members_hdr_dropdown_1_body li a {
  width: 100%;
}
.orgs_team__members_hdr_dropdown_1_body_add_btn {
  padding: 13px 17px;
}
.orgs_team__members_hdr_dropdown_2 > button {
  padding: 0;
  border: 0;
  background-color: transparent;
  transition: 0.3s;
}
.orgs_team__members_hdr_dropdown_2 > button:hover {
  color: rgb(105, 190, 40);
}
.orgs_team__members_body_item {
  padding: 14px 10px 14px 18px;
  display: flex;
  align-items: center;
  grid-gap: 10px;
  width: 100%;
}
.orgs_team__members_body_item:not(:last-child) {
  border-bottom: 1px solid #e7eaec;
}
.orgs_team__members_title {
  font-size: 14px;
  font-weight: 600;
  color: #676a6c;
  flex: 1 1 auto;
  min-width: 0;
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  grid-gap: 6px;
}
.orgs_team__members_title_name {
  flex: 1 1 auto;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.orgs_team__members_title_name.active {
  font-weight: 700;
}
.orgs_team__members_title span {
  flex-shrink: 0;
  background-color: #676a6c;
  padding: 1px 6px;
  border-radius: 5px;
  color: #fff;
  font-size: 12px;
  display: inline-block;
}
.orgs_team__members_dropdown {
  margin-left: auto;
  position: relative;
}
.orgs_team__members_dropdown--ml0 {
  margin-left: 0;
}
.orgs_team__members_dropdown:hover > .orgs_team__members_dropdown_button span {
  background-color: rgb(105, 190, 40);
}
.orgs_team__members_dropdown:hover > .orgs_team__members_dropdown_body {
  display: block;
}
.orgs_team__members_dropdown > button {
  border: 0;
  padding: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  grid-gap: 2px;
  background-color: transparent;
  width: 20px;
  aspect-ratio: 1;
  border-radius: 50%;
}
.orgs_team__members_dropdown > button span {
  display: block;
  width: 2px;
  aspect-ratio: 1;
  background-color: #676a6c;
  border-radius: 50%;
}
.orgs_team__members_dropdown_body {
  position: absolute;
  top: 100%;
  right: -5px;
  padding-top: 12px;
  z-index: 100;
  display: none;
}
.orgs_team__members_dropdown_body ul {
  width: 100%;
  background-color: #fff;
  list-style: none;
  margin: 0;
  padding: 0;
  box-shadow: 0px 1px 15px rgba(0, 0, 0, 0.17);
  white-space: nowrap;
  position: relative;
  min-width: 130px;
  border-radius: 4px;
}
.orgs_team__members_dropdown_body ul::before {
  content: "";
  position: absolute;
  right: 7px;
  bottom: 100%;
  background-color: #fff;
  width: 16px;
  height: 9px;
  clip-path: polygon(0 100%, 50% 0, 100% 100%);
}
.orgs_team__members_dropdown_body li {
  position: relative;
}
.orgs_team__members_dropdown_body li:hover > .orgs_team__members_dropdown_body_2 {
  display: block;
}
.orgs_team__members_dropdown_body li:not(:last-child) {
  border-bottom: 1px solid #e7eaec;
}
.orgs_team__members_dropdown_body li button,
.orgs_team__members_dropdown_body li a {
  border: 0;
  padding: 13px 17px;
  background-color: transparent;
  font-size: 12px;
  font-weight: 600;
  color: #676a6c;
  width: 100%;
  text-align: left;
}
.orgs_team__members_dropdown_body li button a,
.orgs_team__members_dropdown_body li button button,
.orgs_team__members_dropdown_body li a a,
.orgs_team__members_dropdown_body li a button {
  padding: 0;
}
.orgs_team__members_dropdown_body li button:hover,
.orgs_team__members_dropdown_body li a:hover {
  color: rgb(105, 190, 40);
}
.orgs_team__members_dropdown_body_2 {
  position: absolute;
  top: 0;
  right: 100%;
  padding-right: 12px;
  display: none;
}
.orgs_team__members_dropdown_body_2 ul::before {
  clip-path: polygon(0 0, 100% 50%, 0 100%);
  left: 100%;
  top: 11px;
  width: 9px;
  height: 14px;
}
.orgs_team__members_load_more {
  padding: 14px 10px 14px 18px;
  background-color: transparent;
  border: 0;
  font-size: 14px;
  font-weight: 600;
  color: #676a6c;
  width: 100%;
  text-align: center;
  order: 2;
  border-top: 1px solid #e7eaec;
}
.orgs_team__members_load_more i {
  transition: 0.3s;
}
.orgs_team__members_load_more:hover {
  color: rgb(105, 190, 40);
}
.orgs_team__members_load_more:hover > i {
  transform: rotate(360deg);
}
.orgs_team__pagination {
  flex-wrap: nowrap;
  gap: 20px;
}
.orgs_team__pagination .records_select {
  flex-shrink: 0;
}
.orgs_team__pagination .records_select label {
  font-weight: 700;
}

.teams_popup {
  position: fixed;
  inset: 0;
  background: rgba(255, 255, 255, 0.81);
  z-index: 99;
  transition: all ease 0.3s;
}
@media only screen and (min-width: 768px) {
  .teams_popup {
    padding-left: 220px;
  }
}
::ng-deep .mini-navbar .teams_popup {
  padding-left: 70px;
}
.teams_popup__wrapper {
  width: 100%;
  height: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: flex-start;
  overflow-y: auto;
  padding: 30px;
}
.teams_popup__inner {
  max-width: 500px;
  width: 100%;
  border: 1px solid #e7eaec;
  border-radius: 4px;
  padding: 13px 26px 15px;
  position: relative;
  background-color: #fff;
}
.teams_popup__close_button {
  --line_thickness: 2px;
  --line_length: 98%;
  --button_pos: 15px;
  background-color: transparent;
  border: 0;
  padding: 0;
  position: absolute;
  top: var(--button_pos);
  right: var(--button_pos);
  font-size: 14px;
  color: #676a6c;
  width: 12px;
  aspect-ratio: 1;
}
.teams_popup__close_button_inner {
  position: absolute;
  inset: 0;
  transform: rotate(45deg);
}
.teams_popup__close_button_inner::before, .teams_popup__close_button_inner::after {
  content: "";
  position: absolute;
  top: 50%;
  left: 0;
  transform: translateY(-50%);
  width: var(--line_length);
  height: var(--line_thickness);
  background-color: #676a6c;
  transition: all ease 0.3s;
}
.teams_popup__close_button_inner::after {
  top: auto;
  left: 50%;
  transform: translateX(-50%);
  width: var(--line_thickness);
  height: var(--line_length);
}
.teams_popup__close_button:hover > .teams_popup__close_button_inner::before, .teams_popup__close_button:hover > .teams_popup__close_button_inner::after {
  background-color: rgb(105, 190, 40);
}
.teams_popup__body > :not(:last-child) {
  margin-bottom: 14px;
}
.teams_popup__header > :not(:last-child) {
  margin-bottom: 0;
}
.teams_popup__header h2 {
  color: #676a6c;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 18px;
  font-weight: 600;
}
.teams_popup__header h2 span {
  font-size: 0.8em;
}
.teams_popup__team_list {
  border: 1px solid #e7eaec;
  border-radius: 4px;
}
.teams_popup__team_item {
  padding: 13px 20px;
  font-weight: 600;
  color: #676a6c;
  display: block;
  width: 100%;
  cursor: pointer;
  transition: all ease 0.3s;
}
.teams_popup__team_item:hover {
  background-color: #f6f6f6;
}
.teams_popup__team_item:not(:last-child) {
  border-bottom: 1px solid #e7eaec;
}
.teams_popup__team_item input[type=checkbox] {
  accent-color: #639935;
}
.teams_popup__rename_team_field input {
  width: 100%;
  border: 1px solid #e7eaec;
  padding: 10px;
}
.teams_popup__rename_team_field input:focus {
  border-color: rgb(105, 190, 40);
  outline: none;
}

::ng-deep .mini-navbar .swal2-container {
  padding-left: 85px;
}

::ng-deep .swal2-container {
  padding: 30px;
}
@media only screen and (min-width: 768px) {
  ::ng-deep .swal2-container {
    padding-left: 220px;
  }
}
@media only screen and (max-width: 767px) {
  ::ng-deep .swal2-container {
    padding-top: 50px;
    padding-inline: 15px;
  }
}
::ng-deep .swal2-container .swal2-modal {
  align-self: center !important;
  grid-row: auto !important;
  height: auto !important;
  margin: 0 !important;
  border: 1px solid #e7eaec !important;
  border-radius: 4px !important;
  padding: 13px 26px 25px !important;
  position: static !important;
  background-color: #fff !important;
}
::ng-deep .swal2-container .swal2-modal > * {
  margin-block: 0 !important;
}
::ng-deep .swal2-container .swal2-modal > :not(:last-child) {
  margin-bottom: 14px !important;
}
::ng-deep .swal2-container .swal2-actions {
  margin-bottom: 0 !important;
  padding-bottom: 20px !important;
  grid-gap: 10px !important;
}
::ng-deep .swal2-container .swal2-actions button {
  min-width: 130px !important;
  margin: 0 !important;
  font-size: 14px !important;
  padding-top: 10px !important;
  padding-bottom: 9px !important;
  padding-inline: 20px !important;
}
::ng-deep .swal2-container .swal2-actions .swal2-confirm {
  background-color: rgb(105, 190, 40) !important;
}
::ng-deep .swal2-container .swal2-actions .swal2-confirm:hover {
  background-color: #4cae4c !important;
  color: #fff;
}
::ng-deep .swal2-container h2 {
  font-size: 18px !important;
  line-height: 1.3 !important;
  font-weight: 600 !important;
  color: #676a6c !important;
}
::ng-deep .swal2-container .swal2-html-container {
  font-size: 16px !important;
  line-height: 150% !important;
}

.fa-angle-down.active {
  transform: rotate(180deg);
}

.org_mem {
  width: 46%;
  justify-content: space-between;
}
.org_mem li {
  font-weight: 600;
}
.org_mem li::after {
  display: none;
}

#holder {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  align-items: center;
  grid-gap: 5px;
}
#holder li {
  padding: 0;
  width: 20px;
  aspect-ratio: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 3px;
  margin: 0;
  transition: all 0.3s ease;
  border: 1px solid #6d6e71;
}
#holder li:hover {
  opacity: 0.85;
}
#holder li.active {
  color: #fff;
  background-color: #6d6e71;
}

.selectAll {
  padding: 0;
  background-color: #e7eaec;
}
.selectAll > div {
  width: 100%;
}

.gap5 {
  gap: 5px;
}
.gap10 {
  gap: 10px;
}
.gap30 {
  gap: 30px;
}

.hirar {
  width: 195px;
}
.hirar__body {
  border: 1px solid #e7eaec;
  border-top: 0;
  border-bottom-right-radius: 4px;
  border-bottom-left-radius: 4px;
}
.hirar__body__lead {
  border-top: 1px solid #e7eaec;
}
.hirar__body__lead .lead_txt {
  border: 1px solid #e7eaec;
  border-radius: 50%;
  padding: 3px 8px;
  font-size: 10px;
  font-weight: bold;
  color: #676a6c;
}
.hirar .orgs_team__members {
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
.hirar .orgs_team__members_hdr {
  background-color: transparent;
}
.hirar .orgs_team__members_hdr_content:hover .full-mail {
  display: block;
}
.hirar .orgs_team__members_hdr_content:hover .short-mail {
  display: none;
}
.hirar .orgs_team__members_hdr_content .counter {
  display: block;
  text-align: left;
}
.hirar .orgs_team__members_hdr_content .short-mail {
  display: block;
}
.hirar .orgs_team__members_hdr_content .full-mail {
  display: none;
}
.hirar .tooltip:hover .short-mail {
  display: inline-block;
}
.hirar .tooltip:hover .full-mail {
  display: inline-block;
  position: absolute;
  padding: 5px;
  top: -30px;
  width: 110px;
  background: #fff;
  left: -10px;
  box-shadow: 0 0 18px rgba(0, 0, 0, 0.1);
  text-align: center;
  border-radius: 6px;
}

.teams_roster table {
  width: 100%;
}
@media (min-width: 991px) and (max-width: 1199px) {
  .teams_roster th,
  .teams_roster td {
    font-size: 13px;
  }
}
.teams_roster th:first-child,
.teams_roster td:first-child {
  width: 36px;
}
.teams_roster th:nth-child(5), .teams_roster th:nth-child(6),
.teams_roster td:nth-child(5),
.teams_roster td:nth-child(6) {
  width: 80px;
  text-align: center;
}
@media only screen and (max-width: 1199px) {
  .teams_roster th:nth-child(5),
  .teams_roster td:nth-child(5) {
    width: 50px;
  }
  .teams_roster th:nth-child(6),
  .teams_roster td:nth-child(6) {
    width: 40px;
  }
}

.roaster_seach {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  padding: 6px 9px;
  margin: 0 !important;
  border-bottom: 1px solid #e7eaec;
}
.roaster_seach--bb0 {
  border-bottom: 0;
}
.roaster_seach__box {
  display: flex;
  flex-wrap: wrap;
  flex: 1;
}
.roaster_seach__box_input {
  position: relative;
  flex: 1;
}
.roaster_seach__box_input button {
  position: absolute;
  width: 20px;
  height: 20px;
  top: 50%;
  right: 5px;
  transform: translateY(-50%);
  padding: 0;
  border: 0;
  background: transparent;
  display: flex;
  justify-content: center;
  align-items: center;
}
.roaster_seach__box_input button:hover svg {
  fill: #676a6c;
}
.roaster_seach__box_input button svg {
  width: 12px;
  fill: #f00;
}
.roaster_seach__box_input input {
  border-radius: 4px 0 0 4px;
  border: 1px solid #e7eaec;
  background: #fff;
  color: #676a6c;
  padding: 4px 10px;
  flex: 1;
  width: 100%;
  font-size: 14px;
  outline: none;
}
.roaster_seach__box_input input:focus {
  border-color: #676a6c;
}
.roaster_seach__dropdown {
  width: 30px;
  flex-shrink: 0;
  position: relative;
}
.roaster_seach__dropdown:hover > div {
  display: block;
}
.roaster_seach__dropdown_toggle {
  border: 1px solid #e7eaec;
  border-left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 0 4px 4px 0;
  min-height: 100%;
  background-color: transparent;
  width: 100%;
  transition: 300ms;
}
.roaster_seach__dropdown_toggle:hover {
  background-color: #f1f1f2;
}
.roaster_seach__dropdown_body {
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  z-index: 9;
  padding-top: 20px;
  display: none;
}
.roaster_seach__dropdown_body_inner {
  width: 160px;
  background-color: #fff;
  filter: drop-shadow(0px 3px 7px rgba(0, 0, 0, 0.17));
  border-radius: 10px;
  position: relative;
}
.roaster_seach__dropdown_body_inner::before {
  content: "";
  position: absolute;
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%);
  width: 20px;
  height: 10px;
  background-color: #fff;
  clip-path: polygon(50% 0, 100% 100%, 0 100%);
}
.roaster_seach__dropdown_item {
  padding: 10px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.roaster_seach__dropdown_item + div {
  border-top: 1px solid #e7eaec;
}
.roaster_seach__dropdown_item label {
  display: flex;
  gap: 10px;
  color: #676a6c;
}
.roaster_seach__dropdown_item label input {
  margin: 0;
  flex-shrink: 0;
  flex: none;
}
.roaster_seach__button button {
  border-radius: 3px;
  border: 1px solid #e7eaec;
  background: #fff;
  color: #676a6c;
  padding: 7px 10px;
  font-size: 12px;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  transition: 300ms;
  line-height: 1;
  min-height: 100%;
}
.roaster_seach__button button.green_btn {
  background-color: rgb(105, 190, 40);
  border-color: rgb(105, 190, 40);
  color: #fff;
}
.roaster_seach__button button:hover, .roaster_seach__button button.green_btn:hover {
  background-color: #4cae4c;
  border-color: #4cae4c;
  color: #fff;
}

.soryby_outer .sortby {
  display: inline-block;
  position: static;
  margin-left: 6px;
  font-size: 12px;
  color: #ccc;
  vertical-align: middle;
  cursor: pointer;
  opacity: 0.5;
}
.soryby_outer .sortby.active {
  opacity: 1;
}

.white_space_nw {
  white-space: nowrap;
}

.roast_team_block .roast_team_branch {
  padding: 0;
  background-color: transparent;
  border: 0;
}
.roast_team_block .roast_team_branch--bge {
  margin-bottom: 20px;
}
.roast_team_block .roast_team_branch--mb-1 {
  margin-bottom: -1px;
}
.roast_team_block .roast_team_branch--2 table th:nth-child(4) {
  text-align: center;
}
.roast_team_block .roast_team_branch .orgs_team__branch_hdr {
  background-color: #f1f1f2;
  padding: 10px;
  margin: 0 !important;
  border-radius: 4px 4px 0 0;
}
.roast_team_block .roast_team_branch .orgs_team__branch_hdr--pr_exist {
  padding-right: 0;
  display: flex;
  align-items: center;
  gap: 8px;
}
.roast_team_block .roast_team_branch .orgs_team__branch_hdr_title {
  flex: 1;
  min-width: 0;
}
.roast_team_block .roast_team_branch .orgs_team__branch_hdr_title .title-case {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
  flex: 1;
}
.roast_team_block .roast_team_branch .orgs_team__branch_hdr_title .rs-mem {
  flex: 1;
  display: flex;
  gap: 6px;
  align-items: center;
}
.roast_team_block .roast_team_branch .orgs_team__branch_hdr_title .fmt {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 24px;
  height: 22px;
  padding: 0 8px;
  border-radius: 11px;
  background: linear-gradient(135deg, rgb(0, 173, 208), rgb(0, 153, 188));
  color: #fff;
  font-size: 12px;
  font-weight: 700;
  line-height: 1;
  flex-shrink: 0;
  aspect-ratio: auto;
  width: auto;
}
.roast_team_block .roast_team_branch .orgs_team__branch_hdr_dropdown_2 {
  position: static;
  top: auto;
  transform: none;
  right: auto;
  flex-shrink: 0;
  margin-left: 12px;
}
.roast_team_block .roast_team_branch .orgs_team__branch_hdr .w93 {
  width: 93%;
}
.roast_team_block .roast_team_branch .orgs_team__branch_body {
  border: 1px solid #e7eaec;
  border-radius: 0 0 4px 4px;
}
.roast_team_block .roast_team_branch .orgs_team__branch_item {
  border: 0;
}
.roast_team_block .roast_team_branch .ibox-content {
  border: 0;
}
.roast_team_block .roast_team_branch table th:where(:nth-child(2), :nth-child(3), :nth-child(4)) {
  text-align: left;
}
.roast_team_block .roast_team_branch table th,
.roast_team_block .roast_team_branch table td {
  border: 0;
  border-bottom: 1px solid #e7eaec;
  vertical-align: middle;
}
.roast_team_block .roast_team_branch table tr:last-child .orgs_team__members_dropdown_body {
  top: auto;
  bottom: 100%;
  padding-top: 0;
  padding-bottom: 12px;
}
.roast_team_block .roast_team_branch table tr:last-child .orgs_team__members_dropdown_body ul::before {
  bottom: auto;
  top: 100%;
  clip-path: polygon(0 0, 50% 100%, 100% 0);
}
.roast_team_block .roast_team_branch .orgs_team__branch_dropdown,
.roast_team_block .roast_team_branch .orgs_team__members_dropdown {
  margin-inline: auto;
}
.roast_team_block .roast_team_branch .roast_team__email_box {
  position: relative;
  color: #d9d9d9;
  display: inline-block;
}
.roast_team_block .roast_team_branch .roast_team__email_box .full-mail {
  display: none;
  position: absolute;
  bottom: calc(100% + 5px);
  left: 50%;
  transform: translateX(-50%);
  background-color: #fff;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  padding: 4px 11px;
  border-radius: 2px;
  font-size: 13px;
}
.roast_team_block .roast_team_branch .roast_team__email_box .full-mail::before {
  content: "";
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  background-color: #fff;
  width: 10px;
  height: 8px;
  clip-path: polygon(0 0, 100% 0, 50% 100%);
}
.roast_team_block .roast_team_branch .roast_team__email_box:hover .full-mail {
  display: block;
}
.roast_team_block .roast_team_branch .roast_team__email:hover {
  color: #69be28;
}
.roast_team_block .roast_team_branch .selectAll .orgs_team__branch_title {
  padding: 6px 9px;
}
.roast_team_block .raost_team__count {
  position: relative;
  cursor: default;
}
.roast_team_block .raost_team__count:hover > .team-overlay {
  display: block;
}
.roast_team_block .roast_team_view {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 7px;
}
.roast_team_block .roast_team_view button {
  width: 33px;
  height: 30px;
  border-radius: 2px;
  border: 1px solid #e7eaec;
  background: #fff;
  padding: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}
.roast_team_block .roast_team_view button::before {
  content: attr(data-content);
  padding: 4px 8px;
  filter: drop-shadow(0px 3px 7px rgba(0, 0, 0, 0.17));
  background-color: #676a6c;
  color: #fff;
  font-size: 13px;
  position: absolute;
  bottom: calc(100% + 16px);
  left: 50%;
  transform: translateX(-50%);
  border-radius: 4px;
  display: none;
}
.roast_team_block .roast_team_view button::after {
  content: "";
  position: absolute;
  bottom: calc(100% + 8px);
  width: 16px;
  height: 8px;
  background-color: #676a6c;
  clip-path: polygon(0 0, 100% 0, 50% 100%);
  display: none;
}
.roast_team_block .roast_team_view button:hover::before, .roast_team_block .roast_team_view button:hover::after {
  display: block;
}
.roast_team_block .roast_team_view button:hover, .roast_team_block .roast_team_view button.active {
  background-color: #676a6c;
  border-color: #676a6c;
  color: #fff;
}
.roast_team_block .roast_team_view button:hover i, .roast_team_block .roast_team_view button.active i {
  color: #fff;
}
.roast_team_block .roast_team_view button:hover svg path, .roast_team_block .roast_team_view button.active svg path {
  fill: #fff;
}
.roast_team_block .roast_team_view button svg {
  width: 14px;
  height: auto;
}

.hidden {
  visibility: hidden;
}

.counter-mem {
  font-size: 8px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  border: 1px solid #e7eaec;
  height: 17px;
  width: 17px;
  border-radius: 50%;
  text-align: center;
}

.customWeight label {
  font-weight: 700;
}

.orgs_team__members {
  border: 1px solid #e7eaec !important;
  border-radius: 8px !important;
  overflow: visible;
  margin-bottom: 16px;
  transition: box-shadow 0.2s ease;
  position: relative;
}
.orgs_team__members:hover {
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.06);
}

.orgs_team__members_hdr {
  background: #f1f1f2 !important;
  border-bottom: 1px solid #e7eaec;
  padding: 12px 16px;
}

.counter-mem {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 24px;
  height: 22px;
  padding: 0 8px;
  border-radius: 11px;
  background: rgba(0, 173, 208, 0.1);
  color: rgb(0, 173, 208);
  font-size: 12px;
  font-weight: 700;
  margin-left: 8px;
}

.orgs_team__members_hdr_dropdown_1_body,
.orgs_team__branch_hdr_dropdown_2 ul {
  background: #fff !important;
  border: 1px solid #e7eaec !important;
  border-radius: 8px !important;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12) !important;
  padding: 4px 0 !important;
}
.orgs_team__members_hdr_dropdown_1_body li button, .orgs_team__members_hdr_dropdown_1_body li a,
.orgs_team__branch_hdr_dropdown_2 ul li button,
.orgs_team__branch_hdr_dropdown_2 ul li a {
  padding: 9px 16px !important;
  font-size: 13px !important;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  transition: background 0.12s ease;
}
.orgs_team__members_hdr_dropdown_1_body li button:hover, .orgs_team__members_hdr_dropdown_1_body li a:hover,
.orgs_team__branch_hdr_dropdown_2 ul li button:hover,
.orgs_team__branch_hdr_dropdown_2 ul li a:hover {
  background: #f1f1f2 !important;
}

#holder li, .holder li {
  display: inline-flex !important;
  align-items: center;
  justify-content: center;
  min-width: 32px;
  height: 32px;
  padding: 0 8px;
  border: 1px solid #e7eaec;
  border-radius: 4px;
  font-size: 13px;
  font-weight: 500;
  color: #676a6c;
  background: #fff;
  cursor: pointer;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  transition: all 0.15s ease;
  list-style: none;
}
#holder li:hover, .holder li:hover {
  background: #f1f1f2;
  border-color: #ccc;
}
#holder li.active, .holder li.active {
  background: #6d6e71;
  color: #fff;
  border-color: #6d6e71;
}

.roaster_seach__box_input input,
.roaster_seach input[type=text],
.roaster_seach input[type=search] {
  padding: 8px 12px !important;
  border: 1px solid #e7eaec !important;
  border-radius: 6px !important;
  font-size: 13px !important;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}
.roaster_seach__box_input input:focus,
.roaster_seach input[type=text]:focus,
.roaster_seach input[type=search]:focus {
  border-color: rgb(0, 173, 208) !important;
  box-shadow: 0 0 0 3px rgba(0, 173, 208, 0.1);
  outline: none;
}

.team-modal .dialogbox,
.roster-del-mem .dialogbox,
.roster_addmem_popup .dialogbox,
.roster_mem_edit_popup .dialogbox,
.roster_popup .dialogbox {
  position: fixed !important;
  top: 0 !important;
  left: 0 !important;
  width: 100% !important;
  height: 100% !important;
  background: rgba(0, 0, 0, 0.4) !important;
  z-index: 99999 !important;
}
.team-modal .dialogbox__wrapper,
.roster-del-mem .dialogbox__wrapper,
.roster_addmem_popup .dialogbox__wrapper,
.roster_mem_edit_popup .dialogbox__wrapper,
.roster_popup .dialogbox__wrapper {
  display: flex !important;
  justify-content: center !important;
  align-items: flex-start !important;
  padding: 60px 20px !important;
  overflow-y: auto !important;
  height: 100% !important;
}
.team-modal .dialogbox__inner,
.roster-del-mem .dialogbox__inner,
.roster_addmem_popup .dialogbox__inner,
.roster_mem_edit_popup .dialogbox__inner,
.roster_popup .dialogbox__inner {
  width: min(560px, 100%) !important;
  border-radius: 10px !important;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.15) !important;
  overflow: hidden !important;
  background: #fff !important;
  border: none !important;
  padding: 0 !important;
}
.team-modal .dialogbox__hdr,
.roster-del-mem .dialogbox__hdr,
.roster_addmem_popup .dialogbox__hdr,
.roster_mem_edit_popup .dialogbox__hdr,
.roster_popup .dialogbox__hdr {
  padding: 18px 24px !important;
  background: #f1f1f2 !important;
  border-bottom: 1px solid #e7eaec !important;
  position: relative !important;
}
.team-modal .dialogbox__hdr h2,
.roster-del-mem .dialogbox__hdr h2,
.roster_addmem_popup .dialogbox__hdr h2,
.roster_mem_edit_popup .dialogbox__hdr h2,
.roster_popup .dialogbox__hdr h2 {
  font-size: 17px !important;
  font-weight: 700 !important;
  color: #6d6e71 !important;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif !important;
}
.team-modal .dialogbox__close,
.roster-del-mem .dialogbox__close,
.roster_addmem_popup .dialogbox__close,
.roster_mem_edit_popup .dialogbox__close,
.roster_popup .dialogbox__close {
  position: absolute !important;
  top: 16px !important;
  right: 16px !important;
  width: 28px !important;
  height: 28px !important;
  padding: 0 !important;
  border: 1px solid #e7eaec !important;
  border-radius: 6px !important;
  background: #fff !important;
  cursor: pointer;
  transition: all 0.15s ease;
}
.team-modal .dialogbox__close::before, .team-modal .dialogbox__close::after,
.roster-del-mem .dialogbox__close::before,
.roster-del-mem .dialogbox__close::after,
.roster_addmem_popup .dialogbox__close::before,
.roster_addmem_popup .dialogbox__close::after,
.roster_mem_edit_popup .dialogbox__close::before,
.roster_mem_edit_popup .dialogbox__close::after,
.roster_popup .dialogbox__close::before,
.roster_popup .dialogbox__close::after {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  width: 2px;
  height: 55%;
  background-color: #676a6c;
  border-radius: 2px;
  transform: translate(-50%, -50%) rotate(-45deg);
}
.team-modal .dialogbox__close::after,
.roster-del-mem .dialogbox__close::after,
.roster_addmem_popup .dialogbox__close::after,
.roster_mem_edit_popup .dialogbox__close::after,
.roster_popup .dialogbox__close::after {
  transform: translate(-50%, -50%) rotate(45deg);
}
.team-modal .dialogbox__close:hover,
.roster-del-mem .dialogbox__close:hover,
.roster_addmem_popup .dialogbox__close:hover,
.roster_mem_edit_popup .dialogbox__close:hover,
.roster_popup .dialogbox__close:hover {
  background: rgba(245, 67, 89, 0.08) !important;
  border-color: rgba(245, 67, 89, 0.2) !important;
}
.team-modal .dialogbox__body,
.team-modal .dialogbox__form,
.roster-del-mem .dialogbox__body,
.roster-del-mem .dialogbox__form,
.roster_addmem_popup .dialogbox__body,
.roster_addmem_popup .dialogbox__form,
.roster_mem_edit_popup .dialogbox__body,
.roster_mem_edit_popup .dialogbox__form,
.roster_popup .dialogbox__body,
.roster_popup .dialogbox__form {
  padding: 24px !important;
}
.team-modal label,
.roster-del-mem label,
.roster_addmem_popup label,
.roster_mem_edit_popup label,
.roster_popup label {
  font-size: 13px !important;
  font-weight: 600 !important;
  color: #6d6e71 !important;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  margin-bottom: 6px !important;
}
.team-modal input[type=text],
.team-modal input[type=email],
.team-modal input[type=tel],
.team-modal select,
.team-modal .form-control,
.roster-del-mem input[type=text],
.roster-del-mem input[type=email],
.roster-del-mem input[type=tel],
.roster-del-mem select,
.roster-del-mem .form-control,
.roster_addmem_popup input[type=text],
.roster_addmem_popup input[type=email],
.roster_addmem_popup input[type=tel],
.roster_addmem_popup select,
.roster_addmem_popup .form-control,
.roster_mem_edit_popup input[type=text],
.roster_mem_edit_popup input[type=email],
.roster_mem_edit_popup input[type=tel],
.roster_mem_edit_popup select,
.roster_mem_edit_popup .form-control,
.roster_popup input[type=text],
.roster_popup input[type=email],
.roster_popup input[type=tel],
.roster_popup select,
.roster_popup .form-control {
  padding: 9px 12px !important;
  border: 1px solid #e7eaec !important;
  border-radius: 6px !important;
  font-size: 13px !important;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  color: #676a6c;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}
.team-modal input[type=text]:focus,
.team-modal input[type=email]:focus,
.team-modal input[type=tel]:focus,
.team-modal select:focus,
.team-modal .form-control:focus,
.roster-del-mem input[type=text]:focus,
.roster-del-mem input[type=email]:focus,
.roster-del-mem input[type=tel]:focus,
.roster-del-mem select:focus,
.roster-del-mem .form-control:focus,
.roster_addmem_popup input[type=text]:focus,
.roster_addmem_popup input[type=email]:focus,
.roster_addmem_popup input[type=tel]:focus,
.roster_addmem_popup select:focus,
.roster_addmem_popup .form-control:focus,
.roster_mem_edit_popup input[type=text]:focus,
.roster_mem_edit_popup input[type=email]:focus,
.roster_mem_edit_popup input[type=tel]:focus,
.roster_mem_edit_popup select:focus,
.roster_mem_edit_popup .form-control:focus,
.roster_popup input[type=text]:focus,
.roster_popup input[type=email]:focus,
.roster_popup input[type=tel]:focus,
.roster_popup select:focus,
.roster_popup .form-control:focus {
  border-color: rgb(0, 173, 208) !important;
  box-shadow: 0 0 0 3px rgba(0, 173, 208, 0.1) !important;
  outline: none !important;
}
.team-modal .f-btn,
.roster-del-mem .f-btn,
.roster_addmem_popup .f-btn,
.roster_mem_edit_popup .f-btn,
.roster_popup .f-btn {
  padding: 9px 20px !important;
  font-size: 13px !important;
  font-weight: 600 !important;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  border-radius: 6px !important;
  border: none !important;
  background: rgb(105, 190, 40) !important;
  color: #fff !important;
  cursor: pointer;
  transition: background 0.15s ease;
}
.team-modal .f-btn:hover,
.roster-del-mem .f-btn:hover,
.roster_addmem_popup .f-btn:hover,
.roster_mem_edit_popup .f-btn:hover,
.roster_popup .f-btn:hover {
  background: #4cae4c !important;
}
.team-modal .f-btn.disabled,
.roster-del-mem .f-btn.disabled,
.roster_addmem_popup .f-btn.disabled,
.roster_mem_edit_popup .f-btn.disabled,
.roster_popup .f-btn.disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

select.wide-per-page,
.records_select select {
  width: 70px;
  padding: 4px 8px;
  font-size: 13px;
  border: 1px solid #e7eaec;
  border-radius: 4px;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
}
select.wide-per-page:focus,
.records_select select:focus {
  border-color: rgb(0, 173, 208);
  outline: none;
}

.hirar {
  border: 1px solid #e7eaec !important;
  border-radius: 8px !important;
  overflow: hidden;
  margin-bottom: 16px;
}
.hirar .lead_txt {
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: rgb(105, 190, 40);
  background: rgba(105, 190, 40, 0.08);
  padding: 2px 8px;
  border-radius: 3px;
}

.roast_team_branch .fmt {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 28px;
  height: 24px;
  padding: 0 8px;
  border-radius: 12px;
  background: rgba(0, 173, 208, 0.1);
  color: rgb(0, 173, 208);
  font-size: 13px;
  font-weight: 700;
  margin-left: 8px;
}

.orgs_team__branch.roast_team_branch {
  background: #fff;
  border: 1px solid #e7eaec;
  border-radius: 8px;
  overflow: visible;
}

.roster-members-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}
.roster-members-header__left {
  display: flex;
  align-items: center;
  gap: 6px;
}
.roster-members-header__left .title-case {
  font-size: 14px;
  font-weight: 700;
  color: #6d6e71;
}
.roster-members-header__left .fmt {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 24px;
  height: 22px;
  padding: 0 8px;
  border-radius: 11px;
  background: linear-gradient(135deg, rgb(0, 173, 208), #008ba7);
  color: #fff;
  font-size: 12px;
  font-weight: 700;
  flex-shrink: 0;
}

.roster-sort-icon {
  margin-left: 4px;
  font-size: 12px;
  color: #ccc;
  vertical-align: middle;
}

.teammates__head th.sort-heads {
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  transition: color 0.15s ease;
  white-space: nowrap;
}
.teammates__head th.sort-heads:hover {
  color: rgb(0, 173, 208);
}
.teammates__head th.sort-heads:hover .roster-sort-icon {
  color: rgb(0, 173, 208);
}

.roast_team_branch .roaster_seach__button .f-btn {
  padding: 5px 12px !important;
  font-size: 11px !important;
  font-weight: 600 !important;
  border-radius: 5px !important;
  background: rgb(105, 190, 40) !important;
  color: #fff !important;
  border: none !important;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  transition: background 0.15s ease;
  margin-left: 8px;
}
.roast_team_branch .roaster_seach__button .f-btn:hover {
  background: #4cae4c !important;
}

.teammates__head th {
  padding: 6px 8px !important;
  font-size: 11px !important;
  font-weight: 700 !important;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #6d6e71 !important;
  border-bottom: 1px solid #e7eaec !important;
  border-top: none !important;
  white-space: nowrap;
  vertical-align: middle !important;
}
.teammates__head th .sortby,
.teammates__head th span.sortby {
  display: inline-block !important;
  position: static !important;
  top: auto !important;
  right: auto !important;
  margin-left: 6px;
  font-size: 12px;
  color: #ccc;
  vertical-align: middle;
  cursor: pointer;
}

.teams_roster .ibox-content .table-responsive table.teammates td,
.teams_roster .ibox-content .table-responsive table.teammates th,
.teams_roster table.teammates-tb-none td,
.teams_roster table.teammates-tb-none th,
table.teammates td,
table.teammates th {
  border-top: 0 !important;
  padding-top: 3px !important;
  padding-bottom: 3px !important;
}

.teams_roster .table-responsive,
.teams_roster .ibox-content {
  padding: 0 !important;
}

.teams_roster .table-responsive {
  overflow: visible !important;
}

.teams_roster table.teammates {
  width: 100% !important;
  margin-bottom: 0 !important;
}

.roster-layout {
  display: flex;
  width: 100%;
  gap: 20px;
  flex-wrap: nowrap;
  margin: 0;
  padding: 0;
}
@media (max-width: 991px) {
  .roster-layout {
    flex-wrap: wrap;
  }
}

.roster-left-panel {
  width: 40%;
  max-width: 620px;
  flex-shrink: 0;
  padding-left: 0;
  position: relative;
  transition: width 0.3s ease, max-width 0.3s ease, opacity 0.2s ease;
}
.roster-left-panel--collapsed {
  width: 0 !important;
  max-width: 0 !important;
  overflow: hidden;
  opacity: 0;
  padding: 0 !important;
  margin: 0 !important;
}
@media (max-width: 991px) {
  .roster-left-panel {
    width: 100%;
    max-width: none;
    padding-left: 0;
  }
}

.roster-collapse-toggle {
  width: 28px;
  height: 28px;
  border-radius: 6px;
  border: 1px solid #e7eaec;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.15s ease;
  padding: 0;
  flex-shrink: 0;
  margin-right: 8px;
}
.roster-collapse-toggle:hover {
  background: #f4f5f7;
  border-color: #cbd1d5;
}
.roster-collapse-toggle i {
  font-size: 13px;
  color: #676a6c;
}

.roster-layout--collapsed {
  gap: 0;
}

.roster-right-panel {
  flex: 1 1 0%;
  min-width: 0;
  width: 0;
}
@media (max-width: 991px) {
  .roster-right-panel {
    width: 100%;
    flex: 1 1 100%;
  }
}

.roster-right-panel .orgs_team__branch,
.roster-right-panel .roast_team_branch,
.roster-right-panel .roast_team_branch--bge {
  width: 100% !important;
  max-width: 100% !important;
}
.roster-right-panel .orgs_team__list {
  width: 100% !important;
}

.orgs_team__list {
  overflow: visible;
}

.orgs_team__list_row.f-flex {
  display: grid !important;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 12px;
  margin: 0;
  padding: 0;
  flex-wrap: unset;
}

.roster-team-cell {
  flex: unset;
  width: auto !important;
  max-width: none;
  padding: 0;
  min-width: 0;
}
@media (max-width: 1400px), (max-width: 1100px), (max-width: 768px) {
  .roster-team-cell {
    width: auto !important;
  }
}

.roster-team-cell .orgs_team__members {
  min-width: 0;
  overflow: visible;
}
.roster-team-cell .orgs_team__members_hdr {
  display: flex !important;
  align-items: center;
  gap: 8px;
  min-width: 0;
  padding: 10px 12px;
  flex-wrap: nowrap !important;
}
.roster-team-cell .orgs_team__members_hdr_content--name {
  display: flex !important;
  align-items: center;
  gap: 6px;
  flex: 1 1 auto;
  min-width: 0;
  overflow: hidden;
}
.roster-team-cell .orgs_team__members_hdr_content--name > div:first-child {
  flex-shrink: 0;
}
.roster-team-cell .orgs_team__members_hdr_content--name .short-mail,
.roster-team-cell .orgs_team__members_hdr_content--name .full-mail {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0;
  font-size: 13px;
  font-weight: 600;
  color: #6d6e71;
}
.roster-team-cell .orgs_team__members_hdr_content--name > span:last-child {
  flex-shrink: 0;
  font-size: 12px;
  color: #676a6c;
  font-weight: 500;
}
.roster-team-cell .orgs_team__members_hdr .orgs_team__members_hdr_dropdown_1 {
  flex-shrink: 0;
  margin-left: auto;
  position: relative;
}
.roster-team-cell .orgs_team__members_hdr .orgs_team__members_hdr_dropdown_2 {
  flex-shrink: 0;
}

.roast_team_branch--bge {
  overflow: visible !important;
  position: relative;
  z-index: 20;
}
.roast_team_branch--bge .orgs_team__branch_hdr {
  overflow: visible !important;
}
.roast_team_branch--bge .roast_team_view {
  overflow: visible !important;
  margin-right: 16px;
}
.roast_team_branch--bge .orgs_team__branch_hdr--pr_exist {
  display: flex !important;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  padding: 12px 16px;
  min-width: 0;
}
.roast_team_branch--bge .orgs_team__branch_hdr--pr_exist .orgs_team__branch_hdr_title {
  flex: 1 1 auto;
  min-width: 0;
}
.roast_team_branch--bge .orgs_team__branch_hdr--pr_exist .orgs_team__branch_hdr_title > div {
  min-width: 0;
}
.roast_team_branch--bge .orgs_team__branch_hdr--pr_exist .orgs_team__branch_hdr_title .title-case {
  display: inline-block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  vertical-align: bottom;
}
.roast_team_branch--bge .orgs_team__branch_hdr--pr_exist .roast_team_view {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  gap: 4px;
}

.roast_team_branch--bge .roaster_seach {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  padding: 0 16px 12px;
}
.roast_team_branch--bge .roaster_seach__box {
  flex: 1 1 240px;
  min-width: 180px;
}
.roast_team_branch--bge .roaster_seach__button {
  flex-shrink: 0;
}

.roster-collapse-btn {
  flex-shrink: 0;
}
.roster-collapse-btn button {
  width: 33px;
  height: 30px;
  border-radius: 2px;
  border: 1px solid #e7eaec;
  background: transparent;
  padding: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  transition: all 0.15s ease;
}
.roster-collapse-btn button:hover {
  background-color: #676a6c;
  border-color: #676a6c;
}
.roster-collapse-btn button:hover i {
  color: #fff;
}
.roster-collapse-btn button i {
  color: #676a6c;
  font-size: 14px;
}

.orgs_team__list {
  position: relative;
  z-index: 1;
}

.orgs_team__members_hdr_dropdown_1_body {
  z-index: 50 !important;
}

.orgs_team__branch_title {
  border-bottom: 1px solid #e7eaec !important;
  transition: background-color 0.12s ease;
}
.orgs_team__branch_title:hover {
  background-color: rgba(0, 173, 208, 0.03) !important;
}
.orgs_team__branch_title:nth-child(even) {
  background-color: rgba(241, 241, 242, 0.5);
}
.orgs_team__branch_title:nth-child(even):hover {
  background-color: rgba(0, 173, 208, 0.03) !important;
}
.orgs_team__branch_title td {
  padding: 0 10px !important;
  font-size: 13px;
  color: #676a6c;
  vertical-align: middle !important;
  line-height: 1.2;
  border-top: none !important;
}

.orgs_team__branch_title_name a {
  color: #676a6c;
  text-decoration: none;
  font-weight: 500;
  transition: color 0.15s ease;
}
.orgs_team__branch_title_name a:hover {
  color: rgb(0, 173, 208);
}

.orgs_team__branch_title_dropdown button {
  border: none;
  background: transparent;
  cursor: pointer;
  padding: 4px;
  border-radius: 4px;
  transition: background 0.15s ease;
}
.orgs_team__branch_title_dropdown button:hover {
  background: #f1f1f2;
}
.orgs_team__branch_title_dropdown_body {
  background: #fff !important;
  border: 1px solid #e7eaec !important;
  border-radius: 8px !important;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12) !important;
  padding: 4px 0 !important;
  z-index: 100;
}
.orgs_team__branch_title_dropdown_body button, .orgs_team__branch_title_dropdown_body a {
  display: block;
  width: 100%;
  text-align: left;
  padding: 8px 16px !important;
  font-size: 13px !important;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  color: #676a6c !important;
  border: none;
  background: transparent;
  cursor: pointer;
  transition: background 0.12s ease;
}
.orgs_team__branch_title_dropdown_body button:hover, .orgs_team__branch_title_dropdown_body a:hover {
  background: #f1f1f2 !important;
}

.roaster_seach {
  padding: 10px 12px;
  background: #f1f1f2;
  border-bottom: 1px solid #e7eaec;
}
.roaster_seach__box {
  display: flex;
  align-items: center;
  gap: 8px;
}
.roaster_seach__box_input {
  flex: 1;
  position: relative;
}
.roaster_seach__box_input input {
  width: 100% !important;
  padding: 8px 36px 8px 12px !important;
  border: 1px solid #e7eaec !important;
  border-radius: 6px !important;
  font-size: 13px !important;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
}
.roaster_seach__box_input input:focus {
  border-color: rgb(0, 173, 208) !important;
  box-shadow: 0 0 0 3px rgba(0, 173, 208, 0.1);
  outline: none;
}
.roaster_seach__box_input button {
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  border: none;
  background: transparent;
  cursor: pointer;
  padding: 4px;
}
.roaster_seach__box_input button svg {
  width: 12px;
  height: 12px;
  fill: #ccc;
}
.roaster_seach__box_input button:hover svg {
  fill: rgb(245, 67, 89);
}
.roaster_seach__dropdown {
  position: relative;
}
.roaster_seach__dropdown_toggle {
  padding: 6px 10px !important;
  border: 1px solid #e7eaec !important;
  border-radius: 6px !important;
  background: #fff !important;
  cursor: pointer;
  transition: border-color 0.15s ease;
}
.roaster_seach__dropdown_toggle:hover {
  border-color: #ccc !important;
}
.roaster_seach__dropdown_body {
  background: #fff !important;
  border: 1px solid #e7eaec !important;
  border-radius: 8px !important;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12) !important;
  padding: 8px 0 !important;
  z-index: 100;
}
.roaster_seach__dropdown_item {
  padding: 6px 14px;
  font-size: 13px;
}
.roaster_seach__dropdown_item label {
  cursor: pointer;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 6px;
  margin: 0;
}

.orgs_team__branch_body .f-btn--seagrn,
.roaster_seach .f-btn--seagrn {
  border-radius: 5px !important;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-weight: 600 !important;
  font-size: 11px !important;
  padding: 5px 12px !important;
  transition: all 0.15s ease;
}

.orgs_team__branch_title_name input[type=checkbox] {
  accent-color: rgb(105, 190, 40);
  width: 15px;
  height: 15px;
  cursor: pointer;
}

.orgs_team__branch_title_utype {
  font-size: 12px;
}

.raost_team__count {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  border-top: 1px solid #e7eaec;
}
.raost_team__count .records_select {
  display: flex;
  align-items: center;
  gap: 8px;
}
.raost_team__count .records_select label {
  font-size: 12px;
  font-weight: 600;
  color: #6d6e71;
  margin: 0;
}

.orgs_team__members_body .orgs_team__members_body_item {
  position: relative;
}
.orgs_team__members_body .orgs_team__members_body_item .orgs_team__members_dropdown_body {
  top: 100%;
  bottom: auto;
  padding-top: 12px;
  padding-bottom: 0;
}
.orgs_team__members_body .orgs_team__members_body_item .orgs_team__members_dropdown_body ul::before {
  top: auto;
  bottom: 100%;
  clip-path: polygon(0 100%, 50% 0, 100% 100%);
}

app-roster-team-card:nth-last-child(-n+3) .orgs_team__members_hdr_dropdown_1_body {
  top: auto;
  bottom: 100%;
  padding-top: 0;
  padding-bottom: 13px;
}
app-roster-team-card:nth-last-child(-n+3) .orgs_team__members_hdr_dropdown_1_body ul::before {
  bottom: auto;
  top: 100%;
  clip-path: polygon(0 0, 50% 100%, 100% 0);
}

app-directory-view .table {
  width: 100%;
  border-collapse: collapse;
}
app-directory-view .table thead tr {
  background: #f1f1f2;
}
app-directory-view .table thead tr th {
  padding: 8px 10px;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #6d6e71;
  border-bottom: 1px solid #e7eaec;
  border-top: none;
  white-space: nowrap;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
}
app-directory-view .table tbody tr {
  border-bottom: 1px solid #e7eaec;
  transition: background 0.12s ease;
}
app-directory-view .table tbody tr:hover {
  background: rgba(0, 173, 208, 0.03);
}
app-directory-view .table tbody tr td {
  padding: 6px 10px;
  font-size: 13px;
  color: #676a6c;
  vertical-align: middle;
  border-top: none;
}
app-directory-view .teammates__details a {
  color: #676a6c;
  text-decoration: none;
  font-weight: 500;
  transition: color 0.15s ease;
}
app-directory-view .teammates__details a:hover {
  color: rgb(0, 173, 208);
}

.raost_team__count--inline {
  border-top: none !important;
}

.team-count-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 26px;
  height: 22px;
  padding: 0 6px;
  border-radius: 11px;
  background: rgba(0, 173, 208, 0.1);
  color: rgb(0, 173, 208);
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.15s ease;
}
.team-count-badge:hover {
  background: rgba(0, 173, 208, 0.18);
}
.team-count-badge--zero {
  background: rgba(204, 204, 204, 0.1);
  color: #ccc;
  cursor: default;
}
.team-count-badge--zero:hover {
  background: rgba(204, 204, 204, 0.1);
}

.team-overlay {
  display: none;
  position: absolute;
  top: calc(100% + 6px);
  left: 50%;
  transform: translateX(-50%);
  z-index: 200;
  width: max-content;
  min-width: 180px;
  max-width: 260px;
  background: #fff;
  border: 1px solid #e7eaec;
  border-radius: 10px;
  box-shadow: 0 12px 36px rgba(0, 0, 0, 0.14);
  overflow: hidden;
}
.team-overlay__arrow {
  position: absolute;
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%);
  width: 14px;
  height: 7px;
  overflow: hidden;
}
.team-overlay__arrow::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%) rotate(45deg);
  width: 10px;
  height: 10px;
  background: #fff;
  border: 1px solid #e7eaec;
  border-bottom: none;
  border-right: none;
}
.team-overlay__header {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 14px;
  background: #f1f1f2;
  border-bottom: 1px solid #e7eaec;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #6d6e71;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
}
.team-overlay__header i {
  font-size: 10px;
  color: rgb(0, 173, 208);
}
.team-overlay__list {
  list-style: none;
  margin: 0;
  padding: 6px 0;
  max-height: 220px;
  overflow-y: auto;
}
.team-overlay__item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 14px;
  font-size: 13px;
  color: #676a6c;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  text-transform: capitalize;
  transition: background 0.1s ease;
}
.team-overlay__item:hover {
  background: rgba(0, 173, 208, 0.03);
}
.team-overlay__item span {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 200px;
}
.team-overlay__dot {
  font-size: 5px;
  color: rgb(105, 190, 40);
  flex-shrink: 0;
}

.orgs_team__members_title_name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 140px;
}

.orgs_team__members_wave {
  flex-shrink: 0;
  width: 34px;
  height: 15px;
  min-height: 15px;
  background-size: 175px 46px;
  margin: 0 0 0 4px;
}

.orgs_team__members_dot {
  display: block !important;
  width: 7px !important;
  height: 7px !important;
  min-width: 7px !important;
  min-height: 7px !important;
  border-radius: 50% !important;
  opacity: 0.5;
}
.orgs_team__members_dot--cl {
  background-color: rgb(0, 173, 208) !important;
}
.orgs_team__members_dot--id {
  background-color: rgb(255, 121, 0) !important;
}
.orgs_team__members_dot--dv {
  background-color: rgb(105, 190, 40) !important;
}
.orgs_team__members_dot--im {
  background-color: rgb(245, 67, 89) !important;
}

app-member-side-bar .profile_types.no-profile {
  background-image: url("https://assets.foursightonline.com/app/images/foursight-profile-types.svg") !important;
  width: 34px !important;
  height: 15px !important;
  background-size: 175px 46px !important;
}
app-member-side-bar .profile_types.no-profile::after {
  content: none !important;
  display: none !important;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/_variables.scss","webpack://./src/app/components/org-individual-teams/org-individual-teams.component.scss","webpack://./src/app/components/teams/teams.component.scss"],"names":[],"mappings":"AAgIA;EACE,eAAA;AC/HF;;ADkIA;EACE,aAAA;EACA,eAAA;AC/HF;;ADkIA;EACE,sBAAA;AC/HF;;ADkIA;EACE,8BAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;ADkIA;EACE,aAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;AD6IE;;;;;;EAME,YAAA;EACA,wBA7KO;EA8KP,cA3IiB;EA4IjB,0BAAA;EACA,aAAA;AC1IJ;AD4II;;;;;;EACE,gBAAA;ACrIN;ADyIE;;EAEE,eA5GO;EA6GP,gBA3GO;AC5BX;ADyII;EALF;;IAMI,eA/GY;ECtBhB;AACF;ADwIE;;EAEE,eAlHO;EAmHP,gBAjHO;ACrBX;ADwII;EALF;;IAMI,eArHY;ECfhB;AACF;ADuIE;;EAEE,eAxHO;EAyHP,gBAvHO;ACdX;ADuII;EALF;;IAMI,eA3HY;ECRhB;AACF;ADsIE;;EAEE,eA9HO;EA+HP,gBA7HO;ACPX;ADuIE;;EAEE,eAhIO;EAiIP,gBAhIO;ACLX;ADwIE;;EAEE,eAnIO;EAoIP,gBAnIO;ACHX;AD4IE;EACE,eAAA;EACA,gBAAA;EACA,cAzMqB;EA0MrB,aAAA;EACA,mBAAA;AC1IJ;AD4II;EACE,gBAAA;AC1IN;AD6II;EAXF;IAYI,eAAA;EC1IJ;AACF;AD6IE;;EAEE,UAAA;EACA,SAAA;AC3IJ;AD8IE;EACE,gBAAA;EACA,kBAAA;EACA,QAAA;EACA,qBAAA;EACA,mBAAA;AC5IJ;;ADgJA;EACE,sBAxNQ;AC2EV;;ADgJA;EACE,iBAlKU;EAmKV,wBAAA;EACA,mBAAA;AC7IF;AD+IE;EALF;IAMI,cAAA;EC5IF;AACF;AD8IE;EACE,iBA1Ka;AC8BjB;AD+IE;EACE,gBApLa;EAqLb,WAAA;AC7IJ;;ADkJE;EACE,kBAAA;AC/IJ;ADkJE;EACE,iBAAA;AChJJ;;ADqJE;EACE,aAAA;AClJJ;;ADsJA;EACE,kBAAA;ACnJF;ADqJE;EACE,mBAAA;ACnJJ;ADuJI;EACE,sBAAA;ACrJN;ADyJE;EACE,gBAAA;EACA,WAAA;EACA,mBAAA;EACA,eA9Ne;ACuEnB;ADyJI;EACE,sBAAA;ACvJN;AD0JI;EAVF;IAWI,eApOoB;EC6ExB;AACF;AD0JE;EACE,aAAA;EACA,eAAA;EACA,uBAAA;EACA,mBAAA;ACxJJ;AD0JI;EACE,sBAAA;ACxJN;AD2JI;EACE,WAAA;ACzJN;AD4JI;EACE,kBAAA;EACA,oBAAA;EACA,eAAA;EACA,4BA5VM;ACkMZ;;AD+JA;EACE,mBA1PO;AC8FT;AD8JE;EAHF;IAII,mBAAA;EC3JF;AACF;AD6JE;EACE,mBAAA;AC3JJ;AD8JE;EACE,aArQK;ACyGT;AD8JI;EAHF;IAII,aAAA;EC3JJ;AACF;AD6JI;EACE,aAAA;AC3JN;;ADgKA;EACE,gBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,+CAAA;EACA,mBAAA;EACA,kBAAA;AC7JF;AD+JE;EACE,eAAA;AC7JJ;ADgKE;EACE,sCAAA;AC9JJ;ADiKE;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,uBAAA;EACA,oNAAA;AC/JJ;;AD8KE;EACE,eAAA;EACA,gBAAA;EACA,cA/XqB;EAgYrB,gBAAA;EACA,kBAAA;EACA,kBAAA;AC3KJ;AD6KI;EACE,kBAAA;AC3KN;AD8KI;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EACA,WAAA;EACA,mCAAA;AC5KN;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,+BAAA;AC9KF;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,mBAAA;EACA,oBAAA;EACA,mCAzbc;EA0bd,WAzZS;EA0ZT,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,wBAhdS;EAidT,qBAAA;EACA,qBAAA;EACA,kBAAA;EACA,iCAAA;AC9KF;ADgLE;EACE,2BAAA;EACA,mBAAA;AC9KJ;ADiLE;EACE,yBAzbiB;EA0bjB,WA1aO;AC2PX;ADkLE;EACE,eAAA;EACA,mBAAA;EACA,oBAAA;AChLJ;ADmLE;EACE,yBAjckB;EAkclB,cArciB;ACoRrB;ADoLE;EACE,yBAvbS;EAwbT,WA1bO;ACwQX;ADoLI;EACE,6BAAA;AClLN;;ADuLA;EACE;IACE,uBAAA;ECpLF;EDuLA;IACE,yBAAA;ECrLF;AACF;ADwLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,+BAAA;ACtLF;;ADyLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,qBAAA;ACtLF;;ADyLA;EACE,UAAA;ACtLF;ADwLE;EACE,qBAAA;ACtLJ;;AD0LA;EACE,UAAA;ACvLF;;AD2LE;EACE,YAAA;EACA,oCAAA;EAEA,aAAA;EACA,eAAA;EACA,gCAAA;ACzLJ;AD4LM;EACE,mBAAA;AC1LR;AD+LE;EACE,2BAAA;AC7LJ;ADgME;EACE,uBAAA;AC9LJ;ADiME;EACE,mBAAA;AC/LJ;;ADoME;EACE,mBAAA;ACjMJ;ADoME;EACE,yBAAA;AClMJ;ADqME;EACE,sBAAA;ACnMJ;ADsME;EACE,uBAAA;ACpMJ;ADuME;EACE,oBAAA;ACrMJ;;AD/QA;EACE,eAAA;ACkRF;;AD/QA;EACE,aAAA;EACA,eAAA;ACkRF;;AD/QA;EACE,sBAAA;ACkRF;;AD/QA;EACE,8BAAA;ACkRF;;AD/QA;EACE,gBAAA;ACkRF;;AD/QA;EACE,gBAAA;ACkRF;;AD/QA;EACE,aAAA;ACkRF;;AD/QA;EACE,gBAAA;ACkRF;;ADpQE;;;;;;EAME,YAAA;EACA,wBA7KO;EA8KP,cA3IiB;EA4IjB,0BAAA;EACA,aAAA;ACuQJ;ADrQI;;;;;;EACE,gBAAA;AC4QN;ADxQE;;EAEE,eA5GO;EA6GP,gBA3GO;ACqXX;ADxQI;EALF;;IAMI,eA/GY;EC2XhB;AACF;ADzQE;;EAEE,eAlHO;EAmHP,gBAjHO;AC4XX;ADzQI;EALF;;IAMI,eArHY;ECkYhB;AACF;AD1QE;;EAEE,eAxHO;EAyHP,gBAvHO;ACmYX;AD1QI;EALF;;IAMI,eA3HY;ECyYhB;AACF;AD3QE;;EAEE,eA9HO;EA+HP,gBA7HO;AC0YX;AD1QE;;EAEE,eAhIO;EAiIP,gBAhIO;AC4YX;ADzQE;;EAEE,eAnIO;EAoIP,gBAnIO;AC8YX;ADrQE;EACE,eAAA;EACA,gBAAA;EACA,cAzMqB;EA0MrB,aAAA;EACA,mBAAA;ACuQJ;ADrQI;EACE,gBAAA;ACuQN;ADpQI;EAXF;IAYI,eAAA;ECuQJ;AACF;ADpQE;;EAEE,UAAA;EACA,SAAA;ACsQJ;ADnQE;EACE,gBAAA;EACA,kBAAA;EACA,QAAA;EACA,qBAAA;EACA,mBAAA;ACqQJ;;ADjQA;EACE,sBAxNQ;AC4dV;;ADjQA;EACE,iBAlKU;EAmKV,wBAAA;EACA,mBAAA;ACoQF;ADlQE;EALF;IAMI,cAAA;ECqQF;AACF;ADnQE;EACE,iBA1Ka;AC+ajB;ADlQE;EACE,gBApLa;EAqLb,WAAA;ACoQJ;;AD/PE;EACE,kBAAA;ACkQJ;AD/PE;EACE,iBAAA;ACiQJ;;AD5PE;EACE,aAAA;AC+PJ;;AD3PA;EACE,kBAAA;AC8PF;AD5PE;EACE,mBAAA;AC8PJ;AD1PI;EACE,sBAAA;AC4PN;ADxPE;EACE,gBAAA;EACA,WAAA;EACA,mBAAA;EACA,eA9Ne;ACwdnB;ADxPI;EACE,sBAAA;AC0PN;ADvPI;EAVF;IAWI,eApOoB;EC8dxB;AACF;ADvPE;EACE,aAAA;EACA,eAAA;EACA,uBAAA;EACA,mBAAA;ACyPJ;ADvPI;EACE,sBAAA;ACyPN;ADtPI;EACE,WAAA;ACwPN;ADrPI;EACE,kBAAA;EACA,oBAAA;EACA,eAAA;EACA,4BA5VM;ACmlBZ;;ADlPA;EACE,mBA1PO;AC+eT;ADnPE;EAHF;IAII,mBAAA;ECsPF;AACF;ADpPE;EACE,mBAAA;ACsPJ;ADnPE;EACE,aArQK;AC0fT;ADnPI;EAHF;IAII,aAAA;ECsPJ;AACF;ADpPI;EACE,aAAA;ACsPN;;ADjPA;EACE,gBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,+CAAA;EACA,mBAAA;EACA,kBAAA;ACoPF;ADlPE;EACE,eAAA;ACoPJ;ADjPE;EACE,sCAAA;ACmPJ;ADhPE;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,uBAAA;EACA,oNAAA;ACkPJ;;ADnOE;EACE,eAAA;EACA,gBAAA;EACA,cA/XqB;EAgYrB,gBAAA;EACA,kBAAA;EACA,kBAAA;ACsOJ;ADpOI;EACE,kBAAA;ACsON;ADnOI;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EACA,WAAA;EACA,mCAAA;ACqON;;ADhOA;EACE,8BAAA;ACmOF;;ADhOA;EACE,8BAAA;ACmOF;;ADhOA;EACE,+BAAA;ACmOF;;ADhOA;EACE,8BAAA;ACmOF;;ADhOA;EACE,mBAAA;EACA,oBAAA;EACA,mCAzbc;EA0bd,WAzZS;EA0ZT,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,wBAhdS;EAidT,qBAAA;EACA,qBAAA;EACA,kBAAA;EACA,iCAAA;ACmOF;ADjOE;EACE,2BAAA;EACA,mBAAA;ACmOJ;ADhOE;EACE,yBAzbiB;EA0bjB,WA1aO;AC4oBX;AD/NE;EACE,eAAA;EACA,mBAAA;EACA,oBAAA;ACiOJ;AD9NE;EACE,yBAjckB;EAkclB,cArciB;ACqqBrB;AD7NE;EACE,yBAvbS;EAwbT,WA1bO;ACypBX;AD7NI;EACE,6BAAA;AC+NN;;AD1NA;EACE;IACE,uBAAA;EC6NF;ED1NA;IACE,yBAAA;EC4NF;AACF;ADzNA;EACE,8BAAA;AC2NF;;ADxNA;EACE,8BAAA;AC2NF;;ADxNA;EACE,+BAAA;AC2NF;;ADxNA;EACE,8BAAA;AC2NF;;ADxNA;EACE,qBAAA;AC2NF;;ADxNA;EACE,UAAA;AC2NF;ADzNE;EACE,qBAAA;AC2NJ;;ADvNA;EACE,UAAA;AC0NF;;ADtNE;EACE,YAAA;EACA,oCAAA;EAEA,aAAA;EACA,eAAA;EACA,gCAAA;ACwNJ;ADrNM;EACE,mBAAA;ACuNR;ADlNE;EACE,2BAAA;ACoNJ;ADjNE;EACE,uBAAA;ACmNJ;ADhNE;EACE,mBAAA;ACkNJ;;AD7ME;EACE,mBAAA;ACgNJ;AD7ME;EACE,yBAAA;AC+MJ;AD5ME;EACE,sBAAA;AC8MJ;AD3ME;EACE,uBAAA;AC6MJ;AD1ME;EACE,oBAAA;AC4MJ;;AC7xBA;EACE,YAAA;EACA,WAAA;EACA,qBAAA;EACA,kBAAA;ADgyBF;;AC7xBA;EACE,yBAAA;EACA,kBAAA;ADgyBF;;AC7xBA;EACE,cAAA;ADgyBF;;AC7xBA;EACE,yBAAA;EACA,cAAA;ADgyBF;;AC7xBA;EACE,eAAA;ADgyBF;;AC7xBA;EACE,iBAAA;EACA,mBAAA;ADgyBF;;AC5xBE;EACE,kBAAA;AD+xBJ;AC7xBI;EACE,sBAAA;AD+xBN;AC5xBI;EACE,aAAA;EACA,kBAAA;EACA,MAAA;EACA,WAAA;EACA,SAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,uBAAA;EACA,kBAAA;EACA,eAAA;EACA,uBAAA;EACA,uBAAA;EACA,sBAAA;EACA,WFgBa;EEfb,2BAAA;EACA,6BAAA;EACA,mCAAA;EACA,2CAAA;AD8xBN;AC1xBM;EACE,cAAA;AD4xBR;;ACrxBE;EACE,gBAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;ADwxBJ;ACtxBI;EACE,wBF3DU;ACm1BhB;ACrxBI;EAdF;IAeI,oBAAA;EDwxBJ;AACF;ACtxBI;EACE,SAAA;ADwxBN;ACrxBI;EACE,iBAAA;EACA,gBAAA;ADuxBN;ACrxBM;EAJF;IAKI,oBAAA;EDwxBN;AACF;ACrxBQ;EACE,eAAA;EACA,gBAAA;ADuxBV;AClxBI;EACE,6BAAA;EACA,4BAAA;ADoxBN;ACjxBI;EACE,iBAAA;EACA,eAAA;ADmxBN;ACjxBM;EACE,WAAA;EACA,gBAAA;ADmxBR;AC7wBI;EACE,WAAA;AD+wBN;AC7wBM;EACE,eAAA;EACA,gBAAA;EACA,cFjGa;EEkGb,aAAA;AD+wBR;AC7wBQ;EACE,eAAA;AD+wBV;AC3wBM;EACE,eAAA;AD6wBR;ACzwBI;EACE,qBAAA;AD2wBN;ACxwBQ;EACE,6BAAA;EACA,UAAA;EACA,cFrHW;EEsHX,qBAzJK;ADm6Bf;ACxwBU;EACE,qBAAA;EACA,iBAAA;AD0wBZ;ACxwBY;EACE,+BAAA;AD0wBd;ACjwBI;EACE,yBAAA;EACA,yBAAA;ADmwBN;AC/vBU;EACE,yBFrIU;ACs4BtB;AC9vBU;EACE,yBAAA;ADgwBZ;AC7vBU;EACE,SAAA;AD+vBZ;AC1vBM;EACE,aAAA;AD4vBR;AC1vBQ;EACE,kBAAA;EACA,eAAA;AD4vBV;AC1vBU;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,WAAA;EACA,yBAAA;EACA,kBAAA;AD4vBZ;ACxvBQ;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,+BAAA;EACA,gCAAA;EACA,aAAA;EACA,WAAA;EACA,UAAA;AD0vBV;;ACnvBA;EACE,sBAAA;EACA,cF/LmB;EEgMnB,SAAA;ADsvBF;;ACnvBA;EACE,kBAAA;ADsvBF;;ACnvBA;EACE,yBFhMoB;ACs7BtB;;ACnvBA;EACE,cF5MmB;ACk8BrB;;ACnvBA;EACE,cAAA;EACA,gBAAA;EACA,qBAAA;EACA,gBAAA;EACA,yBFpNmB;EEqNnB,kBAAA;EACA,WAAA;ADsvBF;ACpvBE;EACE,iCAAA;EACA,yBAAA;EACA,6BAAA;EACA,oCAAA;ADsvBJ;;AClvBA;EACE,yBAAA;EACA,kBAAA;EACA,aAAA;ADqvBF;ACnvBE;EACE,0BAAA;EACA,yBAAA;ADqvBJ;AClvBE;EACE,SAAA;ADovBJ;AChvBI;EACE;IACE,WAAA;EDkvBN;AACF;AC9uBE;EACE,mBAAA;ADgvBJ;AC9uBI;EACE,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,gBAAA;ADgvBN;AC9uBM;EACE,kBAAA;EACA,YAAA;ADgvBR;AC7uBM;EACE,gBAAA;AD+uBR;AC5uBM;EACE,yBFjQc;EEkQd,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;AD8uBR;AC7uBQ;EACE,kBAAA;EACA,YAAA;AD+uBV;AC5uBQ;EACE,cFpRW;EEqRX,aAAA;EACA,eAAA;AD8uBV;AC1uBM;EACE,kBAAA;EACA,kBAAA;AD4uBR;AC1uBQ;EAEE,mBAAA;AD2uBV;ACxuBQ;EACE,6BAAA;AD0uBV;ACvuBQ;EACE,iBAAA;EACA,gBAAA;EACA,yBAAA;ADyuBV;ACvuBU;EACE,gBAAA;ADyuBZ;ACruBQ;EACE,aAAA;ADuuBV;ACpuBQ;EACE,cFtTW;AC4hCrB;ACnuBQ;;EAEE,kBAAA;EACA,UAAA;ADquBV;ACnuBU;;EACE,mBAAA;ADsuBZ;ACluBQ;EACE,gBAAA;EACA,eAAA;ADouBV;ACjuBQ;;EAEE,gBAAA;EACA,eAAA;ADmuBV;AChuBQ;EACE,gBAAA;EACA,6BAAA;EACA,cAAA;ADkuBV;AC/tBQ;EACE,kBAAA;EACA,kBAAA;EACA,YAAA;EACA,QAAA;EACA,OAAA;EACA,sDAAA;EACA,iBAAA;ADiuBV;AC3sBU;EACE,gCAAA;EACA,kBAAA;EACA,mBAAA;AD6sBZ;AC1sBU;EACE;IACE,UAAA;IACA,WAAA;IACA,gBAAA;ED4sBZ;AACF;ACxsBY;EACE,wBF7YE;ACulChB;ACvsBY;EACE,iBAAA;ADysBd;ACpsBQ;EACE,aAAA;EACA,qCAAA;EACA,cAAA;ADssBV;ACpsBU;EALF;IAMI,qCAAA;EDusBV;AACF;ACpsBY;EACE,kCFnaE;ACymChB;ACnsBY;EACE,cFzZO;EE0ZP,gBAAA;ADqsBd;ACnsBc;EACE,uBF3aA;ACgnChB;AC/rBY;EACE,kCFjbC;ACknCf;AC9rBY;EACE,cFxaO;EEyaP,gBAAA;ADgsBd;AC9rBc;EACE,uBFzbD;ACynCf;AC1rBY;EACE,mCF/bE;AC2nChB;ACzrBY;EACE,cFvbO;EEwbP,gBAAA;AD2rBd;ACzrBc;EACE,wBFvcA;ACkoChB;ACrrBY;EACE,kCF7cI;ACooClB;ACprBY;EACE,cFtcO;EEucP,gBAAA;ADsrBd;ACprBc;EACE,uBFrdE;AC2oClB;ACjrBU;EACE,iBAAA;EACA,kBAAA;EACA,kCAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;ADmrBZ;ACjrBY;EACE,mBAAA;ADmrBd;AC/qBU;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,aAAA;ADirBZ;AC/qBY;EACE,kBAAA;ADirBd;AC9qBY;EACE,WAAA;EACA,oBAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,mBFreQ;EEseR,gBAAA;ADgrBd;AC5qBU;EACE,SAAA;EACA,UAAA;EACA,gBAAA;AD8qBZ;AC5qBY;EACE,mBAAA;AD8qBd;AC3qBY;EACE,kBAAA;AD6qBd;ACvqBI;EACE,eAAA;EACA,kBAAA;EACA,kBAAA;ADyqBN;ACnqBM;EACE,UAAA;ADqqBR;ACjqBI;EACE,yBFzgBgB;EE0gBhB,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,cFrhBe;EEshBf,0BAAA;ADmqBN;ACjqBM;EACE,gBAAA;ADmqBR;ACjqBQ;EACE,aAAA;ADmqBV;AChqBQ;EACE,kBAAA;ADkqBV;AChqBU;EACE,eAAA;ADkqBZ;AChqBY;EACE,aAAA;EACA,kBAAA;EACA,qBAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,SAAA;EACA,2BAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;ADkqBd;AChqBc;EACE,WAAA;EACA,WAAA;EACA,WAAA;EACA,yCAAA;EACA,sBFniBL;EEoiBK,kBAAA;EACA,QAAA;EACA,SAAA;EACA,2BAAA;ADkqBhB;AC1pBI;EACE,UAAA;EACA,iBAAA;AD4pBN;AC3pBM;EACE,eAAA;EACA,gBAAA;EACA,gCAAA;EACA,oBAAA;EACA,SAAA;AD6pBR;AC1pBM;EACE,cFhlBa;EEilBb,YAAA;AD4pBR;AC1pBQ;EACE,mBAAA;EACA,+BAAA;AD4pBV;AC1pBU;EACE,eAAA;AD4pBZ;ACzpBU;EACE,wCAAA;EACA,2BAAA;AD2pBZ;ACtpBM;EACE,kBAAA;EACA,YAAA;ADwpBR;ACtpBQ;EACE,iBAAA;EACA,SAAA;ADwpBV;ACrpBQ;EACE,yBAAA;ADupBV;ACppBQ;EACE,WAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;ADspBV;ACnpBQ;EACE,cF5nBW;EE6nBX,SAAA;EACA,wEAAA;EAEA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;ADopBV;ACjpBQ;EACE,qBAAA;EACA,eAAA;EACA,iBAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;ADmpBV;AC9oBI;EACE,UAAA;EACA,iBAAA;ADgpBN;AC5oBE;EACE,aAAA;EACA,sBAAA;EACA,eAAA;EACA,cAAA;AD8oBJ;AC5oBI;EACE,gBAAA;EACA,SAAA;AD8oBN;AC3oBI;EACE,OAAA;EACA,gBAAA;EACA,kBAAA;AD6oBN;AC3oBM;EALF;IAMI,UAAA;ED8oBN;AACF;AC1oBE;EACE,0BAAA;AD4oBJ;;ACtoBI;EACE,gBAAA;ADyoBN;ACroBE;EACE,aAAA;EACA,SAAA;EACA,yDAAA;EACA,sCAAA;ADuoBJ;ACroBI;EANF;IAOI,0BAAA;EDwoBJ;AACF;ACroBE;EACE,sBAAA;EACA,iBAAA;ADuoBJ;ACpoBE;EACE,yBAAA;EACA,kBAAA;ADsoBJ;ACnoBE;EACE,0BAAA;EACA,yBAAA;ADqoBJ;ACjoBI;EADF;IAEI,UAAA;EDooBJ;AACF;ACloBI;EALF;IAMI,WAAA;EDqoBJ;AACF;ACjoBI;EADF;IAEI,WAAA;EDooBJ;AACF;ACjoBE;EACE,gBAAA;EACA,aAAA;EACA,sBAAA;ADmoBJ;ACjoBI;EALF;IAMI,eAAA;EDooBJ;AACF;ACjoBM;EACE,UAAA;EACA,mCF3vBQ;AC83ChB;AC9nBE;EACE,yBF7uBkB;EE8uBlB,0BAAA;EACA,0BAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,cAAA;ADgoBJ;AC9nBI;EACE,sBFzuBK;ACy2CX;AC7nBI;EACE,yBAAA;AD+nBN;AC5nBI;EACE,eAAA;EACA,wEF1yBO;EE2yBP,cFxwBe;EEywBf,gBAAA;EACA,OAAA;AD8nBN;AC5nBM;EACE,0BAAA;EACA,qBAAA;AD8nBR;ACznBU;EACE,aAAA;AD2nBZ;ACznBU;EACE,qBAAA;AD2nBZ;ACvnBQ;EACE,aAAA;ADynBV;ACrnBM;EACE,SAAA;ADunBR;ACrnBQ;EACE,WAAA;EACA,yBFryBW;EEsyBX,yBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;ADunBV;ACrnBU;EACE,aAAA;EACA,YAAA;EACA,cAAA;EACA,sBAAA;EACA,kBAAA;EACA,kBAAA;EACA,YAAA;EACA,uCAAA;EACA,eAAA;EACA,oCAAA;EACA,gBAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,UAAA;ADunBZ;ACnnBY;EACE,cAAA;ADqnBd;AC9mBI;EACE,yBF/zBa;EEg0Bb,WFtzBK;EEuzBL,gBAAA;EACA,YAAA;EACA,eAAA;ADgnBN;AC7mBI;EACE,sBF7zBK;EE8zBL,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,cFv1Be;EEw1Bf,wEF33BO;EE43BP,gBAAA;AD+mBN;AC5mBI;EACE,YAAA;EACA,mBAAA;AD8mBN;AC1mBE;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;AD4mBJ;AC1mBI;EACE,iBAAA;EACA,iBAAA;EACA,gBAAA;AD4mBN;ACzmBI;EACE,6BAAA;AD2mBN;ACxmBI;EACE,cAAA;EACA,sBAAA;AD0mBN;ACvmBI;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,cAAA;ADymBN;ACvmBM;EACE,cAAA;ADymBR;ACtmBM;EACE,sBAAA;EACA,mBAAA;EACA,UAAA;EACA,qBAAA;ADwmBR;ACrmBM;EACE,+BAAA;ADumBR;ACrmBQ;EACE,eAAA;ADumBV;ACnmBM;EACE,cAAA;ADqmBR;AClmBM;EACE,aAAA;ADomBR;AClmBQ;EACE,qBAAA;ADomBV;AChmBM;EACE,qBAAA;EACA,yBAAA;EACA,cAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;ADkmBR;AChmBQ;EACE,6BAAA;EACA,cAAA;EACA,UAAA;EACA,gBAAA;EACA,gBAAA;ADkmBV;AC9lBM;EAxDF;IAyDI,WAAA;EDimBN;AACF;AC/lBM;EACE,UAAA;EACA,iBAAA;EACA,iBAAA;ADimBR;AC7lBI;EACE,iBAAA;EACA,WAAA;AD+lBN;AC5lBI;EACE,cFj8Be;EEk8Bf,eAAA;EACA,gBAAA;AD8lBN;ACxlBM;EAHF;IAII,iBAAA;ED2lBN;AACF;ACvlBE;EACE,aAAA;ADylBJ;ACvlBI;EACE,UAAA;EACA,yBAAA;EACA,yBAAA;EACA,gBAAA;ADylBN;ACvlBM;;EAEE,oCAAA;EACA,YAAA;EACA,eAAA;ADylBR;ACvlBQ;;EACE,kBAAA;AD0lBV;ACtlBM;EACE,gBAAA;ADwlBR;ACrlBM;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,aAAA;EACA,gBAAA;ADulBR;ACrlBQ;EACE,gBAAA;ADulBV;ACnlBM;EACE,sBAAA;ADqlBR;ACnlBQ;EACE,aAAA;ADqlBV;AC/kBE;EACE,aAAA;ADilBJ;AC/kBI;EACE,UAAA;ADilBN;AC/kBM;EACE,iBAAA;ADilBR;AC/kBQ;EACE,mBAAA;ADilBV;AC9kBQ;EACE,eAAA;EACA,gBAAA;ADglBV;AC5kBM;EACE,SAAA;EACA,mBAAA;AD8kBR;AC5kBQ;EACE,kBAAA;AD8kBV;AClkBE;EACE,aAAA;EACA,eAAA;EACA,6BAAA;EACA,gCAAA;ADokBJ;AClkBI;EACE,OAAA;EACA,SAAA;EACA,cF1iCe;EE2iCf,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,6BAAA;EACA,eAAA;EACA,kBAAA;ADokBN;AClkBM;EACE,yBFtiCO;AC0mDf;AC7jBM;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,OAAA;EACA,WAAA;EACA,mCF1kCY;EE2kCZ,UAAA;AD+jBR;AC5jBM;EACE,+BAAA;AD8jBR;ACzjBE;EACE,iCAAA;EACA,WAAA;AD2jBJ;ACzjBI;EACE,cFjlCe;EEklCf,yBFvkCa;EEwkCb,qBAAA;EACA,gBAAA;EACA,eAAA;EACA,WAAA;EACA,kBAAA;EACA,SAAA;AD2jBN;ACtjBI;EACE,UAAA;ADwjBN;ACrjBI;EACE,cAAA;ADujBN;ACpjBI;EACE,cAAA;ADsjBN;ACnjBI;EACE,oBAAA;EACA,mBAAA;ADqjBN;ACjjBE;EACE,WAAA;EACA,6BAAA;ADmjBJ;ACjjBI;EACE,eAAA;EACA,gBAAA;ADmjBN;AChjBI;EACE,eAAA;EACA,YAAA;ADkjBN;AC/iBI;EACE,yBAAA;EACA,WAAA;EACA,aAAA;EACA,gBAAA;EACA,eAAA;ADijBN;AC/iBM;EACE,aAAA;ADijBR;AC5iBI;EACE,cAAA;EACA,iBAAA;AD8iBN;AC3iBI;EACE,iBAAA;AD6iBN;AC1iBI;EACE,yBAAA;EACA,aAAA;EACA,oBAAA;AD4iBN;ACtiBM;EACE,oBAAA;ADwiBR;ACriBM;EACE,0BAAA;ADuiBR;ACpiBM;EACE,SAAA;EACA,eAAA;ADsiBR;ACniBM;EACE,qBAAA;EACA,eAAA;EACA,iBAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;ADqiBR;ACliBM;EACE,WAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;ADoiBR;ACjiBM;EACE,cF/rCa;EEgsCb,SAAA;EACA,wEAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;ADmiBR;AChiBM;EACE,gCAAA;ADkiBR;AC9hBQ;;EAEE,0BAAA;ADgiBV;AC7hBQ;EACE,eAAA;AD+hBV;AC1hBI;EACE,oBAAA;AD4hBN;ACzhBI;EACE,yBAAA;EACA,iBAAA;EACA,kBAAA;AD2hBN;ACvhBE;EACE,yBAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,OAAA;ADyhBJ;ACvhBI;EACE,SAAA;ADyhBN;ACrhBE;EACE,aAAA;ADuhBJ;ACnhBQ;EACE,aAAA;ADqhBV;ACjhBM;EACE,aAAA;EACA,uBAAA;ADmhBR;AC/gBU;EACE,kCAAA;EACA,kCF/wCI;EEgxCJ,kCAAA;EACA,4BAAA;ADihBZ;AC3gBU;EACE,kCAAA;EACA,kCFxxCG;EEyxCH,kCAAA;EACA,4BAAA;AD6gBZ;ACvgBU;EACE,mCAAA;EACA,mCFjyCI;EEkyCJ,mCAAA;EACA,4BAAA;ADygBZ;ACngBU;EACE,kCAAA;EACA,kCF1yCM;EE2yCN,kCAAA;EACA,4BAAA;ADqgBZ;ACjgBQ;EACE,uBAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,8BAAA;ADmgBV;AClgBU;EATF;IAUI,uBAAA;IACA,sBAAA;EDqgBV;AACF;ACjgBM;EACE,oCAAA;ADmgBR;AChgBM;EACE,oCAAA;ADkgBR;AC/fM;EACE,oCAAA;ADigBR;AC9fM;EACE,oCAAA;ADggBR;AC7fM;EACE,oCAAA;AD+fR;AC5fM;EACE,oCAAA;AD8fR;AC3fM;EACE,oCAAA;AD6fR;AC1fM;EACE,oCAAA;AD4fR;ACxfI;EACE,UAAA;AD0fN;ACvfI;EACE,yBAAA;EACA,eAAA;ADyfN;ACvfM;EACE,yBFj1CO;EEk1CP,YAAA;EACA,eAAA;ADyfR;ACpfU;EACE,qBAAA;EACA,+BAAA;EACA,YAAA;ADsfZ;AC/eE;EACE,SAAA;ADifJ;AC/eI;EACE,aAAA;EACA,iBAAA;EACA,gBAAA;EACA,yBF/2CgB;EEg3ChB,0BAAA;ADifN;AC/eM;EACE,WAAA;EACA,eAAA;EACA,gBAAA;ADifR;AC/eQ;EACE,gBAAA;ADifV;AC5eQ;EACE,aAAA;AD8eV;ACzeI;EACE,UAAA;EACA,yBAAA;EACA,0BAAA;AD2eN;ACzeM;EACE,gBAAA;AD2eR;ACzeQ;EACE,eAAA;EACA,cFr5CW;ACg4DrB;ACzeU;EACE,oBAAA;EACA,sBAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,WAAA;EACA,QAAA;AD2eZ;ACzeY;EACE,kBAAA;EACA,SAAA;EACA,2BAAA;AD2ed;ACzec;EACE,MAAA;AD2ehB;ACxec;EACE,SAAA;AD0ehB;ACpeQ;EACE,cFj7CW;ACu5DrB;ACneY;EACE,kBAAA;EACA,yBFt7CO;EEu7CP,WFl6CH;EEm6CG,oBAAA;EACA,eAAA;EACA,gBAAA;ADqed;ACheY;EACE,qBAAA;EACA,mCAAA;EACA,wBF98CE;EE+8CF,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,iCAAA;EACA,kBAAA;EACA,gBAAA;ADked;AChec;EACE,mCFv9CA;EEw9CA,WFv7CL;ACy5DX;AC7dU;EACE,cAAA;AD+dZ;AC5dU;EACE,qBAAA;EACA,yBAAA;EACA,cFx9CS;EEy9CT,YAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;AD8dZ;AC1dQ;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,aAAA;EACA,gBAAA;AD4dV;AC1dU;EACE,gBAAA;AD4dZ;ACzdU;EACE,sBAAA;AD2dZ;;ACndA;EACE,aAAA;ADsdF;;ACndA;EACE,2BAAA;ADsdF;;ACpdA;EACE;IACE,WAAA;EDudF;AACF;ACrdA;EACE,SAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;ADudF;;ACndE;EACE,QAAA;EACA,UAAA;ADsdJ;ACpdI;EACE,UAAA;EACA,UAAA;ADsdN;;AChdE;EACE,sBAAA;EACA,QAAA;EACA,YAAA;EACA,UAAA;ADmdJ;ACjdI;EACE,SAAA;EACA,UAAA;EACA,WAAA;EACA,UAAA;EACA,4CAAA;ADmdN;;AC9cA;EACE,mBAAA;ADidF;AChdE;EACE,gBAAA;EACA,iBAAA;ADkdJ;AC/cE;EACE,mBAAA;ADidJ;AC9cE;EACE,aAAA;EACA,qCAAA;ADgdJ;AC9cI;EAJF;IAKI,0BAAA;IACA,kBAAA;EDidJ;AACF;AC9cE;EACE,kBAAA;ADgdJ;AC9cI;EAHF;IAII,aAAA;EDidJ;AACF;AC/cI;EACE,mBAAA;ADidN;AC9cI;EACE,8BAAA;EACA,yBFlkDgB;ACkhEtB;AC9cM;EAJF;IAKI,kBAAA;EDidN;AACF;AC9cI;EACE,8BAAA;EACA,yBAAA;ADgdN;AC9cM;EAJF;IAKI,kBAAA;EDidN;AACF;AC/cM;EACE,yBAAA;ADidR;AC7cI;EACE,aAAA;EACA,eAAA;EACA,cAAA;AD+cN;AC7cM;EACE,OAAA;AD+cR;AC7cQ;EACE,eAAA;EACA,gBAAA;EACA,cFzmDW;ACwjErB;AC7cU;EACE,cAAA;EACA,eAAA;EACA,gBAAA;AD+cZ;AC1cM;EACE,YAAA;AD4cR;ACvcM;;EAEE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;ADycR;ACvcQ;;EACE,0BAAA;AD0cV;ACvcQ;;EACE,6BAAA;EACA,SAAA;EACA,cFtmDK;EEumDL,eAAA;AD0cV;ACrcI;EACE,kBAAA;EACA,sBAAA;ADucN;ACrcM;EACE,gCAAA;EACA,kBAAA;EACA,cFppDa;EEqpDb,eAAA;EACA,gBAAA;ADucR;ACpcM;EACE,oCAAA;EACA,kBAAA;ADscR;ACpcQ;EACE,gBAAA;EACA,WAAA;EACA,cAAA;EACA,mBAAA;ADscV;ACncQ;EACE,gBAAA;EACA,WAAA;EACA,mBAAA;ADqcV;AClcQ;EACE,qCAAA;EACA,kBAAA;EACA,mBAAA;ADocV;AChcM;EACE,iBAAA;EACA,mCAAA;EACA,oCAAA;EACA,aAAA;EACA,qCAAA;EACA,8BAAA;EACA,cAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;ADkcR;AC/bU;EACE,kCFhtDI;EEitDJ,iBAAA;ADicZ;AC/bY;EACE,oCAAA;ADicd;AC9bY;EACE,kCFxtDE;EEytDF,cAAA;ADgcd;AC3bY;EACE,oCAAA;AD6bd;ACzbU;EACE,kCFjuDM;EEkuDN,iBAAA;AD2bZ;ACvbY;EACE,kCFvuDI;EEwuDJ,cAAA;ADybd;ACnbU;EACE,kCFlvDI;EEmvDJ,iBAAA;ADqbZ;ACnbY;EACE,oCAAA;ADqbd;AClbY;EACE,cAAA;ADobd;AC/aY;EACE,oCAAA;ADibd;AC7aU;EACE,mCFnwDI;EEowDJ,iBAAA;AD+aZ;AC7aY;EACE,oCAAA;AD+ad;AC5aY;EACE,cAAA;AD8ad;ACxaU;EACE,kCFpxDI;EEqxDJ,iBAAA;AD0aZ;ACxaY;EACE,oCAAA;AD0ad;ACvaY;EACE,cAAA;ADyad;AClaY;EACE,oCAAA;ADoad;AChaU;EACE,mCFvyDI;EEwyDJ,iBAAA;ADkaZ;AChaY;EACE,oCAAA;ADkad;AC/ZY;EACE,cAAA;ADiad;AC1ZY;EACE,oCAAA;AD4Zd;ACxZU;EACE,kCF7zDG;EE8zDH,iBAAA;AD0ZZ;ACxZY;EACE,oCAAA;AD0Zd;ACvZY;EACE,cAAA;ADyZd;ACpZY;EACE,oCAAA;ADsZd;AClZU;EACE,kCF90DM;EE+0DN,iBAAA;ADoZZ;AChZY;EACE,cAAA;ADkZd;AC5YU;EACE,kCF91DI;EE+1DJ,iBAAA;AD8YZ;AC5YY;EACE,cAAA;AD8Yd;AC1YU;EACE,kCFt2DG;EEu2DH,iBAAA;AD4YZ;AC1YY;EACE,cAAA;AD4Yd;ACzYY;EACE,oCAAA;AD2Yd;AClYY;EACE,oCAAA;ADoYd;AChYU;EACE,mCF53DI;EE63DJ,iBAAA;ADkYZ;AChYY;EACE,cAAA;ADkYd;AC9XU;EACE,kCFp4DM;EEq4DN,iBAAA;ADgYZ;AC9XY;EACE,cAAA;ADgYd;AC1XU;EACE,kCFl5DI;EEm5DJ,iBAAA;AD4XZ;AC1XY;EACE,cAAA;AD4Xd;ACxXU;EACE,kCF15DG;EE25DH,iBAAA;AD0XZ;ACxXY;EACE,cAAA;AD0Xd;ACtXU;EACE,mCFl6DI;EEm6DJ,iBAAA;ADwXZ;ACtXY;EACE,cAAA;ADwXd;ACrXY;EACE,oCAAA;ADuXd;ACjXU;EACE,kCFn7DI;EEo7DJ,iBAAA;ADmXZ;ACjXY;EACE,cAAA;ADmXd;AC/WU;EACE,kCF37DG;EE47DH,iBAAA;ADiXZ;AC/WY;EACE,cAAA;ADiXd;AC9WY;EACE,oCAAA;ADgXd;AC3WY;EACE,oCAAA;AD6Wd;ACzWU;EACE,kCF58DM;EE68DN,iBAAA;AD2WZ;ACvWY;EACE,cAAA;ADyWd;AClWY;EACE,oCAAA;ADoWd;AChWU;EACE,kCFj+DG;EEk+DH,iBAAA;ADkWZ;AChWY;EACE,cAAA;ADkWd;AC/VY;EACE,oCAAA;ADiWd;AC1VY;EACE,oCAAA;AD4Vd;ACxVU;EACE,kCFp/DM;EEq/DN,iBAAA;AD0VZ;ACtVY;EACE,cAAA;ADwVd;AClVU;EACE,cAAA;ADoVZ;ACjVU;EACE,iBAAA;ADmVZ;ACnUY;EACE,oCAAA;ADqUd;ACjUU;EACE,kCF7hEG;EE8hEH,iBAAA;ADmUZ;ACjUY;EACE,cAAA;ADmUd;AC/TU;EACE,mCFriEI;EEsiEJ,iBAAA;ADiUZ;AC/TY;EACE,cAAA;ADiUd;AC7TU;EACE,kCF7iEM;EE8iEN,iBAAA;AD+TZ;AC7TY;EACE,cAAA;AD+Td;ACzTU;EACE,kCF3jEI;EE4jEJ,iBAAA;AD2TZ;ACzTY;EACE,oCAAA;AD2Td;ACxTY;EACE,cAAA;AD0Td;ACrTY;EACE,oCAAA;ADuTd;ACnTU;EACE,mCF5kEI;EE6kEJ,iBAAA;ADqTZ;ACjTY;EACE,cAAA;ADmTd;AC/SU;EACE,kCFtlEM;EEulEN,iBAAA;ADiTZ;AC7SY;EACE,cAAA;AD+Sd;ACxSY;EACE,oCAAA;AD0Sd;ACtSU;EACE,kCF3mEG;EE4mEH,iBAAA;ADwSZ;ACtSY;EACE,cAAA;ADwSd;ACpSU;EACE,mCFnnEI;EEonEJ,iBAAA;ADsSZ;ACpSY;EACE,oCAAA;ADsSd;ACnSY;EACE,cAAA;ADqSd;AC/RM;EACE,WAAA;EACA,eAAA;EACA,mBFhnEc;EEinEd,kBAAA;EACA,eAAA;EACA,kBAAA;ADiSR;AC/RQ;EACE,WAAA;EACA,kBAAA;EACA,sCAAA;EACA,yBAAA;EACA,kBAAA;EACA,WAAA;EACA,mBF5nEY;EE6nEZ,WAAA;EACA,sBAAA;ADiSV;AC7RU;EACE,kCFzpEI;ACw7EhB;AC1RU;EACE,kCF9pEG;AC07Ef;ACvRU;EACE,mCFnqEI;AC47EhB;ACpRU;EACE,kCFxqEM;AC87ElB;AClRQ;EACE,kBAAA;EACA,yBAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBF/pEY;EEgqEZ,WAAA;EACA,aAAA;ADoRV;AClRU;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,yBAAA;EACA,yCAAA;ADoRZ;AChRY;EACE,aAAA;ADkRd;AC/QY;EACE,gBAAA;ADiRd;AC7QU;;EAEE,eAAA;AD+QZ;AC5QU;EACE,kBAAA;EACA,gBAAA;EACA,iBAAA;AD8QZ;AC5QY;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,2BAAA;EACA,OAAA;EACA,UAAA;EACA,eAAA;EACA,sBF7rEH;EE8rEG,kBAAA;AD8Qd;AC1QU;;EAEE,gCAAA;EACA,gBAAA;EACA,gBAAA;EACA,WAAA;AD4QZ;AC1QY;;EACE,kBAAA;AD6Qd;ACvQM;EACE,kBAAA;EACA,yBAAA;EACA,SAAA;EACA,2BAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBF7uEa;EE8uEb,cAAA;EACA,aAAA;ADyQR;ACvQQ;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,2BAAA;EACA,WAAA;EACA,WAAA;EACA,yBAAA;EACA,yCAAA;ADyQV;ACrQU;EACE,aAAA;ADuQZ;ACpQU;EACE,gBAAA;ADsQZ;AClQQ;;EAEE,eAAA;ADoQV;ACjQQ;EACE,kBAAA;EACA,gBAAA;EACA,iBAAA;ADmQV;ACjQU;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,2BAAA;EACA,OAAA;EACA,UAAA;EACA,eAAA;EACA,sBFpwED;EEqwEC,kBAAA;ADmQZ;AC/PQ;;EAEE,gCAAA;EACA,gBAAA;EACA,gBAAA;EACA,WAAA;ADiQV;AC/PU;;EACE,kBAAA;ADkQZ;AC1PI;EACE,8BAAA;EACA,yBFxyEgB;EEyyEhB,iBAAA;AD4PN;AC1PM;EACE,gBAAA;AD4PR;ACzPM;EACE,eAAA;EACA,gBAAA;EACA,cF1zEa;ACqjFrB;ACvPI;EACE,gBAAA;EACA,aAAA;EACA,sDAAA;EACA,cAAA;EACA,kBAAA;EACA,yBAAA;EACA,aAAA;EACA,0BAAA;ADyPN;ACvPM;EAVF;IAWI,gBAAA;ED0PN;AACF;ACxPM;EAdF;IAeI,gBAAA;IACA,aAAA;ED2PN;AACF;ACxPI;EACE,kBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,kBAAA;AD0PN;ACxPM;EACE,gBAAA;AD0PR;ACvPM;EACE,eAAA;EACA,yBAAA;EACA,gBAAA;ADyPR;ACvPQ;EACE,mBAAA;ADyPV;ACnPU;EACE,kCFx3EI;AC6mFhB;AC9OU;EACE,kCF/3EG;AC+mFf;ACzOU;EACE,mCFt4EI;ACinFhB;ACpOU;EACE,kCF74EM;ACmnFlB;AChOI;EACE,aAAA;EACA,qCAAA;EACA,cAAA;EACA,YAAA;EACA,mBAAA;ADkON;AC5NM;EACE,eAAA;EACA,kBAAA;EACA,yBF34EW;ACymFnB;AC1NI;EACE,yBAAA;EACA,0BAAA;AD4NN;AC1NM;EACE,kBAAA;AD4NR;AC1NQ;EACE,mBAAA;EACA,oBAAA;EACA,gCAAA;AD4NV;ACxNM;EACE,aAAA;EACA,eAAA;EACA,8BAAA;EACA,wBAAA;EACA,mBAAA;EACA,kBAAA;AD0NR;ACxNQ;EARF;IASI,aAAA;IACA,qCAAA;IACA,cAAA;ED2NR;AACF;ACzNQ;EAdF;IAeI,qCAAA;ED4NR;AACF;ACzNM;EACE,YAAA;EACA,kBAAA;AD2NR;ACzNQ;EAJF;IAKI,WAAA;ED4NR;AACF;AC1NQ;EACE,eAAA;EACA,yBAAA;EACA,gBAAA;AD4NV;AC1NU;EACE,mBAAA;AD4NZ;ACvNM;EACE,aAAA;EACA,qCAAA;EACA,cAAA;EACA,YAAA;EACA,mBAAA;ADyNR;ACvNQ;EACE,eAAA;EACA,yBFv9EW;EEw9EX,kBAAA;ADyNV;ACrNU;EACE,kCF3+EI;ACksFhB;AClNU;EACE,kCFh/EG;ACosFf;AC/MU;EACE,mCFr/EI;ACssFhB;AC5MU;EACE,kCF1/EM;ACwsFlB;ACzMM;EACE,kBAAA;EACA,uBAAA;EACA,mBAAA;AD2MR;ACzMQ;EACE,eAAA;EACA,gBAAA;EACA,cF5/EW;ACusFrB;ACpMI;EACE,8BAAA;EACA,yBF7/EgB;EE8/EhB,iBAAA;ADsMN;ACpMM;EACE,eAAA;EACA,gBAAA;EACA,cF3gFa;ACitFrB;AClMI;EACE,8BAAA;EACA,yBAAA;ADoMN;AChMM;EACE,UAAA;EACA,SAAA;EACA,aAAA;EACA,eAAA;EACA,gCAAA;ADkMR;AChMQ;EACE,gBAAA;ADkMV;AChMU;EAHF;IAII,WAAA;EDmMV;AACF;AChMQ;EACE;IACE,+BAAA;EDkMV;AACF;AC9LM;EACE,cF5iFa;EE6iFb,eAAA;EACA,gBAAA;EACA,YAAA;EACA,gBAAA;EACA,SAAA;EACA,6BAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;ADgMR;AC9LQ;EAbF;IAcI,WAAA;EDiMR;AACF;AC/LQ;EACE,gBAAA;ADiMV;AC/LU;EACE,UAAA;ADiMZ;AC7LQ;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,mCFtlFM;EEulFN,WAAA;EACA,UAAA;AD+LV;AC1LI;EACE,kBAAA;AD4LN;AC1LM;EACE,mBAAA;AD4LR;ACzLM;;EAEE,kBAAA;EACA,yBAAA;EACA,aAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;AD2LR;ACzLQ;;EACE,aAAA;AD4LV;ACxLM;EACE,YAAA;AD0LR;ACvLM;EACE,kBAAA;EACA,6BFxnFQ;EEynFR,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;EACA,WAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;ADyLR;ACvLQ;EACE,yBFxnFW;ACizFrB;;AClLA;EACE,YAAA;EACA,WAAA;EACA,kBAAA;EACA,cFvnFU;EEwnFV,cAAA;EACA,mBF7nFoB;ACkzFtB;ACnLE;EACE,sBFnnFO;ACwyFX;;ACjLA;EACE,yBFloFiB;ACszFnB;AClLE;;EAEE,cFjpFiB;ACq0FrB;;AC/KA;EACE,eAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,gBAAA;EACA,wBAAA;EACA,gBAAA;EACA,sBAAA;EACA,YAAA;EACA,gDAAA;ADkLF;AChLE;EACE,aAAA;ADkLJ;AC/KE;EACE,yBF/pFkB;EEgqFlB,4BAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,cF5qFiB;EE6qFjB,kBAAA;ADiLJ;AC/KI;EACE,mBAAA;ADiLN;AC7KE;EACE,oBAAA;AD+KJ;AC7KI;EACE,mBAAA;AD+KN;AC5KI;EACE,gBAAA;EACA,eAAA;EACA,aAAA;AD8KN;AC5KM;EACE,kBAAA;AD8KR;AC1KI;EACE,SAAA;EACA,UAAA;EACA,gBAAA;AD4KN;ACzKI;;EAEE,gBAAA;EACA,eAAA;AD2KN;ACzKM;;EACE,mBAAA;AD4KR;ACvKE;EACE,qBAAA;EACA,kBAAA;EACA,kBAAA;EACA,MAAA;EACA,SAAA;EACA,WAAA;EACA,kBAAA;EACA,WAAA;EACA,eAAA;EACA,6BAAA;EACA,SAAA;EACA,UAAA;EACA,eAAA;ADyKJ;ACvKI;EAEE,mCFnvFU;AC25FhB;ACrKI;EACE,kBAAA;EACA,QAAA;EACA,wBAAA;ADuKN;ACrKM;EAEE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,yBFtvFa;EEuvFb,yBAAA;ADsKR;ACnKM;EACE,4BAAA;EACA,0BAAA;ADqKR;AClKM;EACE,yBAAA;EACA,6BAAA;ADoKR;;AC9JA;EACE,yBAAA;ADiKF;AC/JE;EACE,yBAAA;ADiKJ;;AC7JA;EACE,0BAAA;ADgKF;;ACzJA;EACE,cAAA;EAKA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;ADwJF;;ACrJA;EACE,SAAA;ADwJF;;AA79FA;EACE,wBAAA;AAg+FF;AA99FE;EACE,cAAA;AAg+FJ;AA79FE;EACE,SAAA;AA+9FJ;AA79FI;EACE,sBD2CK;EC1CL,cDqBe;ECpBf,yBAAA;EACA,mBAAA;EACA,kBAAA;AA+9FN;AA79FM;EACE,yBDea;ECdb,WDmCG;EClCH,qBDaa;ACk9FrB;AAr9FI;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,QAAA;EACA,gBAAA;EACA,oBAAA;AAu9FN;AAl9FI;EACE,WAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;AAo9FN;AAh9FE;EACE,gCAAA;AAk9FJ;AAh9FI;EACE,eAAA;EACA,gBAAA;AAk9FN;AA/8FI;EACE,UAAA;EACA,SAAA;AAi9FN;AA98FI;EACE,gBAAA;EACA,kBAAA;AAg9FN;AA98FM;EACE,kBAAA;EACA,mBAAA;AAg9FR;AA98FQ;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,YAAA;EACA,QAAA;EACA,kBAAA;EACA,UAAA;EACA,YAAA;EACA,yBDjCK;ACi/Ff;AA38FQ;EACE,gBAAA;AA68FV;AA38FU;EACE,cAAA;AA68FZ;AAx8FM;EACE,eAAA;EACA,gBAAA;EACA,wEDnGK;ECoGL,SAAA;EACA,eAAA;EACA,6BAAA;EACA,kBAAA;EACA,cDrEa;ECsEb,yBAAA;AA08FR;AAx8FQ;EACE,cAAA;AA08FV;AAv8FQ;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,yBAAA;EACA,aAAA;AAy8FV;AAn8FE;EACE,yBDnFkB;ECoFlB,yBAAA;EACA,kBAAA;EACA,kBAAA;AAq8FJ;AAn8FI;EANF;IAOI,aAAA;EAs8FJ;AACF;AAp8FI;EACE,sBAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;AAs8FN;AAp8FM;EACE,SAAA;AAs8FR;AAj7FM;EACE,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,YAAA;AAm7FR;AAj7FQ;EAPF;IAQI,WAAA;IACA,eAAA;EAo7FR;AACF;AAl7FQ;EACE,YAAA;AAo7FV;AAl7FU;EACE,WAAA;EACA,YAAA;EACA,YAAA;EACA,gBAAA;EACA,yBAAA;EACA,UAAA;AAo7FZ;AAh7FQ;EACE,SAAA;AAk7FV;AA/6FQ;EACE,SAAA;EACA,gBAAA;EACA,cDhKW;ACilGrB;AA96FM;EACE,6BAAA;EACA,uBAAA;EACA,gBAAA;EACA,iBAAA;AAg7FR;AA96FQ;EACE,eAAA;AAg7FV;AA76FQ;EACE,eAAA;AA+6FV;AA36FU;EACE,kBAAA;EACA,qBAAA;EACA,UAAA;EACA,UAAA;EACA,oBAAA;EACA,mBAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;AA66FZ;AA36FY;EACE,mCAAA;EACA,oCAAA;EACA,8BAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,WAAA;EACA,UAAA;AA66Fd;AAx6FQ;EACE,aAAA;AA06FV;AAv6FQ;EACE,eAAA;EACA,gBAAA;AAy6FV;AAr6FM;EACE,SAAA;EACA,kBAAA;AAu6FR;AAn6FI;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,cAAA;EACA,yBAAA;EACA,kBAAA;AAq6FN;AAn6FM;EACE,mBAAA;AAq6FR;AAl6FM;EACE,6BAAA;EACA,4BAAA;AAo6FR;AAj6FM;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,wEDnRK;ECoRL,aAAA;EACA,eAAA;EAEA,aAAA;EACA,kBAAA;AAk6FR;AAh6FQ;EAXF;IAYI,WAAA;EAm6FR;AACF;AAj6FQ;EACE,eAAA;AAm6FV;AAh6FQ;EACE,eAAA;EACA,gBAAA;AAk6FV;AA95FM;EAGE,kBAAA;AA85FR;AA55FQ;EACE,qBD7PK;EC8PL,6BAAA;AA85FV;AA35FQ;EACE,sBAAA;EACA,sBAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,cDtRW;ECuRX,gBAAA;AA65FV;AA35FU;EACE,6BAAA;EACA,SAAA;EACA,UAAA;EACA,eAAA;AA65FZ;AAv5FQ;EACE,cAAA;AAy5FV;AAn5FQ;EACE,cAAA;AAq5FV;AAj5FM;EAGE,kBAAA;EACA,SAAA;EACA,YAAA;EACA,iBAAA;EACA,YAAA;EACA,aAAA;AAi5FR;AA/4FQ;EACE,WAAA;EACA,sBAAA;EACA,gBAAA;EACA,SAAA;EACA,UAAA;EACA,2CAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;AAi5FV;AA/4FU;EACE,WAAA;EACA,kBAAA;EACA,WAAA;EACA,WAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,4CAAA;AAi5FZ;AA54FU;EACE,gCAAA;AA84FZ;AA14FQ;EACE,SAAA;EACA,kBAAA;EACA,6BAAA;EACA,eAAA;EACA,gBAAA;EACA,cD7VW;EC8VX,WAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;AA44FV;AA14FU;EACE,WAAA;EACA,YAAA;EACA,mBDzVG;EC0VH,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;AA44FZ;AAz4FU;EACE,qBDnWG;ECoWH,6BAAA;AA24FZ;AAv4FQ;EACE,cAAA;AAy4FV;AAr4FM;EAGE,kBAAA;EACA,SAAA;EACA,YAAA;EACA,iBAAA;EACA,YAAA;EACA,aAAA;AAq4FR;AAn4FQ;EACE,WAAA;EACA,sBAAA;EACA,gBAAA;EACA,SAAA;EACA,UAAA;EACA,2CAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;AAq4FV;AAn4FU;EACE,WAAA;EACA,kBAAA;EACA,WAAA;EACA,WAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,4CAAA;AAq4FZ;AAh4FU;EACE,gCAAA;AAk4FZ;AA93FQ;;;;EAEE,SAAA;EACA,kBAAA;EACA,6BAAA;EACA,eAAA;EACA,gBAAA;EACA,cD1aW;EC2aX,WAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;AAk4FV;AAh4FU;;;;EACE,WAAA;EACA,YAAA;EACA,mBDtaG;ECuaH,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;AAq4FZ;AAl4FU;;;;EACE,wBD1cI;ACi1GhB;AAj4FQ;EADF;IAEI,WAAA;IACA,OAAA;EAo4FR;AACF;AAl4FQ;EACE,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;AAo4FV;AAl4FU;EANF;IAOI,gBAAA;EAq4FV;AACF;AAn4FU;EACE,WAAA;EACA,kBAAA;EACA,WAAA;EACA,WAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,4CAAA;AAq4FZ;AAn4FY;EAVF;IAWI,WAAA;IACA,UAAA;EAs4FZ;AACF;AAn4FU;EACE,WAAA;EACA,YAAA;EACA,SAAA;EACA,aAAA;EACA,kBAAA;EACA,sBAAA;EACA,+BAAA;EACA,2CAAA;EACA,wED/gBC;ECghBD,eAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;AAq4FZ;AAj4FQ;EACE,kBAAA;EACA,QAAA;EACA,UAAA;EACA,wCAAA;EACA,sBAAA;EACA,YAAA;EACA,kBAAA;EACA,qBAAA;AAm4FV;AAj4FU;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;AAm4FZ;AA93FM;EACE,kBAAA;EACA,QAAA;EACA,2BAAA;EACA,QAAA;AAg4FR;AA93FQ;EACE,SAAA;EACA,6BAAA;EACA,UAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;AAg4FV;AA93FU;EACE,wBDniBI;ACm6GhB;AAz3FM;EACE,mBAAA;AA23FR;AAl3FM;EACE,aAAA;AAo3FR;AAh3FI;EACE,aAAA;EAEA,mBAAA;EACA,cAAA;EACA,sBAAA;EACA,kBAAA;EACA,yBAAA;EACA,aAAA;EAEA,yBAAA;AAg3FN;AA92FM;EACE,wCAAA;AAg3FR;AA52FI;EACE,aAAA;EAEA,mBAAA;EACA,aAAA;EACA,kBAAA;EACA,UAAA;AA62FN;AA32FM;EACE,WAAA;AA62FR;AA12FM;EAZF;IAaI,WAAA;IACA,gBAAA;EA62FN;AACF;AA32FM;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,cDnlBa;EColBb,0BAAA;EACA,QAAA;AA62FR;AA32FQ;EACE,qBAAA;AA62FV;AA12FQ;EACE,gBAAA;AA42FV;AAz2FQ;EAhBF;IAiBI,WAAA;EA42FR;AACF;AAz2FM;EACE,yBDrmBa;ECsmBb,gBAAA;EACA,kBAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;AA22FR;AAx2FM;EACE,yBDtmBc;ECumBd,gBAAA;EACA,kBAAA;EACA,cDjnBa;ECknBb,eAAA;EACA,gBAAA;AA02FR;AAx2FQ;EACE,sBAAA;AA02FV;AAv2FQ;EACE,iBAAA;AAy2FV;AAv2FU;EACE,aAAA;AAy2FZ;AAr2FY;EACE,aAAA;AAu2Fd;AAp2FY;EACE,qBAAA;EACA,0BAAA;AAs2Fd;AA/1FI;EACE,eAAA;EACA,gBAAA;EACA,cDjpBe;ECkpBf,yBD1oBgB;EC2oBhB,kBAAA;EACA,gBAAA;EACA,kBAAA;AAi2FN;AA/1FM;EACE,kBAAA;EACA,SAAA;EACA,SAAA;EACA,2BAAA;EACA,cAAA;EACA,sBAAA;EACA,YAAA;EACA,uCAAA;EACA,eAAA;EACA,UAAA;EACA,aAAA;EACA,gBAAA;EACA,kBAAA;EACA,SAAA;AAi2FR;AA91FM;EACE,cAAA;AAg2FR;AA51FI;EACE,kBAAA;AA81FN;AA11FU;EACE,mCD/rBI;AC2hHhB;AAx1FQ;EACE,cAAA;AA01FV;AAt1FM;EACE,SAAA;EACA,UAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;EACA,aAAA;EACA,6BAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;AAw1FR;AAt1FQ;EACE,cAAA;EACA,UAAA;EACA,eAAA;EACA,yBD7sBW;EC8sBX,kBAAA;AAw1FV;AAp1FM;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,iBAAA;EACA,YAAA;EACA,aAAA;AAs1FR;AAp1FQ;EACE,WAAA;EACA,sBAAA;EACA,gBAAA;EACA,SAAA;EACA,UAAA;EACA,4CAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;AAs1FV;AAp1FU;EACE,WAAA;EACA,kBAAA;EACA,UAAA;EACA,YAAA;EACA,sBAAA;EACA,WAAA;EACA,WAAA;EACA,4CAAA;AAs1FZ;AAl1FQ;EACE,kBAAA;AAo1FV;AAl1FU;EACE,cAAA;AAo1FZ;AAj1FU;EACE,gCAAA;AAm1FZ;AAh1FU;;EAEE,SAAA;EACA,kBAAA;EACA,6BAAA;EACA,eAAA;EACA,gBAAA;EACA,cDpwBS;ECqwBT,WAAA;EACA,gBAAA;EACA,cAAA;AAk1FZ;AAh1FY;;EACE,wBDtxBE;ACymHhB;AA90FQ;EACE,kBAAA;EACA,MAAA;EACA,WAAA;EACA,mBAAA;EACA,aAAA;AAg1FV;AA70FY;EACE,yCAAA;EACA,UAAA;EACA,SAAA;EACA,UAAA;EACA,YAAA;AA+0Fd;AA10FQ;EACE,mBAAA;EACA,YAAA;AA40FV;AAv0FI;EACE,UAAA;EACA,6BAAA;EACA,SAAA;EACA,eAAA;EACA,gBAAA;EACA,cD9yBe;EC+yBf,WAAA;EACA,kBAAA;AAy0FN;AAv0FM;EACE,gBAAA;AAy0FR;AAt0FM;EACE,wBDn0BQ;AC2oHhB;AAt0FQ;EACE,yBAAA;AAw0FV;AAj0FI;EACE,kBAAA;AAm0FN;AAj0FM;EACE,UAAA;AAm0FR;AAj0FQ;EAHF;IAII,YAAA;EAo0FR;AACF;AAl0FQ;EAPF;IAQI,UAAA;EAq0FR;AACF;AAn0FQ;EAXF;IAYI,WAAA;IACA,kBAAA;EAs0FR;AACF;AAp0FM;EACE,UAAA;AAs0FR;AAp0FQ;EAHF;IAII,yBAAA;EAu0FR;AACF;AAr0FQ;EAPF;IAQI,UAAA;EAw0FR;AACF;AAt0FQ;EAXF;IAYI,WAAA;EAy0FR;AACF;AAt0FM;EACE;IACE,WAAA;EAw0FR;AACF;AAp0FI;EACE,WAAA;EACA,iBAAA;EACA,mBAAA;AAs0FN;AAp0FM;EACE,6BAAA;EACA,SAAA;EACA,cDn3Ba;ECo3Bb,gBAAA;EACA,eAAA;AAs0FR;AAh0FI;EACE,kBAAA;AAk0FN;AAh0FM;EACE;IACE,UAAA;EAk0FR;AACF;AAh0FM;EACE;IACE,qBAAA;EAk0FR;AACF;AA/zFM;EACE;IACE,UAAA;EAi0FR;AACF;AAhzFM;EACE;IACE,WAAA;EAkzFR;AACF;AA7yFE;EACE,yBAAA;EACA,kBAAA;AA+yFJ;AA7yFI;EACE,aAAA;EACA,eAAA;EAEA,iBAAA;EACA,gBAAA;AA8yFN;AA5yFM;EACE,gBAAA;EACA,iBAAA;AA8yFR;AA3yFM;EACE,gBAAA;EACA,mBAAA;AA6yFR;AA1yFM;EACE,iBAAA;AA4yFR;AAzyFM;EACE,QAAA;AA2yFR;AAzyFQ;EACE,QAAA;EACA,gCAAA;AA2yFV;AAtyFI;EACE,yBDj8BgB;ECk8BhB,kBAAA;EACA,aAAA;AAwyFN;AAtyFM;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,wEDp/BK;ECq/BL,kBAAA;EACA,0BAAA;EAEA,aAAA;EACA,QAAA;EACA,mBAAA;EACA,OAAA;AAuyFR;AAryFQ;EACE,eAAA;EACA,gBAAA;AAuyFV;AAryFU;EACE,aAAA;AAuyFZ;AAryFU;EACE,cAAA;AAuyFZ;AAjyFY;EACE,cAAA;AAmyFd;AAjyFY;EACE,aAAA;AAmyFd;AA7xFM;EACE,kBAAA;AA+xFR;AA5xFU;EACE,6BAAA;AA8xFZ;AA3xFU;EACE,cAAA;AA6xFZ;AAzxFQ;EAEE,WAAA;EACA,YAAA;EACA,YAAA;EACA,sBAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;AA0xFV;AAxxFU;EACE,mCD1hCI;EC2hCJ,+BD3hCI;ACqzHhB;AAxxFY;EACE,sBD7/BH;ACuxHX;AAtxFU;EACE,cAAA;EACA,UAAA;EACA,eAAA;EACA,yBD1hCS;EC2hCT,kBAAA;AAwxFZ;AApxFQ;EACE,kBAAA;EACA,SAAA;EACA,YAAA;EACA,gBAAA;EACA,iBAAA;EACA,aAAA;EACA,UAAA;AAsxFV;AApxFU;EACE,WAAA;EACA,sBAAA;EACA,gBAAA;EACA,SAAA;EACA,UAAA;EACA,2CAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;AAsxFZ;AApxFY;EACE,WAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,4CAAA;AAsxFd;AAjxFY;EACE,gCAAA;AAmxFd;AAhxFY;EAEE,SAAA;EACA,kBAAA;EACA,6BAAA;EACA,eAAA;EACA,gBAAA;EACA,cD3kCO;EC4kCP,WAAA;EACA,gBAAA;EACA,qBAAA;AAixFd;AA/wFc;EACE,wBD7lCA;AC82HhB;AA7wFY;EACE,WAAA;AA+wFd;AA3wFU;EACE,kBAAA;AA6wFZ;AAvwFQ;EACE,UAAA;EACA,SAAA;EACA,6BAAA;EACA,gBAAA;AAywFV;AAvwFU;EACE,wBDpnCI;AC63HhB;AAlwFM;EACE,4BAAA;EACA,aAAA;EAEA,mBAAA;EACA,cAAA;EACA,WAAA;AAmwFR;AAjwFQ;EACE,gCAAA;AAmwFV;AA9vFI;EACE,eAAA;EACA,gBAAA;EACA,cDhoCe;ECioCf,cAAA;EACA,YAAA;EACA,aAAA;EACA,iBAAA;EACA,mBAAA;EACA,aAAA;AAgwFN;AA9vFM;EACE,cAAA;EACA,YAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAgwFR;AA9vFQ;EACE,gBAAA;AAgwFV;AA5vFM;EACE,cAAA;EACA,yBDtpCa;ECupCb,gBAAA;EACA,kBAAA;EACA,WAAA;EACA,eAAA;EACA,qBAAA;AA8vFR;AA1vFI;EACE,iBAAA;EACA,kBAAA;AA4vFN;AA1vFM;EACE,cAAA;AA4vFR;AAvvFU;EACE,mCDtrCI;AC+6HhB;AArvFQ;EACE,cAAA;AAuvFV;AAnvFM;EACE,SAAA;EACA,UAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;EACA,aAAA;EACA,6BAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;AAqvFR;AAnvFQ;EACE,cAAA;EACA,UAAA;EACA,eAAA;EACA,yBDpsCW;ECqsCX,kBAAA;AAqvFV;AAjvFM;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,iBAAA;EACA,YAAA;EACA,aAAA;AAmvFR;AAjvFQ;EACE,WAAA;EACA,sBAAA;EACA,gBAAA;EACA,SAAA;EACA,UAAA;EACA,4CAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;AAmvFV;AAjvFU;EACE,WAAA;EACA,kBAAA;EACA,UAAA;EACA,YAAA;EACA,sBAAA;EACA,WAAA;EACA,WAAA;EACA,4CAAA;AAmvFZ;AA/uFQ;EACE,kBAAA;AAivFV;AA/uFU;EACE,cAAA;AAivFZ;AA9uFU;EACE,gCAAA;AAgvFZ;AA7uFU;;EAEE,SAAA;EACA,kBAAA;EACA,6BAAA;EACA,eAAA;EACA,gBAAA;EACA,cD3vCS;EC4vCT,WAAA;EACA,gBAAA;AA+uFZ;AA7uFY;;;;EAEE,UAAA;AAivFd;AA9uFY;;EACE,wBDjxCE;ACkgIhB;AA5uFQ;EACE,kBAAA;EACA,MAAA;EACA,WAAA;EACA,mBAAA;EACA,aAAA;AA8uFV;AA3uFY;EACE,yCAAA;EACA,UAAA;EACA,SAAA;EACA,UAAA;EACA,YAAA;AA6uFd;AAtuFI;EACE,4BAAA;EACA,6BAAA;EACA,SAAA;EACA,eAAA;EACA,gBAAA;EACA,cDpyCe;ECqyCf,WAAA;EACA,kBAAA;EACA,QAAA;EACA,6BAAA;AAwuFN;AAtuFM;EACE,gBAAA;AAwuFR;AAruFM;EACE,wBD3zCQ;ACkiIhB;AAruFQ;EACE,yBAAA;AAuuFV;AAjuFE;EACE,iBAAA;EACA,SAAA;AAmuFJ;AAjuFI;EACE,cAAA;AAmuFN;AAluFM;EACE,gBAAA;AAouFR;;AA9tFA;EACE,eAAA;EACA,QAAA;EACA,qCAAA;EACA,WAAA;EACA,yBAAA;AAiuFF;AA/tFE;EAPF;IAQI,mBAAA;EAkuFF;AACF;AAhuFE;EACE,kBAAA;AAkuFJ;AA/tFE;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,eAAA;EACA,uBAAA;EACA,uBAAA;EACA,gBAAA;EACA,aAAA;AAiuFJ;AA9tFE;EACE,gBAAA;EACA,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,uBAAA;EACA,kBAAA;EACA,sBDj1CO;ACijIX;AA7tFE;EACE,qBAAA;EACA,kBAAA;EACA,kBAAA;EACA,6BAAA;EACA,SAAA;EACA,UAAA;EACA,kBAAA;EACA,sBAAA;EACA,wBAAA;EACA,eAAA;EACA,cDp3CiB;ECq3CjB,WAAA;EACA,eAAA;AA+tFJ;AA7tFI;EACE,kBAAA;EACA,QAAA;EACA,wBAAA;AA+tFN;AA7tFM;EAEE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,OAAA;EACA,2BAAA;EACA,yBAAA;EACA,6BAAA;EACA,yBDt4Ca;ECu4Cb,yBAAA;AA8tFR;AA3tFM;EACE,SAAA;EACA,SAAA;EACA,2BAAA;EACA,4BAAA;EACA,0BAAA;AA6tFR;AAvtFQ;EAEE,mCDn6CM;AC2nIhB;AAjtFI;EACE,mBAAA;AAmtFN;AA9sFI;EACE,gBAAA;AAgtFN;AA7sFI;EACE,cDz6Ce;EC06Cf,wED78CO;EC88CP,eAAA;EACA,gBAAA;AA+sFN;AA7sFM;EACE,gBAAA;AA+sFR;AA1sFE;EACE,yBAAA;EACA,kBAAA;AA4sFJ;AAzsFE;EACE,kBAAA;EACA,gBAAA;EACA,cD57CiB;EC67CjB,cAAA;EACA,WAAA;EACA,eAAA;EACA,yBAAA;AA2sFJ;AAzsFI;EACE,yBDn7CK;AC8nIX;AAxsFI;EACE,gCAAA;AA0sFN;AAvsFI;EACE,qBAAA;AAysFN;AApsFI;EACE,WAAA;EACA,yBAAA;EACA,aAAA;AAssFN;AApsFM;EACE,+BDl+CQ;ECm+CR,aAAA;AAssFR;;AA9rFA;EACE,kBAAA;AAisFF;;AA9rFA;EACE,aAAA;AAisFF;AA/rFE;EAHF;IAII,mBAAA;EAksFF;AACF;AAhsFE;EAPF;IAQI,iBAAA;IACA,oBAAA;EAmsFF;AACF;AAjsFE;EACE,6BAAA;EACA,yBAAA;EACA,uBAAA;EACA,oBAAA;EACA,oCAAA;EACA,6BAAA;EACA,kCAAA;EACA,2BAAA;EACA,iCAAA;AAmsFJ;AAjsFI;EACE,0BAAA;AAmsFN;AAhsFI;EACE,8BAAA;AAksFN;AA9rFE;EACE,2BAAA;EACA,+BAAA;EACA,yBAAA;AAgsFJ;AA9rFI;EACE,2BAAA;EACA,oBAAA;EACA,0BAAA;EACA,4BAAA;EACA,8BAAA;EACA,+BAAA;AAgsFN;AA7rFI;EACE,8CAAA;AA+rFN;AA7rFM;EACE,oCAAA;EACA,WDjgDG;ACgsIX;AA1rFE;EACE,0BAAA;EACA,2BAAA;EACA,2BAAA;EACA,yBAAA;AA4rFJ;AAzrFE;EACE,0BAAA;EACA,4BAAA;AA2rFJ;;AAtrFA;EACE,yBAAA;AAyrFF;;AAtrFA;EACE,UAAA;EACA,8BAAA;AAyrFF;AAvrFE;EACE,gBAAA;AAyrFJ;AAxrFI;EACE,aAAA;AA0rFN;;AArrFA;EACE,aAAA;EACA,eAAA;EACA,yBAAA;EACA,mBAAA;EACA,aAAA;AAwrFF;AAtrFE;EACE,UAAA;EACA,WAAA;EACA,eAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,SAAA;EACA,yBAAA;EACA,yBAAA;AAwrFJ;AAtrFI;EACE,aAAA;AAwrFN;AArrFI;EACE,WAAA;EACA,yBAAA;AAurFN;;AAlrFA;EACE,UAAA;EACA,yBAAA;AAqrFF;AAlrFE;EACE,WAAA;AAorFJ;;AA/qFE;EACE,QAAA;AAkrFJ;AA/qFE;EACE,SAAA;AAirFJ;AA9qFE;EACE,SAAA;AAgrFJ;;AA5qFA;EACE,YAAA;AA+qFF;AA7qFE;EACE,yBAAA;EACA,aAAA;EACA,+BAAA;EACA,8BAAA;AA+qFJ;AA7qFI;EACE,6BAAA;AA+qFN;AA7qFM;EACE,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cDjoDa;ACgzIrB;AA1qFE;EACE,6BAAA;EACA,4BAAA;AA4qFJ;AAzqFE;EACE,6BAAA;AA2qFJ;AAxqFQ;EACE,cAAA;AA0qFV;AAxqFQ;EACE,aAAA;AA0qFV;AAtqFM;EAGE,cAAA;EACA,gBAAA;AAsqFR;AAnqFM;EACE,cAAA;AAqqFR;AAlqFM;EACE,aAAA;AAoqFR;AA7pFM;EACE,qBAAA;AA+pFR;AA7pFM;EACE,qBAAA;EACA,kBAAA;EACA,YAAA;EACA,UAAA;EACA,YAAA;EACA,gBAAA;EACA,WAAA;EACA,uCAAA;EACA,kBAAA;EACA,kBAAA;AA+pFR;;AAxpFE;EACE,WAAA;AA2pFJ;AAtpFI;EAFF;;IAGI,eAAA;EA0pFJ;AACF;AAxpFI;;EACE,WAAA;AA2pFN;AAxpFI;;;EAEE,WAAA;EACA,kBAAA;AA2pFN;AAxpFI;EACE;;IACE,WAAA;EA2pFN;EAxpFI;;IACE,WAAA;EA2pFN;AACF;;AAtpFA;EACE,aAAA;EACA,eAAA;EACA,SAAA;EACA,gBAAA;EACA,oBAAA;EACA,gCAAA;AAypFF;AAvpFE;EACE,gBAAA;AAypFJ;AAtpFE;EACE,aAAA;EACA,eAAA;EACA,OAAA;AAwpFJ;AAtpFI;EACE,kBAAA;EACA,OAAA;AAwpFN;AAtpFM;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,QAAA;EACA,UAAA;EACA,2BAAA;EACA,UAAA;EACA,SAAA;EACA,uBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAwpFR;AAtpFQ;EACE,aDlwDW;AC05IrB;AArpFQ;EACE,WAAA;EACA,UAAA;AAupFV;AAnpFM;EACE,0BAAA;EACA,yBAAA;EACA,gBDzvDG;EC0vDH,cD/wDa;ECgxDb,iBAAA;EACA,OAAA;EACA,WAAA;EACA,eAAA;EACA,aAAA;AAqpFR;AAnpFQ;EACE,qBDvxDW;AC46IrB;AA/oFE;EACE,WAAA;EACA,cAAA;EACA,kBAAA;AAipFJ;AA/oFI;EACE,cAAA;AAipFN;AA9oFI;EACE,yBAAA;EACA,cAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,0BAAA;EACA,gBAAA;EACA,6BAAA;EACA,WAAA;EACA,iBAAA;AAgpFN;AA9oFM;EACE,yBD3yDc;AC27ItB;AA5oFI;EACE,kBAAA;EACA,SAAA;EACA,SAAA;EACA,2BAAA;EACA,UAAA;EACA,iBAAA;EACA,aAAA;AA8oFN;AA5oFM;EACE,YAAA;EACA,sBD7yDG;EC8yDH,oDAAA;EACA,mBAAA;EACA,kBAAA;AA8oFR;AA5oFQ;EACE,WAAA;EACA,kBAAA;EACA,YAAA;EACA,SAAA;EACA,2BAAA;EACA,WAAA;EACA,YAAA;EACA,sBD1zDC;EC2zDD,4CAAA;AA8oFV;AAzoFI;EACE,aAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AA2oFN;AAzoFM;EACE,6BAAA;AA2oFR;AAvoFM;EACE,aAAA;EACA,SAAA;EACA,cDn2Da;AC4+IrB;AAvoFQ;EACE,SAAA;EACA,cAAA;EACA,UAAA;AAyoFV;AAloFI;EACE,kBAAA;EACA,yBAAA;EACA,gBD71DK;EC81DL,cDn3De;ECo3Df,iBAAA;EACA,eAAA;EACA,wEDz5DO;EC05DP,iBAAA;EACA,cAAA;EACA,gBAAA;AAooFN;AAloFM;EACE,mCDp4DY;ECq4DZ,+BDr4DY;ECs4DZ,WDz2DG;AC6+IX;AAjoFM;EAEE,yBDz3DW;EC03DX,qBD13DW;EC23DX,WDh3DG;ACk/IX;;AA3nFE;EACE,qBAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,WD14DgB;EC24DhB,sBAAA;EACA,eAAA;EACA,YAAA;AA8nFJ;AA5nFI;EACE,UAAA;AA8nFN;;AAvnFA;EACE,mBAAA;AA0nFF;;AAtnFE;EACE,UAAA;EACA,6BAAA;EACA,SAAA;AAynFJ;AAvnFI;EACE,mBAAA;AAynFN;AAtnFI;EACE,mBAAA;AAwnFN;AAnnFQ;EACE,kBAAA;AAqnFV;AAhnFI;EACE,yBDj7DgB;ECk7DhB,aAAA;EACA,oBAAA;EACA,0BAAA;AAknFN;AAhnFM;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;AAknFR;AA/mFM;EACE,OAAA;EACA,YAAA;AAinFR;AA/mFQ;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,SAAA;EACA,OAAA;AAinFV;AA9mFQ;EACE,OAAA;EACA,aAAA;EACA,QAAA;EACA,mBAAA;AAgnFV;AA7mFQ;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,YAAA;EACA,cAAA;EACA,mBAAA;EACA,uEAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,cAAA;EACA,kBAAA;EACA,WAAA;AA+mFV;AA3mFM;EACE,gBAAA;EACA,SAAA;EACA,eAAA;EACA,WAAA;EACA,cAAA;EACA,iBAAA;AA6mFR;AA1mFM;EACE,UAAA;AA4mFR;AAxmFI;EACE,yBAAA;EACA,0BAAA;AA0mFN;AAvmFI;EACE,SAAA;AAymFN;AAtmFI;EACE,SAAA;AAwmFN;AAnmFQ;EACE,gBAAA;AAqmFV;AAjmFM;;EAEE,SAAA;EACA,gCAAA;EACA,sBAAA;AAmmFR;AA9lFQ;EACE,SAAA;EACA,YAAA;EACA,cAAA;EACA,oBAAA;AAgmFV;AA9lFU;EACE,YAAA;EACA,SAAA;EACA,yCAAA;AAgmFZ;AA1lFI;;EAEE,mBAAA;AA4lFN;AAxlFM;EACE,kBAAA;EACA,cDliEW;ECmiEX,qBAAA;AA0lFR;AAxlFQ;EACE,aAAA;EACA,kBAAA;EACA,wBAAA;EACA,SAAA;EACA,2BAAA;EACA,sBDjiEC;ECkiED,uCAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;AA0lFV;AAxlFU;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,SAAA;EACA,2BAAA;EACA,sBAAA;EACA,WAAA;EACA,WAAA;EACA,yCAAA;AA0lFZ;AAtlFQ;EACE,cAAA;AAwlFV;AAplFM;EACE,cDpiEG;AC0nJX;AAjlFM;EACE,gBAAA;AAmlFR;AA9kFE;EACE,kBAAA;EACA,eAAA;AAglFJ;AA9kFI;EACE,cAAA;AAglFN;AA5kFE;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,QAAA;AA8kFJ;AA5kFI;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,gBDzlEK;EC0lEL,UAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;AA8kFN;AA5kFM;EACE,2BAAA;EACA,gBAAA;EACA,oDAAA;EACA,yBDznEa;EC0nEb,WDrmEG;ECsmEH,eAAA;EACA,kBAAA;EACA,yBAAA;EACA,SAAA;EACA,2BAAA;EACA,kBAAA;EACA,aAAA;AA8kFR;AA3kFM;EACE,WAAA;EACA,kBAAA;EACA,wBAAA;EACA,WAAA;EACA,WAAA;EACA,yBD1oEa;EC2oEb,yCAAA;EACA,aAAA;AA6kFR;AA1kFM;EAEE,cAAA;AA2kFR;AAxkFM;EAEE,yBDtpEa;ECupEb,qBDvpEa;ECwpEb,WDnoEG;AC4sJX;AAvkFQ;EACE,WDtoEC;AC+sJX;AAtkFQ;EACE,UD1oEC;ACktJX;AApkFM;EACE,WAAA;EACA,YAAA;AAskFR;;AAhkFA;EACE,kBAAA;AAmkFF;;AAhkFA;EACE,cAAA;EACA,oBAAA;EACA,uBAAA;EACA,mBAAA;EACA,yBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;AAmkFF;;AA7jFE;EACE,gBAAA;AAgkFJ;;AAvjFA;EACE,oCAAA;EACA,6BAAA;EACA,iBAAA;EACA,mBAAA;EACA,gCAAA;EACA,kBAAA;AA0jFF;AAxjFE;EAAU,0CAAA;AA2jFZ;;AAvjFA;EACE,8BAAA;EACA,gCAAA;EACA,kBAAA;AA0jFF;;AAtjFA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,YAAA;EACA,cAAA;EACA,mBAAA;EACA,kCAAA;EACA,uBDlvEc;ECmvEd,eAAA;EACA,gBAAA;EACA,gBAAA;AAyjFF;;AArjFA;;EAEE,2BAAA;EACA,oCAAA;EACA,6BAAA;EACA,qDAAA;EACA,yBAAA;AAwjFF;AAtjFE;;;EACE,4BAAA;EACA,0BAAA;EACA,wEDzxES;EC0xET,iCAAA;AA0jFJ;AAxjFI;;;EAAU,8BAAA;AA6jFd;;AAxjFA;EACE,+BAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,YAAA;EACA,cAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,cDzwEmB;EC0wEnB,gBAAA;EACA,eAAA;EACA,wED/yEW;ECgzEX,0BAAA;EACA,gBAAA;AA2jFF;AAzjFE;EAAU,mBDxwEU;ECwwEwB,kBDzwE1B;ACs0JpB;AA5jFE;EAAW,mBD5wEQ;EC4wEyB,WAAA;EAAa,qBD5wEtC;AC60JrB;;AA7jFA;;;EAGE,4BAAA;EACA,oCAAA;EACA,6BAAA;EACA,0BAAA;EACA,wED/zEW;ECg0EX,wDAAA;AAgkFF;AA9jFE;;;EACE,yCAAA;EACA,4CAAA;EACA,aAAA;AAkkFJ;;AAvjFE;;;;;EACE,0BAAA;EACA,iBAAA;EACA,kBAAA;EACA,sBAAA;EACA,uBAAA;EACA,yCAAA;EACA,yBAAA;AA8jFJ;AA3jFE;;;;;EACE,wBAAA;EACA,kCAAA;EACA,kCAAA;EACA,6BAAA;EACA,2BAAA;EACA,uBAAA;AAikFJ;AA9jFE;;;;;EACE,kCAAA;EACA,8BAAA;EACA,sDAAA;EACA,2BAAA;EACA,2BAAA;EACA,uBAAA;EACA,qBAAA;AAokFJ;AAjkFE;;;;;EACE,6BAAA;EACA,8BAAA;EACA,2CAAA;EACA,6BAAA;AAukFJ;AArkFI;;;;;EACE,0BAAA;EACA,2BAAA;EACA,yBAAA;EACA,mFAAA;AA2kFN;AAvkFE;;;;;EACE,6BAAA;EACA,oBAAA;EACA,sBAAA;EACA,sBAAA;EACA,uBAAA;EACA,qBAAA;EACA,oCAAA;EACA,6BAAA;EACA,2BAAA;EACA,eAAA;EACA,0BAAA;AA6kFJ;AA3kFI;;;;;;;;;EAEE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,+CAAA;AAolFN;AAjlFI;;;;;EACE,8CAAA;AAulFN;AAplFI;;;;;EACE,8CAAA;EACA,+CAAA;AA0lFN;AAtlFE;;;;;;;;;;EAEE,wBAAA;AAgmFJ;AA7lFE;;;;;EACE,0BAAA;EACA,2BAAA;EACA,yBAAA;EACA,wEDx6ES;ECy6ET,6BAAA;AAmmFJ;AAhmFE;;;;;;;;;;;;;;;;;;;;;;;;;EAKE,4BAAA;EACA,oCAAA;EACA,6BAAA;EACA,0BAAA;EACA,wEDr7ES;ECs7ET,cDn5EiB;ECo5EjB,wDAAA;AAsnFJ;AApnFI;;;;;;;;;;;;;;;;;;;;;;;;;EACE,yCAAA;EACA,uDAAA;EACA,wBAAA;AA8oFN;AA1oFE;;;;;EACE,4BAAA;EACA,0BAAA;EACA,2BAAA;EACA,wEDp8ES;ECq8ET,6BAAA;EACA,uBAAA;EACA,wCAAA;EACA,sBAAA;EACA,eAAA;EACA,iCAAA;AAgpFJ;AA9oFI;;;;;EAAU,8BAAA;AAqpFd;AAppFI;;;;;EAAa,YAAA;EAAc,mBAAA;AA4pF/B;;AAvpFA;;EAEE,WAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,kBAAA;EACA,wEDz9EW;ACmnKb;AAxpFE;;EAAU,8BDt8EI;ECs8E0B,aAAA;AA6pF1C;;AAzpFA;EACE,oCAAA;EACA,6BAAA;EACA,gBAAA;EACA,mBAAA;AA4pFF;AA1pFE;EACE,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,wBDn9EY;ECo9EZ,oCAAA;EACA,gBAAA;EACA,kBAAA;AA4pFJ;;AAvpFA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,YAAA;EACA,cAAA;EACA,mBAAA;EACA,kCAAA;EACA,uBDt+Ec;ECu+Ed,eAAA;EACA,gBAAA;EACA,gBAAA;AA0pFF;;AArpFA;EACE,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,iBAAA;AAwpFF;;AAppFA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;AAupFF;AArpFE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AAupFJ;AArpFI;EACE,eAAA;EACA,gBAAA;EACA,cDj/Ee;ACwoKrB;AAppFI;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,YAAA;EACA,cAAA;EACA,mBAAA;EACA,8DAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAspFN;;AAhpFA;EACE,gBAAA;EACA,eAAA;EACA,WDvgFkB;ECwgFlB,sBAAA;AAmpFF;;AA/oFA;EACE,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,4BAAA;EACA,mBAAA;AAkpFF;AAhpFE;EACE,uBDxiFY;AC0rKhB;AAhpFI;EAAoB,uBD1iFR;AC6rKhB;;AA/oFA;EACE,4BAAA;EACA,0BAAA;EACA,2BAAA;EACA,6BAAA;EACA,wCAAA;EACA,sBAAA;EACA,uBAAA;EACA,wED3kFW;EC4kFX,iCAAA;EACA,gBAAA;AAkpFF;AAhpFE;EAAU,8BAAA;AAmpFZ;;AA9oFE;EACE,2BAAA;EACA,0BAAA;EACA,2BAAA;EACA,yBAAA;EACA,sBAAA;EACA,yBAAA;EACA,2CAAA;EACA,2BAAA;EACA,mBAAA;EACA,iCAAA;AAipFJ;AA9oFI;;EAEE,gCAAA;EACA,2BAAA;EACA,oBAAA;EACA,sBAAA;EACA,gBAAA;EACA,eAAA;EACA,WD/jFc;ECgkFd,sBAAA;EACA,eAAA;AAgpFN;;AA1oFA;;;;;;EAME,wBAAA;EACA,2BAAA;EACA,8BAAA;AA6oFF;;AAzoFA;;EAEE,qBAAA;AA4oFF;;AAxoFA;EACE,4BAAA;AA2oFF;;AAxoFA;EACE,sBAAA;EACA,2BAAA;AA2oFF;;AAvoFA;EACE,aAAA;EACA,WAAA;EACA,SAAA;EACA,iBAAA;EACA,SAAA;EACA,UAAA;AA0oFF;AAxoFE;EARF;IASI,eAAA;EA2oFF;AACF;;AAxoFA;EACE,UAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,mEAAA;AA2oFF;AAzoFE;EACE,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,UAAA;EACA,qBAAA;EACA,oBAAA;AA2oFJ;AAxoFE;EAjBF;IAkBI,WAAA;IACA,eAAA;IACA,eAAA;EA2oFF;AACF;;AAxoFA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,iCAAA;EACA,UAAA;EACA,cAAA;EACA,iBAAA;AA2oFF;AAzoFE;EACE,mBAAA;EACA,qBAAA;AA2oFJ;AAxoFE;EACE,eAAA;EACA,cDrqFiB;AC+yKrB;;AAtoFA;EACE,MAAA;AAyoFF;;AAtoFA;EACE,YAAA;EACA,YAAA;EACA,QAAA;AAyoFF;AAvoFE;EALF;IAMI,WAAA;IACA,cAAA;EA0oFF;AACF;;AAroFE;;;EAGE,sBAAA;EACA,0BAAA;AAwoFJ;AAroFE;EACE,sBAAA;AAuoFJ;;AAloFA;EACE,iBAAA;AAqoFF;;AAjoFA;EACE,wBAAA;EACA,2DAAA;EACA,SAAA;EACA,SAAA;EACA,UAAA;EACA,gBAAA;AAooFF;;AAjoFA;EACE,WAAA;EACA,sBAAA;EACA,eAAA;EACA,UAAA;EACA,YAAA;AAooFF;AAloFE;EAPF;IAUI,sBAAA;EAmoFF;AACF;;AA9nFE;EACE,YAAA;EACA,iBAAA;AAioFJ;AA7nFE;EACE,wBAAA;EACA,mBAAA;EACA,QAAA;EACA,YAAA;EACA,kBAAA;EACA,4BAAA;AA+nFJ;AA7nFI;EACE,wBAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;EACA,YAAA;EACA,gBAAA;AA+nFN;AA7nFM;EACE,cAAA;AA+nFR;AA5nFM;;EAEE,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,cDlwFa;ACg4KrB;AA1nFM;EACE,cAAA;EACA,eAAA;EACA,cD9wFa;EC+wFb,gBAAA;AA4nFR;AAvnFI;EACE,cAAA;EACA,iBAAA;EACA,kBAAA;AAynFN;AArnFI;EACE,cAAA;AAunFN;;AAhnFA;EACE,4BAAA;EACA,kBAAA;EACA,WAAA;AAmnFF;AAjnFE;EACE,4BAAA;AAmnFJ;AAhnFE;EACE,4BAAA;EACA,kBAAA;AAknFJ;AA9mFE;EACE,wBAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;EACA,kBAAA;EACA,YAAA;AAgnFJ;AA9mFI;EACE,cAAA;EACA,YAAA;AAgnFN;AA9mFM;EACE,YAAA;AAgnFR;AA7mFM;EACE,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;AA+mFR;AA3mFI;EACE,cAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;AA6mFN;;AAvmFA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,oBAAA;AA0mFF;AAxmFE;EACE,eAAA;EACA,gBAAA;AA0mFJ;AAvmFE;EACE,cAAA;AAymFJ;;AApmFA;EACE,cAAA;AAumFF;AArmFE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,uBAAA;EACA,UAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,0BAAA;AAumFJ;AArmFI;EACE,yBDz3Fe;EC03Ff,qBD13Fe;ACi+KrB;AArmFM;EAAI,WAAA;AAwmFV;AArmFI;EACE,cDh4Fe;ECi4Ff,eAAA;AAumFN;;AAlmFA;EACE,kBAAA;EACA,UAAA;AAqmFF;;AAlmFA;EACE,sBAAA;AAqmFF;;AAjmFA;EACE,2CAAA;EACA,uCAAA;AAomFF;AAlmFE;EAAU,oDAAA;AAqmFZ;AAnmFE;EACE,0CAAA;AAqmFJ;AApmFI;EAAU,oDAAA;AAumFd;AApmFE;EACE,0BAAA;EACA,eAAA;EACA,cD95FiB;EC+5FjB,iCAAA;EACA,gBAAA;EACA,2BAAA;AAsmFJ;;AAhmFE;EACE,cDx6FiB;ECy6FjB,qBAAA;EACA,gBAAA;EACA,4BAAA;AAmmFJ;AAjmFI;EAAU,uBD37FE;AC+hLhB;;AA9lFE;EACE,YAAA;EACA,uBAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;EACA,iCAAA;AAimFJ;AA/lFI;EAAU,mBDn7FQ;ACqhLtB;AA/lFE;EACE,2BAAA;EACA,oCAAA;EACA,6BAAA;EACA,qDAAA;EACA,yBAAA;EACA,YAAA;AAimFJ;AA/lFI;EACE,cAAA;EACA,WAAA;EACA,gBAAA;EACA,4BAAA;EACA,0BAAA;EACA,wED/+FO;ECg/FP,yBAAA;EACA,YAAA;EACA,uBAAA;EACA,eAAA;EACA,iCAAA;AAimFN;AA/lFM;EAAU,8BAAA;AAkmFhB;;AA5lFA;EACE,kBAAA;EACA,mBDn9FoB;ECo9FpB,gCAAA;AA+lFF;AA7lFE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AA+lFJ;AA7lFI;EACE,OAAA;EACA,kBAAA;AA+lFN;AA7lFM;EACE,sBAAA;EACA,qCAAA;EACA,oCAAA;EACA,6BAAA;EACA,0BAAA;EACA,wEDhhGK;AC+mLb;AA7lFQ;EACE,yCAAA;EACA,4CAAA;EACA,aAAA;AA+lFV;AA3lFM;EACE,kBAAA;EACA,UAAA;EACA,QAAA;EACA,2BAAA;EACA,YAAA;EACA,uBAAA;EACA,eAAA;EACA,YAAA;AA6lFR;AA3lFQ;EAAM,WAAA;EAAa,YAAA;EAAc,UDz/FrB;ACylLpB;AA9lFQ;EAAc,sBD7gGJ;AC8mLlB;AA5lFE;EACE,kBAAA;AA8lFJ;AA5lFI;EACE,4BAAA;EACA,oCAAA;EACA,6BAAA;EACA,2BAAA;EACA,eAAA;EACA,mCAAA;AA8lFN;AA5lFM;EAAU,6BAAA;AA+lFhB;AA5lFI;EACE,2BAAA;EACA,oCAAA;EACA,6BAAA;EACA,qDAAA;EACA,yBAAA;EACA,YAAA;AA8lFN;AA3lFI;EACE,iBAAA;EACA,eAAA;AA6lFN;AA3lFM;EACE,eAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,SAAA;AA6lFR;;AAtlFA;;EAEE,6BAAA;EACA,wEDrlGW;ECslGX,2BAAA;EACA,0BAAA;EACA,4BAAA;EACA,0BAAA;AAylFF;;AArlFA;EACE,+BDvkGc;ECwkGd,WAAA;EACA,YAAA;EACA,eAAA;AAwlFF;;AAplFA;EACE,eAAA;AAulFF;;AAnlFA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;EACA,6BAAA;AAslFF;AAplFE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AAslFJ;AAplFI;EACE,eAAA;EACA,gBAAA;EACA,cDjlGe;ECklGf,SAAA;AAslFN;;AA9kFE;EACE,kBAAA;AAilFJ;AA/kFI;EACE,SAAA;EACA,YAAA;EACA,iBAAA;EACA,iBAAA;AAilFN;AA/kFM;EACE,SAAA;EACA,YAAA;EACA,4CAAA;AAilFR;;AAxkFE;EACE,SAAA;EACA,YAAA;EACA,cAAA;EACA,oBAAA;AA2kFJ;AAzkFI;EACE,YAAA;EACA,SAAA;EACA,yCAAA;AA2kFN;;AAnkFE;EACE,WAAA;EACA,yBAAA;AAskFJ;AApkFI;EACE,mBDloGgB;ACwsLtB;AApkFM;EACE,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,cD7oGa;EC8oGb,gCAAA;EACA,gBAAA;EACA,mBAAA;EACA,wEDzrGK;AC+vLb;AAlkFI;EACE,gCAAA;EACA,iCAAA;AAokFN;AAlkFM;EAAU,mCAAA;AAqkFhB;AAnkFM;EACE,iBAAA;EACA,eAAA;EACA,cDnqGa;ECoqGb,sBAAA;EACA,gBAAA;AAqkFR;AAhkFE;EACE,cD3qGiB;EC4qGjB,qBAAA;EACA,gBAAA;EACA,4BAAA;AAkkFJ;AAhkFI;EAAU,uBD9rGE;ACiwLhB;;AA9jFA;EACE,2BAAA;AAikFF;;AA7jFA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,YAAA;EACA,cAAA;EACA,mBAAA;EACA,kCAAA;EACA,uBDjtGc;ECktGd,eAAA;EACA,gBAAA;EACA,eAAA;EACA,0BAAA;AAgkFF;AA9jFE;EACE,mCAAA;AAgkFJ;AA7jFE;EACE,oCAAA;EACA,WDxsGgB;ECysGhB,eAAA;AA+jFJ;AA7jFI;EAAU,oCAAA;AAgkFd;;AA3jFA;EACE,aAAA;EACA,kBAAA;EACA,qBAAA;EACA,SAAA;EACA,2BAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,yBAAA;EACA,mBAAA;EACA,2CAAA;EACA,gBAAA;AA8jFF;AA5jFE;EACE,kBAAA;EACA,YAAA;EACA,SAAA;EACA,2BAAA;EACA,WAAA;EACA,WAAA;EACA,gBAAA;AA8jFJ;AA5jFI;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,SAAA;EACA,yCAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,yBAAA;EACA,mBAAA;EACA,kBAAA;AA8jFN;AA1jFE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,mBD5vGkB;EC6vGlB,gCAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,cDrwGiB;ECswGjB,wED9yGS;AC02Lb;AA1jFI;EACE,eAAA;EACA,uBD7xGU;ACy1LhB;AAxjFE;EACE,gBAAA;EACA,SAAA;EACA,cAAA;EACA,iBAAA;EACA,gBAAA;AA0jFJ;AAvjFE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,eAAA;EACA,cDjyGiB;ECkyGjB,wEDr0GS;ECs0GT,0BAAA;EACA,gCAAA;AAyjFJ;AAvjFI;EACE,mCAAA;AAyjFN;AAtjFI;EACE,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,gBAAA;AAwjFN;AApjFE;EACE,cAAA;EACA,wBDh0GY;ECi0GZ,cAAA;AAsjFJ;;AAjjFA;EACE,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;AAojFF;;AAjjFA;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,2BAAA;EACA,iBAAA;AAojFF;;AAhjFA;EACE,yBAAA;EACA,qBAAA;EACA,sBAAA;EACA,yBAAA;EACA,0BAAA;EACA,6BAAA;EACA,YAAA;AAmjFF;AAjjFE;EAAQ,6CAAA;AAojFV;AAnjFE;EAAQ,6CAAA;AAsjFV;AArjFE;EAAQ,8CAAA;AAwjFV;AAvjFE;EAAQ,6CAAA;AA0jFV;;AApjFA;EACE,6GAAA;EACA,sBAAA;EACA,uBAAA;EACA,sCAAA;AAujFF;AArjFE;EACE,wBAAA;EACA,wBAAA;AAujFJ","sourcesContent":["// Font\n$font-stack: \"open sans\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n$muso-100: \"Museo-100\";\n$muso-300: \"Museo-300\";\n$muso-300-i: \"Museo-300Italic\";\n$muso-500: \"Museo-regular\";\n$muso-700: \"Museo-700\";\n$muso-700-i: \"Museo-700Italic\";\n$muso-sans: \"MuseoSans-300\";\n$car-font: \"Marydale\";\n$car-big-font: \"Bangers\", cursive;\n$font-museo: \"Conv_museo-500-webfont\";\n$font-helvetica: \"Helvetica\", \"open sans\";\n$MuseoSansCondensed-300: \"MuseoSansCondensed-300\";\n\n$fwBold: 700;\n\n//Foursight\n// $clarify-color: #06A6CE;\n// $ideate-color: #FF8300;\n// $develop-color: #7BBC43;\n// $implement-color: #FF485C;\n$clarify-color: rgba(0, 173, 208, 1);\n$ideate-color: rgba(255, 121, 0, 1);\n$develop-color: rgba(105, 190, 40, 1);\n$implement-color: rgba(245, 67, 89, 1);\n$low-clarify-color: rgba(0, 173, 208, 1);\n$low-ideate-color: rgba(255, 121, 0, 1);\n$low-develop-color: rgba(105, 190, 40, 1);\n$low-implement-color: rgba(245, 67, 89, 1);\n$profile-connector-color: #656668;\n// Profile Neutral color\n$integrator-color: #e3e3e3;\n// Team Report\n$report-integrator: #a7a7a7;\n// Body text color in reports\n$body-content-color: #676a6c;\n// Learner Map\n$gray-lm: rgba(0, 0, 0, 0.2);\n$border-color: #aaa;\n\n$color-neutral-dark: #6d6e71;\n$color-neutral-dark-500: #6a6a6a;\n$color-neutral-mid: #ccc;\n$color-neutral-light: #f1f1f2;\n$color-neutral-mid-old: #9e9e97;\n$color-dark-green: #4cae4c;\n$color-light-grey: #d9d9d9;\n$color-red: #ff485c;\n\n$color-grey-1: #e7eaec;\n\n$clrGray1: #f6f6f6;\n\n$clrDarkGray1: #ddd;\n\n$clrGrey: #eee;\n$clrWhite: #fff;\n$clrBlack: #000;\n$clrWarning: #f8ac59;\n\n$assets: \"https://assets.foursightonline.com/app\";\n$adminUpload: \"https://assets.foursightonline.com/admin-uploads/docs/\";\n\n$separator: \"\\//\";\n\n$active-class: #017ebc;\n\n// anchor Tag\n$anchor-color: #337ab7;\n\n//Sidebar\n$color-light-type: #fff;\n// submenu background\n$fs-dark-grey: #464646;\n// Hover\n$fs-active-light: #5f5f63;\n$fs-sidenav-bg: #333333;\n$fs-sidenav-hov-bg: #3e3e3f;\n$fs-green: #69be28;\n\n$clrInputAccent: #639935;\n\n$fn-fs-h1: 44px;\n$fn-fs-h1-mobile: 38px;\n$fn-lh-h1: 1.1;\n\n$fn-fs-h2: 38px;\n$fn-fs-h2-mobile: 32px;\n$fn-lh-h2: 1.2;\n\n$fn-fs-h3: 32px;\n$fn-fs-h3-mobile: 24px;\n$fn-lh-h3: 1.2;\n\n$fn-fs-h4: 24px;\n$fn-fs-h4-mobile: 20px;\n$fn-lh-h4: 1.2;\n\n$fn-fs-h5: 18px;\n$fn-lh-h5: 1.2;\n\n$fn-fs-h6: 16px;\n$fn-lh-h6: 1.3;\n\n$fn-title-subtext: 22px;\n$fn-title-subtext-mobile: 18px;\n\n$pageWidth: 1080px;\n$pageWidthSmall: 820px;\n$pageWidthFluid: 1200px;\n\n$secPad: 60px;\n\n$pageWidth: 1080px;\n$pageWidthFluid: 1200px;\n\n$desktop: \"only screen and (max-width: 1600px)\";\n$mac: \"only screen and (max-width: 1350px)\";\n$pc-up: \"only screen and (min-width: 1200px)\";\n$pc: \"only screen and (max-width: 1199px)\";\n$tablet-up: \"only screen and (min-width: 992px)\";\n$tablet: \"only screen and (max-width: 991px)\";\n$mobile-up: \"only screen and (min-width: 768px)\";\n$mobile: \"only screen and (max-width: 767px)\";\n$xl: \"only screen and (max-width: 1440px)\";\n$xl-up: \"only screen and (min-width: 1440px)\";\n\nimg {\n  max-width: 100%;\n}\n\n.flex {\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.dir-col {\n  flex-direction: column;\n}\n\n.dir-col-rev {\n  flex-direction: column-reverse;\n}\n\n.mh-full {\n  min-height: 100%;\n}\n\n.mt-auto {\n  margin-top: auto;\n}\n\n.bt-0 {\n  border-top: 0;\n}\n\n.bb-0 {\n  border-bottom: 0;\n}\n\n@mixin headingfont() {\n  font-family: $muso-700 !important;\n  font-weight: normal !important;\n}\n\n@mixin contentfont() {\n  font-family: $muso-300 !important;\n  font-weight: normal !important;\n}\n\n.fn-body {\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6 {\n    --hGap: 10px;\n    font-family: $muso-700;\n    color: $color-neutral-dark;\n    margin-bottom: var(--hGap);\n    margin-top: 0;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n  }\n\n  h1,\n  .h1-text {\n    font-size: $fn-fs-h1;\n    line-height: $fn-lh-h1;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h1-mobile;\n    }\n  }\n\n  h2,\n  .h2-text {\n    font-size: $fn-fs-h2;\n    line-height: $fn-lh-h2;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h2-mobile;\n    }\n  }\n\n  h3,\n  .h3-text {\n    font-size: $fn-fs-h3;\n    line-height: $fn-lh-h3;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h3-mobile;\n    }\n  }\n\n  h4,\n  .h4-text {\n    font-size: $fn-fs-h4;\n    line-height: $fn-lh-h4;\n  }\n\n  h5,\n  .h5-text {\n    font-size: $fn-fs-h5;\n    line-height: $fn-lh-h5;\n  }\n\n  h6,\n  .h6-text {\n    font-size: $fn-fs-h6;\n    line-height: $fn-lh-h6;\n  }\n\n  $fn-title-subtext: 22px;\n  $fn-title-subtext-mobile: 18px;\n\n  p {\n    font-size: 18px;\n    line-height: 1.6;\n    color: $color-neutral-dark-500;\n    margin-top: 0;\n    margin-bottom: 10px;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n\n    @media #{$mobile} {\n      font-size: 16px;\n    }\n  }\n\n  ul,\n  ol {\n    padding: 0;\n    margin: 0;\n  }\n\n  sup {\n    font-size: 0.7em;\n    position: relative;\n    top: 5px;\n    display: inline-block;\n    vertical-align: top;\n  }\n}\n\n.bg-grey {\n  background-color: $clrGrey;\n}\n\n.fn-container {\n  max-width: $pageWidth;\n  width: calc(100% - 30px);\n  margin-inline: auto;\n\n  @media #{$tablet-up} {\n    margin-left: 0;\n  }\n\n  &--fluid {\n    max-width: $pageWidthFluid;\n  }\n\n  &--small {\n    max-width: $pageWidthSmall;\n    width: 100%;\n  }\n}\n\n.text {\n  &-center {\n    text-align: center;\n  }\n\n  &-right {\n    text-align: right;\n  }\n}\n\n.d {\n  &-none {\n    display: none;\n  }\n}\n\n.section-title {\n  text-align: center;\n\n  &:not(:last-child) {\n    margin-bottom: calc($secPad - 20px);\n  }\n\n  h2 {\n    &:not(:last-child) {\n      margin-block-end: calc($secPad / 3);\n    }\n  }\n\n  p {\n    max-width: 900px;\n    width: 100%;\n    margin-inline: auto;\n    font-size: $fn-title-subtext;\n\n    &:not(:last-child) {\n      margin-block-end: calc($secPad / 3);\n    }\n\n    @media #{$mobile} {\n      font-size: $fn-title-subtext-mobile;\n    }\n  }\n\n  .section-title__linkcontainer {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    align-items: center;\n\n    &:not(:last-child) {\n      margin-block-end: 20px;\n    }\n\n    & > * {\n      margin: 5px;\n    }\n\n    .fn-btn {\n      padding-block: 6px;\n      padding-inline: 13px;\n      font-size: 12px;\n      font-family: $muso-sans;\n    }\n  }\n}\n\n.section-padding {\n  padding-block: $secPad;\n\n  @media #{$mobile} {\n    padding-block: ($secPad - 20px);\n  }\n\n  &-small {\n    padding-block: calc($secPad / 2);\n  }\n\n  &-all {\n    padding: $secPad;\n\n    @media #{$mobile} {\n      padding: calc($secPad / 2);\n    }\n\n    &-small {\n      padding: calc($secPad / 2);\n    }\n  }\n}\n\n.headline {\n  --lineSize: 10px;\n  width: fit-content;\n  padding-block-end: calc(10px + var(--lineSize));\n  margin-inline: auto;\n  position: relative;\n\n  &--small-border {\n    --lineSize: 6px;\n  }\n\n  &:not(:last-child) {\n    margin-bottom: calc(var(--hGap) * 2.5);\n  }\n\n  &::before {\n    content: \"\";\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: var(--lineSize);\n    background: linear-gradient(\n      90deg,\n      $clarify-color 0%,\n      $clarify-color 25%,\n      $ideate-color 25%,\n      $ideate-color 50%,\n      $develop-color 50%,\n      $develop-color 75%,\n      $implement-color 75%,\n      $implement-color 100%\n    );\n  }\n}\n\n.custom-list {\n  li {\n    font-size: 18px;\n    line-height: 1.4;\n    color: $color-neutral-dark-500;\n    list-style: none;\n    position: relative;\n    padding-left: 15px;\n\n    &:not(:last-child) {\n      margin-bottom: 4px;\n    }\n\n    &::before {\n      content: \"\";\n      position: absolute;\n      top: 10px;\n      left: 0;\n      width: 3px;\n      height: 3px;\n      background-color: var(--clrProfile);\n    }\n  }\n}\n\n.color-clarify {\n  --clrProfile: #{$clarify-color};\n}\n\n.color-ideate {\n  --clrProfile: #{$ideate-color};\n}\n\n.color-develop {\n  --clrProfile: #{$develop-color};\n}\n\n.color-implement {\n  --clrProfile: #{$implement-color};\n}\n\n.fn-btn {\n  padding-block: 20px;\n  padding-inline: 28px;\n  background-color: $develop-color;\n  color: $clrWhite;\n  font-size: 18px;\n  line-height: 1.2;\n  display: inline-block;\n  font-family: $muso-700;\n  text-decoration: none;\n  word-break: break-all;\n  text-align: center;\n  transition: background-color 0.3s;\n\n  &:focus {\n    outline: 1px dashed $color-neutral-dark-500;\n    outline-offset: 4px;\n  }\n\n  &:hover {\n    background-color: $color-neutral-dark;\n    color: $clrWhite;\n  }\n\n  &--sm {\n    font-size: 14px;\n    padding-block: 10px;\n    padding-inline: 20px;\n  }\n\n  &--grey {\n    background-color: $color-neutral-light;\n    color: $color-neutral-dark;\n  }\n\n  &--ongoing {\n    background-color: $clrWarning;\n    color: $clrWhite;\n\n    i {\n      animation: spin 0.3s infinite;\n    }\n  }\n}\n\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.color-clarify {\n  --clrProfile: #{$clarify-color};\n}\n\n.color-ideate {\n  --clrProfile: #{$ideate-color};\n}\n\n.color-develop {\n  --clrProfile: #{$develop-color};\n}\n\n.color-implement {\n  --clrProfile: #{$implement-color};\n}\n\n.w-4 {\n  width: calc(100% / 3);\n}\n\n.w-3 {\n  width: calc(100% / 4);\n\n  &--wd {\n    width: calc(100% / 3);\n  }\n}\n\n.w-6 {\n  width: calc(100% / 2);\n}\n\n.fn {\n  &-row {\n    --rGap: 15px;\n    --rGap-minus: calc(-1 * var(--rGap));\n\n    display: flex;\n    flex-wrap: wrap;\n    margin-inline: var(--rGap-minus);\n\n    &--col-gap-exist {\n      .fn-col {\n        margin-bottom: calc($secPad / 2);\n      }\n    }\n  }\n\n  &-col {\n    padding-inline: var(--rGap);\n  }\n\n  &-justify-center {\n    justify-content: center;\n  }\n\n  &-items-center {\n    align-items: center;\n  }\n}\n\n.m {\n  &x-auto {\n    margin-inline: auto;\n  }\n\n  &l-auto {\n    margin-inline-start: auto;\n  }\n\n  &l-0 {\n    margin-inline-start: 0;\n  }\n\n  &r-auto {\n    margin-inline-end: auto;\n  }\n\n  &r-0 {\n    margin-inline-end: 0;\n  }\n}\n","@import \"./../../../assets/styles/variables\";\n@import \"./../teams/teams.component.scss\";\n\n.orgs_team {\n  padding-block: 10px 48px;\n\n  &--pdt0 {\n    padding-top: 0;\n  }\n\n  &__view {\n    gap: 10px;\n\n    & > div {\n      background-color: $clrWhite;\n      color: $body-content-color;\n      border: 1px solid $color-grey-1;\n      padding-inline: 6px;\n      border-radius: 4px;\n\n      &.active {\n        background-color: $body-content-color;\n        color: $clrWhite;\n        border-color: $body-content-color;\n      }\n    }\n    // .hierar {\n    //   background-color: $body-content-color;\n    //   color: $clrWhite;\n    //   padding-inline: 6px;\n    //   border-radius: 4px;\n    // }\n\n    .f-btn {\n      display: flex;\n      align-items: center;\n      padding-block: 3px;\n      border-radius: 4px;\n      gap: 8px;\n      font-weight: 500;\n      padding-inline: 10px;\n    }\n  }\n\n  &__invite {\n    select {\n      width: 100%;\n      padding-block: 7px;\n      border: 1px solid $color-grey-1;\n      border-radius: 5px;\n    }\n  }\n\n  &__tab {\n    border-bottom: 1px solid $color-grey-1;\n\n    &--txt {\n      font-size: 16px;\n      font-weight: 700;\n    }\n\n    ul {\n      padding: 0;\n      margin: 0;\n    }\n\n    li {\n      list-style: none;\n      position: relative;\n\n      &:not(:last-child) {\n        margin-right: 16px;\n        padding-right: 18px;\n\n        &::after {\n          content: \"\";\n          position: absolute;\n          top: 0;\n          bottom: -1px;\n          right: 0;\n          margin-block: auto;\n          width: 1px;\n          height: 18px;\n          background-color: $color-grey-1;\n        }\n      }\n\n      &.active {\n        button {\n          font-weight: 700;\n\n          &::after {\n            display: block;\n          }\n        }\n      }\n\n      button {\n        font-size: 16px;\n        font-weight: 500;\n        font-family: $font-stack;\n        border: 0;\n        padding: 16px 0;\n        background-color: transparent;\n        position: relative;\n        color: $body-content-color;\n        transition: all ease 0.3s;\n\n        &:hover {\n          color: lighten($body-content-color, 20%);\n        }\n\n        &::after {\n          content: \"\";\n          position: absolute;\n          right: 0;\n          bottom: 0;\n          left: 0;\n          height: 2px;\n          background-color: #74bf24;\n          display: none;\n        }\n      }\n    }\n  }\n\n  &__branch {\n    background-color: $color-neutral-light;\n    border: 1px solid $color-grey-1;\n    border-radius: 4px;\n    padding: 14px 18px;\n\n    @media #{$mobile} {\n      padding: 10px;\n    }\n\n    &_srch {\n      background-color: #fff;\n      padding: 6px 7px;\n      border-radius: 4px;\n      position: relative;\n\n      & > div {\n        gap: 10px;\n      }\n\n      // &::before {\n      //   content: \"\";\n      //   position: absolute;\n      //   right: 134px;\n      //   bottom: 99%;\n      //   background-color: #fff;\n      //   width: 25px;\n      //   height: 12px;\n      //   clip-path: polygon(0 100%, 50% 0, 100% 100%);\n\n      //   @media #{$mobile} {\n      //     right: 0;\n      //     left: 7px;\n      //     width: 20px;\n      //   }\n\n      // }\n\n      &_inp {\n        border: 1px solid $color-grey-1;\n        border-radius: 4px;\n        max-width: 200px;\n        flex-grow: 1;\n        padding: 8px;\n\n        @media #{$tablet} {\n          width: 100%;\n          max-width: none;\n        }\n\n        & + div {\n          flex-grow: 1;\n\n          input {\n            width: 100%;\n            height: 100%;\n            padding: 8px;\n            font-weight: 600;\n            border: 1px solid $color-grey-1;\n            outline: 0;\n          }\n        }\n\n        h3 {\n          margin: 0;\n        }\n\n        select {\n          border: 0;\n          font-weight: 600;\n          color: $body-content-color;\n        }\n      }\n      &_sort {\n        background-color: transparent;\n        border-right: 1px solid;\n        padding: 4px 6px;\n        margin-right: 4px;\n\n        &--nobdr {\n          border-right: 0;\n        }\n\n        &--pl0 {\n          padding-left: 0;\n        }\n\n        &:hover {\n          span {\n            position: absolute;\n            display: inline-block;\n            top: -33px;\n            left: -5px;\n            padding: 1px 6px 2px;\n            background: #676a6c;\n            color: #fff;\n            border-radius: 4px;\n            min-width: 42px;\n            text-align: center;\n\n            &::after {\n              border-left: 10px solid transparent;\n              border-right: 10px solid transparent;\n              border-top: 10px solid #676a6c;\n              margin: 2rem;\n              content: \"\";\n              position: absolute;\n              left: -22px;\n              top: -11px;\n            }\n          }\n        }\n\n        span {\n          display: none;\n        }\n\n        img {\n          max-width: 15px;\n          min-height: 15px;\n        }\n      }\n\n      button {\n        border: 0;\n        border-radius: 50%;\n      }\n    }\n\n    &_hdr {\n      display: flex;\n      flex-wrap: wrap;\n      align-items: center;\n      grid-gap: 10px;\n      padding: 10px 20px 10px 0;\n      position: relative;\n\n      &:not(:last-child) {\n        margin-bottom: 15px;\n      }\n\n      &--mpb0 {\n        margin-bottom: 0px !important;\n        padding-bottom: 0 !important;\n      }\n\n      &_title {\n        font-size: 14px;\n        line-height: 1.3;\n        font-weight: 700;\n        font-family: $font-stack;\n        display: flex;\n        flex-wrap: wrap;\n        // align-items: center;\n        grid-gap: 4px;\n        margin-right: auto;\n\n        @media #{$mobile} {\n          width: 100%;\n        }\n\n        i {\n          font-size: 20px;\n        }\n\n        .fmt {\n          font-size: 12px;\n          font-weight: 600;\n        }\n      }\n\n      &_search,\n      &_sorting,\n      &_filter {\n        position: relative;\n\n        &:hover > button {\n          border-color: $color-grey-1;\n          background-color: transparent;\n        }\n\n        & > button {\n          background-color: #fff;\n          border: 1px solid #fff;\n          border-radius: 4px;\n          padding: 4px 10px;\n          font-size: 12px;\n          font-weight: 600;\n          color: $body-content-color;\n          transition: 0.3s;\n\n          &.no_profile_link {\n            background-color: transparent;\n            border: 0;\n            padding: 0;\n            font-size: 14px;\n          }\n        }\n      }\n\n      &_search {\n        .orgs_team__branch_hdr_search_body {\n          display: block;\n        }\n      }\n\n      &_sorting,\n      &_filter {\n        &:hover > &_body {\n          display: block;\n        }\n      }\n\n      &_search_body,\n      &_sorting_body,\n      &_filter_body {\n        position: absolute;\n        top: 100%;\n        right: -45px;\n        padding-top: 26px;\n        z-index: 100;\n        display: none;\n\n        ul {\n          width: 100%;\n          background-color: #fff;\n          list-style: none;\n          margin: 0;\n          padding: 0;\n          box-shadow: 0px 3px 7px rgba(0, 0, 0, 0.17);\n          white-space: nowrap;\n          position: relative;\n          border-radius: 4px;\n          min-width: 152px;\n\n          &::before {\n            content: \"\";\n            position: absolute;\n            right: 59px;\n            bottom: 99%;\n            background-color: #fff;\n            width: 25px;\n            height: 12px;\n            clip-path: polygon(0 100%, 50% 0, 100% 100%);\n          }\n        }\n\n        li {\n          &:not(:last-child) {\n            border-bottom: 1px solid $color-grey-1;\n          }\n        }\n\n        button {\n          border: 0;\n          padding: 13px 17px;\n          background-color: transparent;\n          font-size: 12px;\n          font-weight: 600;\n          color: $body-content-color;\n          width: 100%;\n          text-align: left;\n          display: flex;\n          align-items: center;\n          grid-gap: 10px;\n\n          span {\n            width: 20px;\n            height: 20px;\n            background: $color-grey-1;\n            display: flex;\n            justify-content: center;\n            align-items: center;\n            border-radius: 50%;\n            font-size: 10px;\n            margin-left: auto;\n          }\n\n          &:hover {\n            border-color: $color-grey-1;\n            background-color: transparent;\n          }\n        }\n\n        &:hover > &_body {\n          display: block;\n        }\n      }\n\n      &_search_body,\n      &_sorting_body,\n      &_filter_body {\n        position: absolute;\n        top: 100%;\n        right: -45px;\n        padding-top: 26px;\n        z-index: 100;\n        display: none;\n\n        ul {\n          width: 100%;\n          background-color: #fff;\n          list-style: none;\n          margin: 0;\n          padding: 0;\n          box-shadow: 0px 3px 7px rgba(0, 0, 0, 0.17);\n          white-space: nowrap;\n          position: relative;\n          border-radius: 4px;\n          min-width: 152px;\n\n          &::before {\n            content: \"\";\n            position: absolute;\n            right: 59px;\n            bottom: 99%;\n            background-color: #fff;\n            width: 25px;\n            height: 12px;\n            clip-path: polygon(0 100%, 50% 0, 100% 100%);\n          }\n        }\n\n        li {\n          &:not(:last-child) {\n            border-bottom: 1px solid $color-grey-1;\n          }\n        }\n\n        button,\n        a {\n          border: 0;\n          padding: 13px 17px;\n          background-color: transparent;\n          font-size: 12px;\n          font-weight: 600;\n          color: $body-content-color;\n          width: 100%;\n          text-align: left;\n          display: flex;\n          align-items: center;\n          grid-gap: 10px;\n\n          span {\n            width: 20px;\n            height: 20px;\n            background: $color-grey-1;\n            display: flex;\n            justify-content: center;\n            align-items: center;\n            border-radius: 50%;\n            font-size: 10px;\n            margin-left: auto;\n          }\n\n          &:hover {\n            color: $develop-color;\n          }\n        }\n      }\n\n      &_search_body {\n        @media #{$mobile} {\n          right: auto;\n          left: 0;\n        }\n\n        &_form {\n          list-style: none;\n          white-space: nowrap;\n          position: relative;\n          min-width: 300px;\n\n          @media #{$desktop} {\n            min-width: 200px;\n          }\n\n          &::before {\n            content: \"\";\n            position: absolute;\n            right: 49px;\n            bottom: 99%;\n            background-color: #fff;\n            width: 25px;\n            height: 12px;\n            clip-path: polygon(0 100%, 50% 0, 100% 100%);\n\n            @media #{$mobile} {\n              right: auto;\n              left: 10px;\n            }\n          }\n\n          input {\n            width: 100%;\n            height: 45px;\n            border: 0;\n            outline: none;\n            border-radius: 4px;\n            background-color: #fff;\n            color: rgba(103, 106, 108, 0.3);\n            box-shadow: 0px 3px 7px rgba(0, 0, 0, 0.17);\n            font-family: $font-stack;\n            font-size: 12px;\n            font-weight: 600;\n            padding: 15px;\n            padding-right: 60px;\n          }\n        }\n\n        &_clear_button {\n          position: absolute;\n          top: 5px;\n          right: 0px;\n          background-color: transparent !important;\n          width: 26px !important;\n          height: 26px;\n          border-radius: 50%;\n          padding: 0 !important;\n\n          i {\n            position: absolute;\n            top: 50%;\n            left: 50%;\n            transform: translate(-50%, -50%);\n          }\n        }\n      }\n\n      &_dropdown_2 {\n        position: absolute;\n        top: 29%;\n        transform: translateY(-29%);\n        right: 0;\n\n        & > button {\n          border: 0;\n          background-color: transparent;\n          padding: 0;\n          display: flex;\n          justify-content: center;\n          align-items: center;\n          transition: 0.3s;\n\n          &:hover {\n            color: $develop-color;\n          }\n        }\n      }\n    }\n\n    &_body {\n      & > :not(:last-child) {\n        margin-bottom: 15px;\n      }\n    }\n\n    &_list {\n      // & > :not(:last-child) {\n      //   margin-bottom: 7px;\n      // }\n\n      .f-d-none {\n        display: none;\n      }\n    }\n\n    &_item {\n      display: flex;\n      // flex-wrap: wrap;\n      align-items: center;\n      grid-gap: 12px;\n      background-color: #fff;\n      padding: 15px 19px;\n      border: 1px solid $color-grey-1;\n      border-top: 0;\n      // border-radius: 4px;\n      transition: all ease 0.3s;\n\n      &:hover {\n        box-shadow: 0 0 20px rgba(0, 0, 0, 0.05);\n      }\n    }\n\n    &_title {\n      display: flex;\n      // flex-wrap: wrap;\n      align-items: center;\n      grid-gap: 8px;\n      margin-right: auto;\n      width: 88%;\n\n      &--wd {\n        width: 100%;\n      }\n\n      @media #{$mobile} {\n        width: 100%;\n        max-width: 150px;\n      }\n\n      &_name {\n        font-size: 14px;\n        line-height: 1.3;\n        font-weight: 600;\n        color: $body-content-color;\n        text-transform: capitalize;\n        gap: 8px;\n\n        input[type=\"checkbox\"] {\n          accent-color: #639935;\n        }\n\n        &.active {\n          font-weight: 700;\n        }\n\n        @media #{$mobile} {\n          width: 100%;\n        }\n      }\n\n      &_study {\n        background-color: $body-content-color;\n        padding: 1px 6px;\n        border-radius: 5px;\n        color: #fff;\n        font-size: 12px;\n        font-weight: 600;\n      }\n\n      &_utype {\n        background-color: $color-neutral-light;\n        padding: 1px 6px;\n        border-radius: 5px;\n        color: $body-content-color;\n        font-size: 12px;\n        font-weight: 600;\n\n        &--bgw {\n          background-color: #fff;\n        }\n\n        &--mail {\n          margin-left: auto;\n\n          .full-mail {\n            display: none;\n          }\n\n          &:hover {\n            .short-mail {\n              display: none;\n            }\n\n            .full-mail {\n              display: inline-block;\n              transition: all 300ms ease;\n            }\n          }\n        }\n      }\n    }\n\n    &_count {\n      font-size: 10px;\n      font-weight: 600;\n      color: $body-content-color;\n      background-color: $color-neutral-light;\n      border-radius: 2px;\n      padding: 3px 7px;\n      position: relative;\n\n      ul {\n        position: absolute;\n        top: 100%;\n        left: 50%;\n        transform: translateX(-50%);\n        color: #676a6c;\n        background-color: #fff;\n        padding: 6px;\n        box-shadow: 0 0 18px rgba(0, 0, 0, 0.1);\n        font-size: 13px;\n        z-index: 1;\n        display: none;\n        min-width: 130px;\n        padding-left: 20px;\n        margin: 0;\n      }\n\n      &:hover > ul {\n        display: block;\n      }\n    }\n\n    &_dropdown {\n      position: relative;\n\n      &:hover {\n        & > &_button {\n          span {\n            background-color: $develop-color;\n          }\n        }\n\n        & > .orgs_team__branch_dropdown_body {\n          display: block;\n        }\n      }\n\n      & > button {\n        border: 0;\n        padding: 0;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        flex-direction: column;\n        grid-gap: 2px;\n        background-color: transparent;\n        width: 20px;\n        aspect-ratio: 1;\n        border-radius: 50%;\n\n        span {\n          display: block;\n          width: 2px;\n          aspect-ratio: 1;\n          background-color: $body-content-color;\n          border-radius: 50%;\n        }\n      }\n\n      &_body {\n        position: absolute;\n        top: 100%;\n        right: -5px;\n        padding-top: 12px;\n        z-index: 100;\n        display: none;\n\n        ul {\n          width: 100%;\n          background-color: #fff;\n          list-style: none;\n          margin: 0;\n          padding: 0;\n          box-shadow: 0px 1px 15px rgba(0, 0, 0, 0.17);\n          white-space: nowrap;\n          position: relative;\n          min-width: 130px;\n          border-radius: 4px;\n\n          &::before {\n            content: \"\";\n            position: absolute;\n            right: 7px;\n            bottom: 100%;\n            background-color: #fff;\n            width: 16px;\n            height: 9px;\n            clip-path: polygon(0 100%, 50% 0, 100% 100%);\n          }\n        }\n\n        li {\n          position: relative;\n\n          &:hover > .orgs_team__branch_dropdown_body_2 {\n            display: block;\n          }\n\n          &:not(:last-child) {\n            border-bottom: 1px solid $color-grey-1;\n          }\n\n          button,\n          a {\n            border: 0;\n            padding: 13px 17px;\n            background-color: transparent;\n            font-size: 12px;\n            font-weight: 600;\n            color: $body-content-color;\n            width: 100%;\n            text-align: left;\n            display: block;\n\n            &:hover {\n              color: $develop-color;\n            }\n          }\n        }\n\n        &_2 {\n          position: absolute;\n          top: 0;\n          right: 100%;\n          padding-right: 12px;\n          display: none;\n\n          ul {\n            &::before {\n              clip-path: polygon(0 0, 100% 50%, 0 100%);\n              left: 100%;\n              top: 11px;\n              width: 9px;\n              height: 14px;\n            }\n          }\n        }\n\n        .disabled {\n          cursor: not-allowed;\n          opacity: 0.7;\n        }\n      }\n    }\n\n    &_load_more {\n      padding: 0;\n      background-color: transparent;\n      border: 0;\n      font-size: 14px;\n      font-weight: 600;\n      color: $body-content-color;\n      width: 100%;\n      text-align: center;\n\n      i {\n        transition: 0.3s;\n      }\n\n      &:hover {\n        color: $develop-color;\n\n        & > i {\n          transform: rotate(360deg);\n        }\n      }\n    }\n  }\n\n  &__block {\n    &_row {\n      grid-row-gap: 30px;\n\n      .f-col-5 {\n        width: 37%;\n\n        @media #{$desktop} {\n          width: 520px;\n        }\n\n        @media #{$pc} {\n          width: 45%;\n        }\n\n        @media #{$tablet} {\n          width: 100%;\n          padding-left: 15px;\n        }\n      }\n      .f-col-7 {\n        width: 63%;\n\n        @media #{$desktop} {\n          width: calc(100% - 520px);\n        }\n\n        @media #{$pc} {\n          width: 55%;\n        }\n\n        @media #{$tablet} {\n          width: 100%;\n        }\n      }\n\n      @media #{$pc} {\n        & > div {\n          width: 100%;\n        }\n      }\n    }\n\n    &_btn {\n      width: 100%;\n      text-align: right;\n      padding-block: 10px;\n\n      button {\n        background-color: transparent;\n        border: 0;\n        color: $body-content-color;\n        font-weight: 500;\n        margin-right: 0;\n      }\n    }\n  }\n\n  &__list {\n    &_row {\n      grid-row-gap: 20px;\n      \n      @media (max-width: 1399px) {\n        .f-col-4 {\n          width: 50%;\n        }\n      }\n      @media (max-width: 1800px) {\n        .f-col-3 {\n          width: calc(100% / 3);\n        }\n      }\n\n      @media #{$mac} {\n        .f-col-3 {\n          width: 50%;\n        }\n      }\n\n      // @media #{$pc} {\n\n      //   .f-col-3 {\n      //     width: 100%;\n      //   }\n      // }\n\n      // @media #{$tablet} {\n\n      //   .f-col-3 {\n      //     width: 50%;\n      //   }\n      // }\n\n      @media #{$mobile} {\n        .f-col-3 {\n          width: 100%;\n        }\n      }\n    }\n  }\n\n  &__members {\n    border: 1px solid $color-grey-1;\n    border-radius: 4px;\n\n    &_body {\n      display: flex;\n      flex-wrap: wrap;\n      // flex-direction: column;\n      max-height: 249px;\n      overflow-y: auto;\n\n      &--of {\n        overflow-y: auto;\n        max-height: 249px;\n      }\n\n      &--ofh {\n        max-height: none;\n        overflow-y: visible;\n      }\n\n      &--mh_increased {\n        max-height: 498px;\n      }\n\n      &_item {\n        order: 2;\n\n        &.active {\n          order: 1;\n          border-bottom: 1px solid $color-grey-1;\n        }\n      }\n    }\n\n    &_hdr {\n      background-color: $color-neutral-light;\n      padding: 10px 15px;\n      grid-gap: 7px;\n\n      &_content {\n        font-size: 14px;\n        font-weight: 700;\n        line-height: 1.3;\n        font-family: $font-stack;\n        margin-right: auto;\n        text-transform: capitalize;\n        // width: calc(100% - 70px);\n        display: flex;\n        gap: 5px;\n        align-items: center;\n        flex: 1;\n\n        span {\n          font-size: 12px;\n          font-weight: 600;\n\n          &.full-mail {\n            display: none;\n          }\n          &.short-mail {\n            display: block;\n          }\n        }\n\n        &--name {\n          &:hover {\n            .full-mail {\n              display: block;\n            }\n            .short-mail {\n              display: none;\n            }\n          }\n        }\n      }\n\n      &_dropdown_1 {\n        position: relative;\n\n        &:hover {\n          & > button {\n            background-color: transparent;\n          }\n\n          & > .orgs_team__members_hdr_dropdown_1_body {\n            display: block;\n          }\n        }\n\n        & > button,\n        & > a {\n          width: 18px;\n          height: 19px;\n          padding: 2px;\n          background-color: #fff;\n          border: 1px solid $color-grey-1;\n          border-radius: 3px;\n          display: flex;\n          flex-direction: column;\n          justify-content: center;\n          align-items: center;\n          grid-gap: 2px;\n\n          &:hover {\n            background-color: $develop-color;\n            border-color: $develop-color;\n\n            span {\n              background-color: $clrWhite;\n            }\n          }\n\n          span {\n            display: block;\n            width: 2px;\n            aspect-ratio: 1;\n            background-color: $body-content-color;\n            border-radius: 50%;\n          }\n        }\n\n        &_body {\n          position: absolute;\n          top: 100%;\n          right: -21px;\n          min-width: 133px;\n          padding-top: 13px;\n          display: none;\n          z-index: 9;\n\n          ul {\n            width: 100%;\n            background-color: #fff;\n            list-style: none;\n            margin: 0;\n            padding: 0;\n            box-shadow: 0px 3px 7px rgba(0, 0, 0, 0.17);\n            white-space: nowrap;\n            position: relative;\n            border-radius: 4px;\n\n            &::before {\n              content: \"\";\n              position: absolute;\n              right: 20px;\n              bottom: 100%;\n              background-color: #fff;\n              width: 20px;\n              height: 10px;\n              clip-path: polygon(0 100%, 50% 0, 100% 100%);\n            }\n          }\n\n          li {\n            &:not(:last-child) {\n              border-bottom: 1px solid $color-grey-1;\n            }\n\n            &:not(.orgs_team__members_hdr_dropdown_1_body_add_btn) button,\n            &:not(.orgs_team__members_hdr_dropdown_1_body_add_btn) a {\n              border: 0;\n              padding: 13px 17px;\n              background-color: transparent;\n              font-size: 12px;\n              font-weight: 600;\n              color: $body-content-color;\n              width: 100%;\n              text-align: left;\n              display: inline-block;\n\n              &:hover {\n                color: $develop-color;\n              }\n            }\n\n            a {\n              width: 100%;\n            }\n          }\n\n          &_add_btn {\n            padding: 13px 17px;\n          }\n        }\n      }\n\n      &_dropdown_2 {\n        & > button {\n          padding: 0;\n          border: 0;\n          background-color: transparent;\n          transition: 0.3s;\n\n          &:hover {\n            color: $develop-color;\n          }\n        }\n      }\n    }\n\n    &_body {\n      &_item {\n        padding: 14px 10px 14px 18px;\n        display: flex;\n        // flex-wrap: wrap;\n        align-items: center;\n        grid-gap: 10px;\n        width: 100%;\n\n        &:not(:last-child) {\n          border-bottom: 1px solid $color-grey-1;\n        }\n      }\n    }\n\n    &_title {\n      font-size: 14px;\n      font-weight: 600;\n      color: $body-content-color;\n      flex: 1 1 auto;\n      min-width: 0;\n      display: flex;\n      flex-wrap: nowrap;\n      align-items: center;\n      grid-gap: 6px;\n\n      &_name {\n        flex: 1 1 auto;\n        min-width: 0;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        white-space: nowrap;\n\n        &.active {\n          font-weight: 700;\n        }\n      }\n\n      span {\n        flex-shrink: 0;\n        background-color: $body-content-color;\n        padding: 1px 6px;\n        border-radius: 5px;\n        color: #fff;\n        font-size: 12px;\n        display: inline-block;\n      }\n    }\n\n    &_dropdown {\n      margin-left: auto;\n      position: relative;\n\n      &--ml0 {\n        margin-left: 0;\n      }\n\n      &:hover {\n        & > .orgs_team__members_dropdown_button {\n          span {\n            background-color: $develop-color;\n          }\n        }\n\n        & > .orgs_team__members_dropdown_body {\n          display: block;\n        }\n      }\n\n      & > button {\n        border: 0;\n        padding: 0;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        flex-direction: column;\n        grid-gap: 2px;\n        background-color: transparent;\n        width: 20px;\n        aspect-ratio: 1;\n        border-radius: 50%;\n\n        span {\n          display: block;\n          width: 2px;\n          aspect-ratio: 1;\n          background-color: $body-content-color;\n          border-radius: 50%;\n        }\n      }\n\n      &_body {\n        position: absolute;\n        top: 100%;\n        right: -5px;\n        padding-top: 12px;\n        z-index: 100;\n        display: none;\n\n        ul {\n          width: 100%;\n          background-color: #fff;\n          list-style: none;\n          margin: 0;\n          padding: 0;\n          box-shadow: 0px 1px 15px rgba(0, 0, 0, 0.17);\n          white-space: nowrap;\n          position: relative;\n          min-width: 130px;\n          border-radius: 4px;\n\n          &::before {\n            content: \"\";\n            position: absolute;\n            right: 7px;\n            bottom: 100%;\n            background-color: #fff;\n            width: 16px;\n            height: 9px;\n            clip-path: polygon(0 100%, 50% 0, 100% 100%);\n          }\n        }\n\n        li {\n          position: relative;\n\n          &:hover > .orgs_team__members_dropdown_body_2 {\n            display: block;\n          }\n\n          &:not(:last-child) {\n            border-bottom: 1px solid $color-grey-1;\n          }\n\n          button,\n          a {\n            border: 0;\n            padding: 13px 17px;\n            background-color: transparent;\n            font-size: 12px;\n            font-weight: 600;\n            color: $body-content-color;\n            width: 100%;\n            text-align: left;\n\n            a,\n            button {\n              padding: 0;\n            }\n\n            &:hover {\n              color: $develop-color;\n            }\n          }\n        }\n\n        &_2 {\n          position: absolute;\n          top: 0;\n          right: 100%;\n          padding-right: 12px;\n          display: none;\n\n          ul {\n            &::before {\n              clip-path: polygon(0 0, 100% 50%, 0 100%);\n              left: 100%;\n              top: 11px;\n              width: 9px;\n              height: 14px;\n            }\n          }\n        }\n      }\n    }\n\n    &_load_more {\n      padding: 14px 10px 14px 18px;\n      background-color: transparent;\n      border: 0;\n      font-size: 14px;\n      font-weight: 600;\n      color: $body-content-color;\n      width: 100%;\n      text-align: center;\n      order: 2;\n      border-top: 1px solid #e7eaec;\n\n      i {\n        transition: 0.3s;\n      }\n\n      &:hover {\n        color: $develop-color;\n\n        & > i {\n          transform: rotate(360deg);\n        }\n      }\n    }\n  }\n\n  &__pagination {\n    flex-wrap: nowrap;\n    gap: 20px;\n\n    .records_select {\n      flex-shrink: 0;\n      label{\n        font-weight: 700\n      }\n    }\n  }\n}\n\n.teams_popup {\n  position: fixed;\n  inset: 0;\n  background: rgba(255, 255, 255, 0.81);\n  z-index: 99;\n  transition: all ease 0.3s;\n\n  @media #{$mobile-up} {\n    padding-left: 220px;\n  }\n\n  ::ng-deep .mini-navbar & {\n    padding-left: 70px;\n  }\n\n  &__wrapper {\n    width: 100%;\n    height: 100%;\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    align-items: flex-start;\n    overflow-y: auto;\n    padding: 30px;\n  }\n\n  &__inner {\n    max-width: 500px;\n    width: 100%;\n    border: 1px solid $color-grey-1;\n    border-radius: 4px;\n    padding: 13px 26px 15px;\n    position: relative;\n    background-color: $clrWhite;\n  }\n\n  &__close_button {\n    --line_thickness: 2px;\n    --line_length: 98%;\n    --button_pos: 15px;\n    background-color: transparent;\n    border: 0;\n    padding: 0;\n    position: absolute;\n    top: var(--button_pos);\n    right: var(--button_pos);\n    font-size: 14px;\n    color: $body-content-color;\n    width: 12px;\n    aspect-ratio: 1;\n\n    &_inner {\n      position: absolute;\n      inset: 0;\n      transform: rotate(45deg);\n\n      &::before,\n      &::after {\n        content: \"\";\n        position: absolute;\n        top: 50%;\n        left: 0;\n        transform: translateY(-50%);\n        width: var(--line_length);\n        height: var(--line_thickness);\n        background-color: $body-content-color;\n        transition: all ease 0.3s;\n      }\n\n      &::after {\n        top: auto;\n        left: 50%;\n        transform: translateX(-50%);\n        width: var(--line_thickness);\n        height: var(--line_length);\n      }\n    }\n\n    &:hover {\n      & > .teams_popup__close_button_inner {\n        &::before,\n        &::after {\n          background-color: $develop-color;\n        }\n      }\n    }\n  }\n\n  &__body {\n    & > :not(:last-child) {\n      margin-bottom: 14px;\n    }\n  }\n\n  &__header {\n    & > :not(:last-child) {\n      margin-bottom: 0;\n    }\n\n    h2 {\n      color: $body-content-color;\n      font-family: $font-stack;\n      font-size: 18px;\n      font-weight: 600;\n\n      span {\n        font-size: 0.8em;\n      }\n    }\n  }\n\n  &__team_list {\n    border: 1px solid $color-grey-1;\n    border-radius: 4px;\n  }\n\n  &__team_item {\n    padding: 13px 20px;\n    font-weight: 600;\n    color: $body-content-color;\n    display: block;\n    width: 100%;\n    cursor: pointer;\n    transition: all ease 0.3s;\n\n    &:hover {\n      background-color: $clrGray1;\n    }\n\n    &:not(:last-child) {\n      border-bottom: 1px solid $color-grey-1;\n    }\n\n    input[type=\"checkbox\"] {\n      accent-color: #639935;\n    }\n  }\n\n  &__rename_team_field {\n    input {\n      width: 100%;\n      border: 1px solid $color-grey-1;\n      padding: 10px;\n\n      &:focus {\n        border-color: $develop-color;\n        outline: none;\n      }\n    }\n  }\n}\n\n// delete team\n\n::ng-deep .mini-navbar .swal2-container {\n  padding-left: 85px;\n}\n\n::ng-deep .swal2-container {\n  padding: 30px;\n\n  @media #{$mobile-up} {\n    padding-left: 220px;\n  }\n\n  @media #{$mobile} {\n    padding-top: 50px;\n    padding-inline: 15px;\n  }\n\n  .swal2-modal {\n    align-self: center !important;\n    grid-row: auto !important;\n    height: auto !important;\n    margin: 0 !important;\n    border: 1px solid #e7eaec !important;\n    border-radius: 4px !important;\n    padding: 13px 26px 25px !important;\n    position: static !important;\n    background-color: $clrWhite !important;\n\n    & > * {\n      margin-block: 0 !important;\n    }\n\n    & > :not(:last-child) {\n      margin-bottom: 14px !important;\n    }\n  }\n\n  .swal2-actions {\n    margin-bottom: 0 !important;\n    padding-bottom: 20px !important;\n    grid-gap: 10px !important;\n\n    button {\n      min-width: 130px !important;\n      margin: 0 !important;\n      font-size: 14px !important;\n      padding-top: 10px !important;\n      padding-bottom: 9px !important;\n      padding-inline: 20px !important;\n    }\n\n    .swal2-confirm {\n      background-color: $develop-color !important;\n\n      &:hover {\n        background-color: $color-dark-green !important;\n        color: $clrWhite;\n      }\n    }\n  }\n\n  h2 {\n    font-size: 18px !important;\n    line-height: 1.3 !important;\n    font-weight: 600 !important;\n    color: $body-content-color !important;\n  }\n\n  .swal2-html-container {\n    font-size: 16px !important;\n    line-height: 150% !important;\n  }\n}\n// delete team end\n\n.fa-angle-down.active {\n  transform: rotate(180deg);\n}\n\n.org_mem {\n  width: 46%;\n  justify-content: space-between;\n\n  li {\n    font-weight: 600;\n    &::after {\n      display: none;\n    }\n  }\n}\n\n#holder {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-end;\n  align-items: center;\n  grid-gap: 5px;\n\n  li {\n    padding: 0;\n    width: 20px;\n    aspect-ratio: 1;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    border-radius: 3px;\n    margin: 0;\n    transition: all 0.3s ease;\n    border: 1px solid #6d6e71;\n\n    &:hover {\n      opacity: 0.85;\n    }\n\n    &.active {\n      color: #fff;\n      background-color: #6d6e71;\n    }\n  }\n}\n\n.selectAll {\n  padding: 0;\n  background-color: #e7eaec;\n  // cursor: pointer;\n\n  & > div {\n    width: 100%;\n  }\n}\n\n.gap {\n  &5 {\n    gap: 5px;\n  }\n\n  &10 {\n    gap: 10px;\n  }\n\n  &30 {\n    gap: 30px;\n  }\n}\n\n.hirar {\n  width: 195px;\n\n  &__body {\n    border: 1px solid $color-grey-1;\n    border-top: 0;\n    border-bottom-right-radius: 4px;\n    border-bottom-left-radius: 4px;\n\n    &__lead {\n      border-top: 1px solid $color-grey-1;\n\n      .lead_txt {\n        border: 1px solid $color-grey-1;\n        border-radius: 50%;\n        padding: 3px 8px;\n        font-size: 10px;\n        font-weight: bold;\n        color: $body-content-color;\n      }\n    }\n  }\n\n  .orgs_team__members {\n    border-bottom-right-radius: 0;\n    border-bottom-left-radius: 0;\n  }\n\n  .orgs_team__members_hdr {\n    background-color: transparent;\n    &_content {\n      &:hover {\n        .full-mail {\n          display: block;\n        }\n        .short-mail {\n          display: none;\n        }\n      }\n\n      .counter {\n        // width: 18px;\n        // height: 18px;\n        display: block;\n        text-align: left;\n      }\n\n      .short-mail {\n        display: block;\n      }\n\n      .full-mail {\n        display: none;\n      }\n    }\n  }\n\n  .tooltip {\n    &:hover {\n      .short-mail {\n        display: inline-block;\n      }\n      .full-mail {\n        display: inline-block;\n        position: absolute;\n        padding: 5px;\n        top: -30px;\n        width: 110px;\n        background: #fff;\n        left: -10px;\n        box-shadow: 0 0 18px rgba(0, 0, 0, 0.1);\n        text-align: center;\n        border-radius: 6px;\n      }\n    }\n  }\n}\n\n.teams_roster {\n  table {\n    width: 100%;\n  }\n\n  th,\n  td {\n    @media (min-width: 991px) and (max-width: 1199px) {\n      font-size: 13px;\n    }\n\n    &:first-child {\n      width: 36px;\n    }\n\n    &:nth-child(5),\n    &:nth-child(6) {\n      width: 80px;\n      text-align: center;\n    }\n\n    @media #{$pc} {\n      &:nth-child(5) {\n        width: 50px;\n      }\n\n      &:nth-child(6) {\n        width: 40px;\n      }\n    }\n  }\n}\n\n.roaster_seach {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n  padding: 6px 9px;\n  margin: 0 !important;\n  border-bottom: 1px solid $color-grey-1;\n\n  &--bb0 {\n    border-bottom: 0;\n  }\n\n  &__box {\n    display: flex;\n    flex-wrap: wrap;\n    flex: 1;\n\n    &_input {\n      position: relative;\n      flex: 1;\n\n      button {\n        position: absolute;\n        width: 20px;\n        height: 20px;\n        top: 50%;\n        right: 5px;\n        transform: translateY(-50%);\n        padding: 0;\n        border: 0;\n        background: transparent;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n\n        &:hover svg {\n          fill: $body-content-color;\n        }\n\n        svg {\n          width: 12px;\n          fill: #f00;\n        }\n      }\n\n      input {\n        border-radius: 4px 0 0 4px;\n        border: 1px solid $color-grey-1;\n        background: $clrWhite;\n        color: $body-content-color;\n        padding: 4px 10px;\n        flex: 1;\n        width: 100%;\n        font-size: 14px;\n        outline: none;\n\n        &:focus {\n          border-color: $body-content-color;\n        }\n      }\n    }\n  }\n\n  &__dropdown {\n    width: 30px;\n    flex-shrink: 0;\n    position: relative;\n\n    &:hover > div {\n      display: block;\n    }\n\n    &_toggle {\n      border: 1px solid $color-grey-1;\n      border-left: 0;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      border-radius: 0 4px 4px 0;\n      min-height: 100%;\n      background-color: transparent;\n      width: 100%;\n      transition: 300ms;\n\n      &:hover {\n        background-color: $color-neutral-light;\n      }\n    }\n\n    &_body {\n      position: absolute;\n      top: 100%;\n      left: 50%;\n      transform: translateX(-50%);\n      z-index: 9;\n      padding-top: 20px;\n      display: none;\n\n      &_inner {\n        width: 160px;\n        background-color: $clrWhite;\n        filter: drop-shadow(0px 3px 7px rgba(0, 0, 0, 0.17));\n        border-radius: 10px;\n        position: relative;\n\n        &::before {\n          content: \"\";\n          position: absolute;\n          bottom: 100%;\n          left: 50%;\n          transform: translateX(-50%);\n          width: 20px;\n          height: 10px;\n          background-color: $clrWhite;\n          clip-path: polygon(50% 0, 100% 100%, 0 100%);\n        }\n      }\n    }\n\n    &_item {\n      padding: 10px;\n      display: flex;\n      flex-direction: column;\n      gap: 10px;\n\n      & + div {\n        border-top: 1px solid $color-grey-1;\n        // padding-inline: 20px;\n      }\n\n      label {\n        display: flex;\n        gap: 10px;\n        color: $body-content-color;\n\n        input {\n          margin: 0;\n          flex-shrink: 0;\n          flex: none;\n        }\n      }\n    }\n  }\n\n  &__button {\n    button {\n      border-radius: 3px;\n      border: 1px solid $color-grey-1;\n      background: $clrWhite;\n      color: $body-content-color;\n      padding: 7px 10px;\n      font-size: 12px;\n      font-family: $font-stack;\n      transition: 300ms;\n      line-height: 1;\n      min-height: 100%;\n\n      &.green_btn {\n        background-color: $low-develop-color;\n        border-color: $low-develop-color;\n        color: $clrWhite;\n      }\n\n      &:hover,\n      &.green_btn:hover {\n        background-color: $color-dark-green;\n        border-color: $color-dark-green;\n        color: $clrWhite;\n      }\n    }\n  }\n}\n\n.soryby_outer {\n  .sortby {\n    display: inline-block;\n    position: static;\n    margin-left: 6px;\n    font-size: 12px;\n    color: $color-neutral-mid;\n    vertical-align: middle;\n    cursor: pointer;\n    opacity: 0.5;\n\n    &.active {\n      opacity: 1;\n    }\n  }\n}\n\n// ROAST TEAM START\n\n.white_space_nw {\n  white-space: nowrap;\n}\n\n.roast_team_block {\n  .roast_team_branch {\n    padding: 0;\n    background-color: transparent;\n    border: 0;\n\n    &--bge {\n      margin-bottom: 20px;\n    }\n\n    &--mb-1 {\n      margin-bottom: -1px;\n    }\n\n    &--2 {\n      table {\n        th:nth-child(4) {\n          text-align: center;\n        }\n      }\n    }\n\n    .orgs_team__branch_hdr {\n      background-color: $color-neutral-light;\n      padding: 10px;\n      margin: 0 !important;\n      border-radius: 4px 4px 0 0;\n\n      &--pr_exist {\n        padding-right: 0;\n        display: flex;\n        align-items: center;\n        gap: 8px;\n      }\n\n      &_title {\n        flex: 1;\n        min-width: 0;\n\n        .title-case {\n          display: flex;\n          flex-wrap: wrap;\n          align-items: center;\n          gap: 10px;\n          flex: 1;\n        }\n\n        .rs-mem {\n          flex: 1;\n          display: flex;\n          gap: 6px;\n          align-items: center;\n        }\n\n        .fmt {\n          display: inline-flex;\n          align-items: center;\n          justify-content: center;\n          min-width: 24px;\n          height: 22px;\n          padding: 0 8px;\n          border-radius: 11px;\n          background: linear-gradient(135deg, rgba(0, 173, 208, 1), rgba(0, 153, 188, 1));\n          color: #fff;\n          font-size: 12px;\n          font-weight: 700;\n          line-height: 1;\n          flex-shrink: 0;\n          aspect-ratio: auto;\n          width: auto;\n        }\n      }\n\n      &_dropdown_2 {\n        position: static;\n        top: auto;\n        transform: none;\n        right: auto;\n        flex-shrink: 0;\n        margin-left: 12px;\n      }\n\n      .w93 {\n        width: 93%;\n      }\n    }\n\n    .orgs_team__branch_body {\n      border: 1px solid $color-grey-1;\n      border-radius: 0 0 4px 4px;\n    }\n\n    .orgs_team__branch_item {\n      border: 0;\n    }\n\n    .ibox-content {\n      border: 0;\n    }\n\n    table {\n      th {\n        &:where(:nth-child(2), :nth-child(3), :nth-child(4)) {\n          text-align: left;\n        }\n      }\n\n      th,\n      td {\n        border: 0;\n        border-bottom: 1px solid $color-grey-1;\n        vertical-align: middle;\n      }\n\n      // Last row: open dropdown upward to prevent clipping at table bottom\n      tr:last-child {\n        .orgs_team__members_dropdown_body {\n          top: auto;\n          bottom: 100%;\n          padding-top: 0;\n          padding-bottom: 12px;\n\n          ul::before {\n            bottom: auto;\n            top: 100%;\n            clip-path: polygon(0 0, 50% 100%, 100% 0);\n          }\n        }\n      }\n    }\n\n    .orgs_team__branch_dropdown,\n    .orgs_team__members_dropdown {\n      margin-inline: auto;\n    }\n\n    .roast_team__email {\n      &_box {\n        position: relative;\n        color: $color-light-grey;\n        display: inline-block;\n\n        .full-mail {\n          display: none;\n          position: absolute;\n          bottom: calc(100% + 5px);\n          left: 50%;\n          transform: translateX(-50%);\n          background-color: $clrWhite;\n          box-shadow: 0 0 10px rgba($clrBlack, 0.1);\n          padding: 4px 11px;\n          border-radius: 2px;\n          font-size: 13px;\n\n          &::before {\n            content: \"\";\n            position: absolute;\n            top: 100%;\n            left: 50%;\n            transform: translateX(-50%);\n            background-color: #fff;\n            width: 10px;\n            height: 8px;\n            clip-path: polygon(0 0, 100% 0, 50% 100%);\n          }\n        }\n\n        &:hover .full-mail {\n          display: block;\n        }\n      }\n\n      &:hover {\n        color: $fs-green;\n      }\n    }\n\n    .selectAll {\n      .orgs_team__branch_title {\n        padding: 6px 9px;\n      }\n    }\n  }\n\n  .raost_team__count {\n    position: relative;\n    cursor: default;\n\n    &:hover > .team-overlay {\n      display: block;\n    }\n  }\n\n  .roast_team_view {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    gap: 7px;\n\n    button {\n      width: 33px;\n      height: 30px;\n      border-radius: 2px;\n      border: 1px solid $color-grey-1;\n      background: $clrWhite;\n      padding: 0;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      position: relative;\n\n      &::before {\n        content: attr(data-content);\n        padding: 4px 8px;\n        filter: drop-shadow(0px 3px 7px rgba(0, 0, 0, 0.17));\n        background-color: $body-content-color;\n        color: $clrWhite;\n        font-size: 13px;\n        position: absolute;\n        bottom: calc(100% + 16px);\n        left: 50%;\n        transform: translateX(-50%);\n        border-radius: 4px;\n        display: none;\n      }\n\n      &::after {\n        content: \"\";\n        position: absolute;\n        bottom: calc(100% + 8px);\n        width: 16px;\n        height: 8px;\n        background-color: $body-content-color;\n        clip-path: polygon(0 0, 100% 0, 50% 100%);\n        display: none;\n      }\n\n      &:hover::before,\n      &:hover::after {\n        display: block;\n      }\n\n      &:hover,\n      &.active {\n        background-color: $body-content-color;\n        border-color: $body-content-color;\n        color: $clrWhite;\n\n        i {\n          color: $clrWhite;\n        }\n\n        svg path {\n          fill: $clrWhite;\n        }\n      }\n\n      svg {\n        width: 14px;\n        height: auto;\n      }\n    }\n  }\n}\n\n.hidden {\n  visibility: hidden;\n}\n\n.counter-mem {\n  font-size: 8px;\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  border: 1px solid #e7eaec;\n  height: 17px;\n  width: 17px;\n  border-radius: 50%;\n  text-align: center;\n}\n\n// ROAST TEAM END\n\n.customWeight{\n  label{\n    font-weight: 700;\n  }\n}\n\n// ══════════════════════════════════════════════════════\n// Design System Override — match /orgs route UI\n// ══════════════════════════════════════════════════════\n\n// Team card borders and hover\n.orgs_team__members {\n  border: 1px solid $color-grey-1 !important;\n  border-radius: 8px !important;\n  overflow: visible;\n  margin-bottom: 16px;\n  transition: box-shadow 0.2s ease;\n  position: relative;\n\n  &:hover { box-shadow: 0 2px 10px rgba(0,0,0,0.06); }\n}\n\n// Team card header\n.orgs_team__members_hdr {\n  background: $color-neutral-light !important;\n  border-bottom: 1px solid $color-grey-1;\n  padding: 12px 16px;\n}\n\n// Member count badge\n.counter-mem {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 24px;\n  height: 22px;\n  padding: 0 8px;\n  border-radius: 11px;\n  background: rgba($clarify-color, 0.1);\n  color: $clarify-color;\n  font-size: 12px;\n  font-weight: 700;\n  margin-left: 8px;\n}\n\n// Dropdown menus\n.orgs_team__members_hdr_dropdown_1_body,\n.orgs_team__branch_hdr_dropdown_2 ul {\n  background: #fff !important;\n  border: 1px solid $color-grey-1 !important;\n  border-radius: 8px !important;\n  box-shadow: 0 8px 24px rgba(0,0,0,0.12) !important;\n  padding: 4px 0 !important;\n\n  li button, li a {\n    padding: 9px 16px !important;\n    font-size: 13px !important;\n    font-family: $font-stack;\n    transition: background 0.12s ease;\n\n    &:hover { background: $color-neutral-light !important; }\n  }\n}\n\n// Pagination pills\n#holder li, .holder li {\n  display: inline-flex !important;\n  align-items: center;\n  justify-content: center;\n  min-width: 32px;\n  height: 32px;\n  padding: 0 8px;\n  border: 1px solid $color-grey-1;\n  border-radius: 4px;\n  font-size: 13px;\n  font-weight: 500;\n  color: $body-content-color;\n  background: #fff;\n  cursor: pointer;\n  font-family: $font-stack;\n  transition: all 0.15s ease;\n  list-style: none;\n\n  &:hover { background: $color-neutral-light; border-color: $color-neutral-mid; }\n  &.active { background: $color-neutral-dark; color: #fff; border-color: $color-neutral-dark; }\n}\n\n// Search inputs\n.roaster_seach__box_input input,\n.roaster_seach input[type=\"text\"],\n.roaster_seach input[type=\"search\"] {\n  padding: 8px 12px !important;\n  border: 1px solid $color-grey-1 !important;\n  border-radius: 6px !important;\n  font-size: 13px !important;\n  font-family: $font-stack;\n  transition: border-color 0.2s ease, box-shadow 0.2s ease;\n\n  &:focus {\n    border-color: $clarify-color !important;\n    box-shadow: 0 0 0 3px rgba($clarify-color, 0.1);\n    outline: none;\n  }\n}\n\n// Popup/Modal overrides — applied globally via ViewEncapsulation.None\n.team-modal,\n.roster-del-mem,\n.roster_addmem_popup,\n.roster_mem_edit_popup,\n.roster_popup {\n\n  .dialogbox {\n    position: fixed !important;\n    top: 0 !important;\n    left: 0 !important;\n    width: 100% !important;\n    height: 100% !important;\n    background: rgba(0, 0, 0, 0.4) !important;\n    z-index: 99999 !important;\n  }\n\n  .dialogbox__wrapper {\n    display: flex !important;\n    justify-content: center !important;\n    align-items: flex-start !important;\n    padding: 60px 20px !important;\n    overflow-y: auto !important;\n    height: 100% !important;\n  }\n\n  .dialogbox__inner {\n    width: min(560px, 100%) !important;\n    border-radius: 10px !important;\n    box-shadow: 0 12px 40px rgba(0, 0, 0, 0.15) !important;\n    overflow: hidden !important;\n    background: #fff !important;\n    border: none !important;\n    padding: 0 !important;\n  }\n\n  .dialogbox__hdr {\n    padding: 18px 24px !important;\n    background: $color-neutral-light !important;\n    border-bottom: 1px solid $color-grey-1 !important;\n    position: relative !important;\n\n    h2 {\n      font-size: 17px !important;\n      font-weight: 700 !important;\n      color: $color-neutral-dark !important;\n      font-family: $font-stack !important;\n    }\n  }\n\n  .dialogbox__close {\n    position: absolute !important;\n    top: 16px !important;\n    right: 16px !important;\n    width: 28px !important;\n    height: 28px !important;\n    padding: 0 !important;\n    border: 1px solid $color-grey-1 !important;\n    border-radius: 6px !important;\n    background: #fff !important;\n    cursor: pointer;\n    transition: all 0.15s ease;\n\n    &::before,\n    &::after {\n      content: \"\";\n      position: absolute;\n      top: 50%;\n      left: 50%;\n      width: 2px;\n      height: 55%;\n      background-color: #676a6c;\n      border-radius: 2px;\n      transform: translate(-50%, -50%) rotate(-45deg);\n    }\n\n    &::after {\n      transform: translate(-50%, -50%) rotate(45deg);\n    }\n\n    &:hover {\n      background: rgba($implement-color, 0.08) !important;\n      border-color: rgba($implement-color, 0.2) !important;\n    }\n  }\n\n  .dialogbox__body,\n  .dialogbox__form {\n    padding: 24px !important;\n  }\n\n  label {\n    font-size: 13px !important;\n    font-weight: 600 !important;\n    color: $color-neutral-dark !important;\n    font-family: $font-stack;\n    margin-bottom: 6px !important;\n  }\n\n  input[type=\"text\"],\n  input[type=\"email\"],\n  input[type=\"tel\"],\n  select,\n  .form-control {\n    padding: 9px 12px !important;\n    border: 1px solid $color-grey-1 !important;\n    border-radius: 6px !important;\n    font-size: 13px !important;\n    font-family: $font-stack;\n    color: $body-content-color;\n    transition: border-color 0.2s ease, box-shadow 0.2s ease;\n\n    &:focus {\n      border-color: $clarify-color !important;\n      box-shadow: 0 0 0 3px rgba($clarify-color, 0.1) !important;\n      outline: none !important;\n    }\n  }\n\n  .f-btn {\n    padding: 9px 20px !important;\n    font-size: 13px !important;\n    font-weight: 600 !important;\n    font-family: $font-stack;\n    border-radius: 6px !important;\n    border: none !important;\n    background: $develop-color !important;\n    color: #fff !important;\n    cursor: pointer;\n    transition: background 0.15s ease;\n\n    &:hover { background: $color-dark-green !important; }\n    &.disabled { opacity: 0.5; cursor: not-allowed; }\n  }\n}\n\n// Records per page select\nselect.wide-per-page,\n.records_select select {\n  width: 70px;\n  padding: 4px 8px;\n  font-size: 13px;\n  border: 1px solid $color-grey-1;\n  border-radius: 4px;\n  font-family: $font-stack;\n\n  &:focus { border-color: $clarify-color; outline: none; }\n}\n\n// Hierarchical view cards\n.hirar {\n  border: 1px solid $color-grey-1 !important;\n  border-radius: 8px !important;\n  overflow: hidden;\n  margin-bottom: 16px;\n\n  .lead_txt {\n    font-size: 10px;\n    font-weight: 700;\n    text-transform: uppercase;\n    letter-spacing: 0.05em;\n    color: $develop-color;\n    background: rgba($develop-color, 0.08);\n    padding: 2px 8px;\n    border-radius: 3px;\n  }\n}\n\n// Roster name header badge\n.roast_team_branch .fmt {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 28px;\n  height: 24px;\n  padding: 0 8px;\n  border-radius: 12px;\n  background: rgba($clarify-color, 0.1);\n  color: $clarify-color;\n  font-size: 13px;\n  font-weight: 700;\n  margin-left: 8px;\n}\n\n// ── Members Table — match /orgs tabular layout ──\n\n.orgs_team__branch.roast_team_branch {\n  background: #fff;\n  border: 1px solid $color-grey-1;\n  border-radius: 8px;\n  overflow: visible;\n}\n\n// Members panel header — new class, no specificity conflicts\n.roster-members-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n\n  &__left {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n\n    .title-case {\n      font-size: 14px;\n      font-weight: 700;\n      color: $color-neutral-dark;\n    }\n\n    .fmt {\n      display: inline-flex;\n      align-items: center;\n      justify-content: center;\n      min-width: 24px;\n      height: 22px;\n      padding: 0 8px;\n      border-radius: 11px;\n      background: linear-gradient(135deg, $clarify-color, darken($clarify-color, 8%));\n      color: #fff;\n      font-size: 12px;\n      font-weight: 700;\n      flex-shrink: 0;\n    }\n  }\n}\n\n// Sort icon — single inline icon\n.roster-sort-icon {\n  margin-left: 4px;\n  font-size: 12px;\n  color: $color-neutral-mid;\n  vertical-align: middle;\n}\n\n// Sortable table header\n.teammates__head th.sort-heads {\n  cursor: pointer;\n  user-select: none;\n  transition: color 0.15s ease;\n  white-space: nowrap;\n\n  &:hover {\n    color: $clarify-color;\n\n    .roster-sort-icon { color: $clarify-color; }\n  }\n}\n\n.roast_team_branch .roaster_seach__button .f-btn {\n  padding: 5px 12px !important;\n  font-size: 11px !important;\n  font-weight: 600 !important;\n  border-radius: 5px !important;\n  background: $develop-color !important;\n  color: #fff !important;\n  border: none !important;\n  font-family: $font-stack;\n  transition: background 0.15s ease;\n  margin-left: 8px;\n\n  &:hover { background: $color-dark-green !important; }\n}\n\n// Members table header row\n.teammates__head {\n  th {\n    padding: 6px 8px !important;\n    font-size: 11px !important;\n    font-weight: 700 !important;\n    text-transform: uppercase;\n    letter-spacing: 0.04em;\n    color: $color-neutral-dark !important;\n    border-bottom: 1px solid $color-grey-1 !important;\n    border-top: none !important;\n    white-space: nowrap;\n    vertical-align: middle !important;\n\n    // Sort arrows — inline with spacing\n    .sortby,\n    span.sortby {\n      display: inline-block !important;\n      position: static !important;\n      top: auto !important;\n      right: auto !important;\n      margin-left: 6px;\n      font-size: 12px;\n      color: $color-neutral-mid;\n      vertical-align: middle;\n      cursor: pointer;\n    }\n  }\n}\n\n// Force condensed rows and remove all stray borders — exact DOM path\n.teams_roster .ibox-content .table-responsive table.teammates td,\n.teams_roster .ibox-content .table-responsive table.teammates th,\n.teams_roster table.teammates-tb-none td,\n.teams_roster table.teammates-tb-none th,\ntable.teammates td,\ntable.teammates th {\n  border-top: 0 !important;\n  padding-top: 3px !important;\n  padding-bottom: 3px !important;\n}\n\n// Table uses full width of its column\n.teams_roster .table-responsive,\n.teams_roster .ibox-content {\n  padding: 0 !important;\n}\n\n// Allow dropdown menus to escape the table-responsive clipping context\n.teams_roster .table-responsive {\n  overflow: visible !important;\n}\n\n.teams_roster table.teammates {\n  width: 100% !important;\n  margin-bottom: 0 !important;\n}\n\n// 40/60 fluid layout\n.roster-layout {\n  display: flex;\n  width: 100%;\n  gap: 20px;\n  flex-wrap: nowrap;\n  margin: 0;\n  padding: 0;\n\n  @media (max-width: 991px) {\n    flex-wrap: wrap;\n  }\n}\n\n.roster-left-panel {\n  width: 40%;\n  max-width: 620px;\n  flex-shrink: 0;\n  padding-left: 0;\n  position: relative;\n  transition: width 0.3s ease, max-width 0.3s ease, opacity 0.2s ease;\n\n  &--collapsed {\n    width: 0 !important;\n    max-width: 0 !important;\n    overflow: hidden;\n    opacity: 0;\n    padding: 0 !important;\n    margin: 0 !important;\n  }\n\n  @media (max-width: 991px) {\n    width: 100%;\n    max-width: none;\n    padding-left: 0;\n  }\n}\n\n.roster-collapse-toggle {\n  width: 28px;\n  height: 28px;\n  border-radius: 6px;\n  border: 1px solid $color-grey-1;\n  background: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: background 0.15s ease;\n  padding: 0;\n  flex-shrink: 0;\n  margin-right: 8px;\n\n  &:hover {\n    background: #f4f5f7;\n    border-color: darken($color-grey-1, 10%);\n  }\n\n  i {\n    font-size: 13px;\n    color: $body-content-color;\n  }\n}\n\n.roster-layout--collapsed {\n  gap: 0;\n}\n\n.roster-right-panel {\n  flex: 1 1 0%;\n  min-width: 0;\n  width: 0;\n\n  @media (max-width: 991px) {\n    width: 100%;\n    flex: 1 1 100%;\n  }\n}\n\n// Force right panel and all children to fill available width\n.roster-right-panel {\n  .orgs_team__branch,\n  .roast_team_branch,\n  .roast_team_branch--bge {\n    width: 100% !important;\n    max-width: 100% !important;\n  }\n\n  .orgs_team__list {\n    width: 100% !important;\n  }\n}\n\n// Team cards grid — contained within parent\n.orgs_team__list {\n  overflow: visible;\n}\n\n// Fluid Teams widget grid — auto-fit so cards reflow naturally at any width\n.orgs_team__list_row.f-flex {\n  display: grid !important;\n  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\n  gap: 12px;\n  margin: 0;\n  padding: 0;\n  flex-wrap: unset;\n}\n\n.roster-team-cell {\n  flex: unset;\n  width: auto !important;\n  max-width: none;\n  padding: 0;\n  min-width: 0; // allow content to shrink inside grid cell\n\n  @media (max-width: 1400px),\n         (max-width: 1100px),\n         (max-width: 768px) {\n    width: auto !important;\n  }\n}\n\n// ── Team card internal layout polish ──\n.roster-team-cell {\n  .orgs_team__members {\n    min-width: 0; // allow text truncation inside card\n    overflow: visible;\n  }\n\n  // Card header — single row, checkbox+title grows/truncates, actions stay fixed\n  .orgs_team__members_hdr {\n    display: flex !important;\n    align-items: center;\n    gap: 8px;\n    min-width: 0;\n    padding: 10px 12px;\n    flex-wrap: nowrap !important;\n\n    &_content--name {\n      display: flex !important;\n      align-items: center;\n      gap: 6px;\n      flex: 1 1 auto;\n      min-width: 0; // critical for text-overflow ellipsis inside flex\n      overflow: hidden;\n\n      > div:first-child {\n        flex-shrink: 0; // checkbox never shrinks\n      }\n\n      .short-mail,\n      .full-mail {\n        overflow: hidden;\n        text-overflow: ellipsis;\n        white-space: nowrap;\n        min-width: 0;\n        font-size: 13px;\n        font-weight: 600;\n        color: $color-neutral-dark;\n      }\n\n      // Count badge\n      > span:last-child {\n        flex-shrink: 0;\n        font-size: 12px;\n        color: $body-content-color;\n        font-weight: 500;\n      }\n    }\n\n    // Three-dot menu button\n    .orgs_team__members_hdr_dropdown_1 {\n      flex-shrink: 0;\n      margin-left: auto;\n      position: relative;\n    }\n\n    // Chevron / accordion toggle\n    .orgs_team__members_hdr_dropdown_2 {\n      flex-shrink: 0;\n    }\n  }\n\n}\n\n// Fix view switcher overflow and z-index\n.roast_team_branch--bge {\n  overflow: visible !important;\n  position: relative;\n  z-index: 20;\n\n  .orgs_team__branch_hdr {\n    overflow: visible !important;\n  }\n\n  .roast_team_view {\n    overflow: visible !important;\n    margin-right: 16px;\n  }\n\n  // Header toolbar — title + view switcher + new team button\n  .orgs_team__branch_hdr--pr_exist {\n    display: flex !important;\n    align-items: center;\n    gap: 12px;\n    flex-wrap: wrap; // allow wrap ONLY when absolutely no space\n    padding: 12px 16px;\n    min-width: 0;\n\n    .orgs_team__branch_hdr_title {\n      flex: 1 1 auto;\n      min-width: 0;\n\n      > div {\n        min-width: 0;\n      }\n\n      .title-case {\n        display: inline-block;\n        max-width: 100%;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        white-space: nowrap;\n        vertical-align: bottom;\n      }\n    }\n\n    .roast_team_view {\n      flex-shrink: 0;\n      display: flex;\n      align-items: center;\n      gap: 4px;\n    }\n  }\n}\n\n// Search bar row inside Teams panel — keep search + filter icon + New team button on one row\n.roast_team_branch--bge .roaster_seach {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n  padding: 0 16px 12px;\n\n  &__box {\n    flex: 1 1 240px;\n    min-width: 180px;\n  }\n\n  &__button {\n    flex-shrink: 0;\n  }\n}\n\n// Collapse/expand arrow button — matches view switcher style\n.roster-collapse-btn {\n  flex-shrink: 0;\n\n  button {\n    width: 33px;\n    height: 30px;\n    border-radius: 2px;\n    border: 1px solid $color-grey-1;\n    background: transparent;\n    padding: 0;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    cursor: pointer;\n    transition: all 0.15s ease;\n\n    &:hover {\n      background-color: $body-content-color;\n      border-color: $body-content-color;\n\n      i { color: #fff; }\n    }\n\n    i {\n      color: $body-content-color;\n      font-size: 14px;\n    }\n  }\n}\n\n.orgs_team__list {\n  position: relative;\n  z-index: 1;\n}\n\n.orgs_team__members_hdr_dropdown_1_body {\n  z-index: 50 !important;\n}\n\n// Members table rows — condensed\n.orgs_team__branch_title {\n  border-bottom: 1px solid $color-grey-1 !important;\n  transition: background-color 0.12s ease;\n\n  &:hover { background-color: rgba($clarify-color, 0.03) !important; }\n\n  &:nth-child(even) {\n    background-color: rgba($color-neutral-light, 0.5);\n    &:hover { background-color: rgba($clarify-color, 0.03) !important; }\n  }\n\n  td {\n    padding: 0 10px !important;\n    font-size: 13px;\n    color: $body-content-color;\n    vertical-align: middle !important;\n    line-height: 1.2;\n    border-top: none !important;\n  }\n}\n\n// Member name link\n.orgs_team__branch_title_name {\n  a {\n    color: $body-content-color;\n    text-decoration: none;\n    font-weight: 500;\n    transition: color 0.15s ease;\n\n    &:hover { color: $clarify-color; }\n  }\n}\n\n// Member action dropdown (3-dot)\n.orgs_team__branch_title_dropdown {\n  button {\n    border: none;\n    background: transparent;\n    cursor: pointer;\n    padding: 4px;\n    border-radius: 4px;\n    transition: background 0.15s ease;\n\n    &:hover { background: $color-neutral-light; }\n  }\n\n  &_body {\n    background: #fff !important;\n    border: 1px solid $color-grey-1 !important;\n    border-radius: 8px !important;\n    box-shadow: 0 8px 24px rgba(0,0,0,0.12) !important;\n    padding: 4px 0 !important;\n    z-index: 100;\n\n    button, a {\n      display: block;\n      width: 100%;\n      text-align: left;\n      padding: 8px 16px !important;\n      font-size: 13px !important;\n      font-family: $font-stack;\n      color: $body-content-color !important;\n      border: none;\n      background: transparent;\n      cursor: pointer;\n      transition: background 0.12s ease;\n\n      &:hover { background: $color-neutral-light !important; }\n    }\n  }\n}\n\n// Search bar in members panel\n.roaster_seach {\n  padding: 10px 12px;\n  background: $color-neutral-light;\n  border-bottom: 1px solid $color-grey-1;\n\n  &__box {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n\n    &_input {\n      flex: 1;\n      position: relative;\n\n      input {\n        width: 100% !important;\n        padding: 8px 36px 8px 12px !important;\n        border: 1px solid $color-grey-1 !important;\n        border-radius: 6px !important;\n        font-size: 13px !important;\n        font-family: $font-stack;\n\n        &:focus {\n          border-color: $clarify-color !important;\n          box-shadow: 0 0 0 3px rgba($clarify-color, 0.1);\n          outline: none;\n        }\n      }\n\n      button {\n        position: absolute;\n        right: 8px;\n        top: 50%;\n        transform: translateY(-50%);\n        border: none;\n        background: transparent;\n        cursor: pointer;\n        padding: 4px;\n\n        svg { width: 12px; height: 12px; fill: $color-neutral-mid; }\n\n        &:hover svg { fill: $implement-color; }\n      }\n    }\n  }\n\n  &__dropdown {\n    position: relative;\n\n    &_toggle {\n      padding: 6px 10px !important;\n      border: 1px solid $color-grey-1 !important;\n      border-radius: 6px !important;\n      background: #fff !important;\n      cursor: pointer;\n      transition: border-color 0.15s ease;\n\n      &:hover { border-color: $color-neutral-mid !important; }\n    }\n\n    &_body {\n      background: #fff !important;\n      border: 1px solid $color-grey-1 !important;\n      border-radius: 8px !important;\n      box-shadow: 0 8px 24px rgba(0,0,0,0.12) !important;\n      padding: 8px 0 !important;\n      z-index: 100;\n    }\n\n    &_item {\n      padding: 6px 14px;\n      font-size: 13px;\n\n      label {\n        cursor: pointer;\n        font-weight: 500;\n        display: flex;\n        align-items: center;\n        gap: 6px;\n        margin: 0;\n      }\n    }\n  }\n}\n\n// \"Add to team\" button\n.orgs_team__branch_body .f-btn--seagrn,\n.roaster_seach .f-btn--seagrn {\n  border-radius: 5px !important;\n  font-family: $font-stack;\n  font-weight: 600 !important;\n  font-size: 11px !important;\n  padding: 5px 12px !important;\n  transition: all 0.15s ease;\n}\n\n// Checkbox styling\n.orgs_team__branch_title_name input[type=\"checkbox\"] {\n  accent-color: $develop-color;\n  width: 15px;\n  height: 15px;\n  cursor: pointer;\n}\n\n// Energy wave icons (profile dots)\n.orgs_team__branch_title_utype {\n  font-size: 12px;\n}\n\n// Records per page + pagination in members panel\n.raost_team__count {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 12px 16px;\n  border-top: 1px solid $color-grey-1;\n\n  .records_select {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n\n    label {\n      font-size: 12px;\n      font-weight: 600;\n      color: $color-neutral-dark;\n      margin: 0;\n    }\n  }\n}\n\n// Member dropdowns inside team cards — always open downward.\n// The card has overflow:visible so the menu escapes below cleanly.\n.orgs_team__members_body {\n  .orgs_team__members_body_item {\n    position: relative;\n\n    .orgs_team__members_dropdown_body {\n      top: 100%;\n      bottom: auto;\n      padding-top: 12px;\n      padding-bottom: 0;\n\n      ul::before {\n        top: auto;\n        bottom: 100%;\n        clip-path: polygon(0 100%, 50% 0, 100% 100%);\n      }\n    }\n  }\n}\n\n// Last row of team cards: open card-header dropdown upward to avoid\n// clipping at the bottom of the grid container.\napp-roster-team-card:nth-last-child(-n+3) {\n  .orgs_team__members_hdr_dropdown_1_body {\n    top: auto;\n    bottom: 100%;\n    padding-top: 0;\n    padding-bottom: 13px;\n\n    ul::before {\n      bottom: auto;\n      top: 100%;\n      clip-path: polygon(0 0, 50% 100%, 100% 0);\n    }\n  }\n}\n\n// Directory view styles moved to directory-view.component.scss\n// Legacy selectors kept for backwards compat only:\napp-directory-view {\n  .table {\n    width: 100%;\n    border-collapse: collapse;\n\n    thead tr {\n      background: $color-neutral-light;\n\n      th {\n        padding: 8px 10px;\n        font-size: 11px;\n        font-weight: 700;\n        text-transform: uppercase;\n        letter-spacing: 0.04em;\n        color: $color-neutral-dark;\n        border-bottom: 1px solid $color-grey-1;\n        border-top: none;\n        white-space: nowrap;\n        font-family: $font-stack;\n      }\n    }\n\n    tbody tr {\n      border-bottom: 1px solid $color-grey-1;\n      transition: background 0.12s ease;\n\n      &:hover { background: rgba($clarify-color, 0.03); }\n\n      td {\n        padding: 6px 10px;\n        font-size: 13px;\n        color: $body-content-color;\n        vertical-align: middle;\n        border-top: none;\n      }\n    }\n  }\n\n  .teammates__details a {\n    color: $body-content-color;\n    text-decoration: none;\n    font-weight: 500;\n    transition: color 0.15s ease;\n\n    &:hover { color: $clarify-color; }\n  }\n}\n\n// Inline team count in table cells — only remove the border, keep padding\n.raost_team__count--inline {\n  border-top: none !important;\n}\n\n// ── Team Count Badge ──\n.team-count-badge {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 26px;\n  height: 22px;\n  padding: 0 6px;\n  border-radius: 11px;\n  background: rgba($clarify-color, 0.1);\n  color: $clarify-color;\n  font-size: 12px;\n  font-weight: 700;\n  cursor: pointer;\n  transition: all 0.15s ease;\n\n  &:hover {\n    background: rgba($clarify-color, 0.18);\n  }\n\n  &--zero {\n    background: rgba($color-neutral-mid, 0.1);\n    color: $color-neutral-mid;\n    cursor: default;\n\n    &:hover { background: rgba($color-neutral-mid, 0.1); }\n  }\n}\n\n// ── Teams Overlay Popup ──\n.team-overlay {\n  display: none;\n  position: absolute;\n  top: calc(100% + 6px);\n  left: 50%;\n  transform: translateX(-50%);\n  z-index: 200;\n  width: max-content;\n  min-width: 180px;\n  max-width: 260px;\n  background: #fff;\n  border: 1px solid $color-grey-1;\n  border-radius: 10px;\n  box-shadow: 0 12px 36px rgba(0, 0, 0, 0.14);\n  overflow: hidden;\n\n  &__arrow {\n    position: absolute;\n    bottom: 100%;\n    left: 50%;\n    transform: translateX(-50%);\n    width: 14px;\n    height: 7px;\n    overflow: hidden;\n\n    &::after {\n      content: '';\n      position: absolute;\n      bottom: 0;\n      left: 50%;\n      transform: translateX(-50%) rotate(45deg);\n      width: 10px;\n      height: 10px;\n      background: #fff;\n      border: 1px solid $color-grey-1;\n      border-bottom: none;\n      border-right: none;\n    }\n  }\n\n  &__header {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    padding: 8px 14px;\n    background: $color-neutral-light;\n    border-bottom: 1px solid $color-grey-1;\n    font-size: 11px;\n    font-weight: 700;\n    text-transform: uppercase;\n    letter-spacing: 0.04em;\n    color: $color-neutral-dark;\n    font-family: $font-stack;\n\n    i {\n      font-size: 10px;\n      color: $clarify-color;\n    }\n  }\n\n  &__list {\n    list-style: none;\n    margin: 0;\n    padding: 6px 0;\n    max-height: 220px;\n    overflow-y: auto;\n  }\n\n  &__item {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    padding: 6px 14px;\n    font-size: 13px;\n    color: $body-content-color;\n    font-family: $font-stack;\n    text-transform: capitalize;\n    transition: background 0.1s ease;\n\n    &:hover {\n      background: rgba($clarify-color, 0.03);\n    }\n\n    span {\n      white-space: nowrap;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      max-width: 200px;\n    }\n  }\n\n  &__dot {\n    font-size: 5px;\n    color: $develop-color;\n    flex-shrink: 0;\n  }\n}\n\n// ── Team Member Energy Wave Icon ──\n.orgs_team__members_title_name {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  max-width: 140px;\n}\n\n.orgs_team__members_wave {\n  flex-shrink: 0;\n  width: 34px;\n  height: 15px;\n  min-height: 15px;\n  background-size: 175px 46px;\n  margin: 0 0 0 4px;\n}\n\n\n.orgs_team__members_dot {\n  display: block !important;\n  width: 7px !important;\n  height: 7px !important;\n  min-width: 7px !important;\n  min-height: 7px !important;\n  border-radius: 50% !important;\n  opacity: 0.5;\n\n  &--cl { background-color: $clarify-color !important; }\n  &--id { background-color: $ideate-color !important; }\n  &--dv { background-color: $develop-color !important; }\n  &--im { background-color: $implement-color !important; }\n}\n\n// Override .teams .profile_types.no-profile bleed from teams.component.scss\n// That rule sets background-image: none and adds ::after content \"No profile\"\n// which breaks the energy wave sprite in our directory member table\napp-member-side-bar .profile_types.no-profile {\n  background-image: url('https://assets.foursightonline.com/app/images/foursight-profile-types.svg') !important;\n  width: 34px !important;\n  height: 15px !important;\n  background-size: 175px 46px !important;\n\n  &::after {\n    content: none !important;\n    display: none !important;\n  }\n}\n","@import \"./../../../assets/styles/variables\";\n$border-color: #e7eaec;\n\n::ng-deep #holder > li {\n  padding: 5px;\n  margin: 2px;\n  display: inline-block;\n  border-color: #ddd;\n}\n\n::ng-deep #holder > li[data-page] {\n  border: solid #a0a0a0 1px;\n  border-radius: 5px;\n}\n\n::ng-deep #holder > li.separator:before {\n  content: \"...\";\n}\n\n::ng-deep #holder > li.active {\n  background-color: #f4f4f4;\n  color: inherit;\n}\n\n::ng-deep #holder > li[data-page]:hover {\n  cursor: pointer;\n}\n\n.groups {\n  margin-left: 15px;\n  margin-bottom: 10px;\n}\n\n.reset-input {\n  th {\n    position: relative;\n\n    input[type=\"search\"] {\n      width: 100% !important;\n    }\n\n    .reset-close {\n      display: none;\n      position: absolute;\n      top: 0;\n      right: 25px;\n      bottom: 0;\n      margin: auto;\n      border-radius: 50%;\n      background: #ddd;\n      border: none !important;\n      text-align: center;\n      font-size: 14px;\n      padding: 0px !important;\n      height: 16px !important;\n      width: 16px !important;\n      color: $color-light-type;\n      line-height: 1.2 !important;\n      font-family: Arial !important;\n      transform: rotate(45deg) !important;\n      -webkit-transform: rotate(45deg) !important;\n    }\n\n    &:hover {\n      .reset-close {\n        display: block;\n      }\n    }\n  }\n}\n\n.tva {\n  &__head {\n    min-height: 84px;\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    border: 1px solid $border-color;\n    border-radius: 4px;\n    margin-inline: 15px;\n    padding: 17px 35px;\n\n    i:hover {\n      color: $develop-color;\n    }\n\n    @media #{$mobile} {\n      padding-inline: 20px;\n    }\n\n    &--border-0 {\n      border: 0;\n    }\n\n    &--type-1 {\n      padding: 8px 27px;\n      min-height: auto;\n\n      @media #{$mobile} {\n        padding-inline: 20px;\n      }\n\n      .tva__cta__hd {\n        h5 {\n          font-size: 16px;\n          font-weight: 700;\n        }\n      }\n    }\n\n    &--brb-0 {\n      border-bottom-right-radius: 0;\n      border-bottom-left-radius: 0;\n    }\n\n    .f-m-bottom-0 + span {\n      font-weight: bold;\n      font-size: 12px;\n\n      img {\n        width: 40px;\n        margin-left: 6px;\n      }\n    }\n  }\n\n  &__cta {\n    &__hd {\n      width: 100%;\n\n      h5 {\n        font-size: 24px;\n        font-weight: 700;\n        color: $body-content-color;\n        margin-top: 0;\n\n        &.tva__head_subtitle {\n          font-size: 16px;\n        }\n      }\n\n      small {\n        font-size: 14px;\n      }\n    }\n\n    &__btn {\n      display: inline-block;\n\n      &--comp {\n        a {\n          background-color: transparent;\n          padding: 0;\n          color: $body-content-color;\n          border-color: $border-color;\n\n          span {\n            display: inline-block;\n            padding: 5px 12px;\n\n            &:first-child {\n              border-right: 1px solid $border-color;\n            }\n          }\n        }\n      }\n    }\n  }\n\n  &__bot {\n    table {\n      border: 1px solid $border-color;\n      border-collapse: collapse;\n\n      thead {\n        tr {\n          &:first-child {\n            background-color: $color-neutral-light;\n          }\n\n          input[type=\"checkbox\"] {\n            border: 1px solid $border-color;\n          }\n\n          th {\n            border: 0;\n          }\n        }\n      }\n\n      input[type=\"checkbox\"] {\n        display: none;\n\n        & + label {\n          position: relative;\n          cursor: pointer;\n\n          &::before {\n            content: \"\";\n            position: absolute;\n            top: 0;\n            left: 0;\n            height: 10px;\n            width: 10px;\n            border: 1px solid $border-color;\n            border-radius: 3px;\n          }\n        }\n\n        &:checked + label::after {\n          content: \"\";\n          position: absolute;\n          left: 4px;\n          top: 3px;\n          border-right: 2px solid #e7eaec;\n          border-bottom: 2px solid #e7eaec;\n          rotate: 45deg;\n          height: 4px;\n          width: 2px;\n        }\n      }\n    }\n  }\n}\n\n.back {\n  background-color: #fff;\n  color: $body-content-color;\n  border: 0;\n}\n\n._mb_5 {\n  margin-bottom: 5px;\n}\n\n._bg_neutral_light {\n  background-color: $color-neutral-light;\n}\n\n._color_body_content {\n  color: $body-content-color;\n}\n\n.lead {\n  font-size: 8px;\n  font-weight: 700;\n  display: inline-block;\n  padding: 2px 4px;\n  background-color: $body-content-color;\n  border-radius: 2px;\n  color: #fff;\n\n  &--round {\n    background-color: $clrWhite !important;\n    color: $body-content-color !important;\n    border-radius: 50% !important;\n    border: 1px solid $color-grey-1 !important;\n  }\n}\n\n::ng-deep.userProfile {\n  border: 2px solid $color-neutral-light;\n  border-radius: 4px;\n  border-top: 0;\n\n  &--brt-0 {\n    border-top-right-radius: 0;\n    border-top-left-radius: 0;\n  }\n\n  &--bdr-0 {\n    border: 0;\n  }\n\n  &__top-row {\n    @media #{$pc} {\n      & > div {\n        width: 100%;\n      }\n    }\n  }\n\n  &__team {\n    padding-inline: 8px;\n\n    &__accord {\n      border: 1px solid $color-grey-1;\n      border-radius: 4px;\n      border-top: 0;\n      min-height: 100%;\n\n      &--zindex {\n        position: relative;\n        z-index: 999;\n      }\n\n      &--mr {\n        margin-right: 2%;\n      }\n\n      &_header {\n        background-color: $color-neutral-light;\n        padding: 10px 19px;\n        min-height: 38px;\n        display: flex;\n        align-items: center;\n        &--posZind {\n          position: relative;\n          z-index: 999;\n        }\n\n        h5 {\n          color: $body-content-color;\n          margin-top: 0;\n          font-size: 14px;\n        }\n      }\n\n      &_body {\n        padding: 13px 18px;\n        position: relative;\n\n        & > :not(:last-child),\n        &_list > :not(:last-child) {\n          margin-bottom: 15px;\n        }\n\n        &_list:not(:last-child) {\n          margin-bottom: 7px !important;\n        }\n\n        &_list {\n          max-height: 146px;\n          overflow: hidden;\n          transition: all ease 0.5s;\n\n          &.active {\n            max-height: none;\n          }\n        }\n\n        * {\n          margin-top: 0;\n        }\n\n        a {\n          color: $body-content-color;\n        }\n\n        ul,\n        ol {\n          margin: 0 0 0 14px;\n          padding: 0;\n\n          & > :not(:last-child) {\n            margin-bottom: 10px;\n          }\n        }\n\n        h5 {\n          font-weight: 700;\n          font-size: 14px;\n        }\n\n        p,\n        li {\n          font-weight: 600;\n          font-size: 12px;\n        }\n\n        .active + .userProfile__team__accord_body_show_more_button {\n          position: static;\n          background-color: transparent;\n          padding-top: 0;\n        }\n\n        &_show_more_button {\n          text-align: center;\n          position: absolute;\n          bottom: 10px;\n          right: 0;\n          left: 0;\n          background: linear-gradient(180deg, transparent, $clrWhite);\n          padding-top: 10px;\n\n          button {\n            // color: #337ab7;\n            // font-size: 12px;\n            // border-radius: 2px;\n            // border: 1px solid $color-grey-1;\n            // background: #fff;\n            // padding: 4px 16px;\n            // font-family: $font-stack;\n            // font-weight: 600;\n            // cursor: pointer;\n\n            // &:hover {\n            //   color: #fff;\n            //   background-color: #337ab7;\n            //   border-color: #337ab7;\n            // }\n          }\n        }\n\n        &_exter_links {\n          & > :not(:last-child) {\n            border-bottom: 1px solid $color-grey-1;\n            margin-bottom: 4px;\n            padding-bottom: 7px;\n          }\n\n          @media #{$mobile} {\n            & > div > div {\n              flex: none;\n              width: 100%;\n              text-align: left;\n            }\n          }\n\n          a {\n            &:hover i {\n              color: $develop-color;\n            }\n\n            i {\n              transition: 300ms;\n            }\n          }\n        }\n\n        &_groups {\n          display: grid;\n          grid-template-columns: repeat(4, 1fr);\n          grid-gap: 20px;\n\n          @media #{$pc} {\n            grid-template-columns: repeat(2, 1fr);\n          }\n\n          .clarify {\n            .userProfile__team__accord_body_groups_header {\n              background-color: $clarify-color;\n            }\n\n            h5 {\n              color: $body-content-color;\n              font-weight: 600;\n\n              span {\n                color: $clarify-color;\n              }\n            }\n          }\n\n          .ideate {\n            .userProfile__team__accord_body_groups_header {\n              background-color: $ideate-color;\n            }\n\n            h5 {\n              color: $body-content-color;\n              font-weight: 600;\n\n              span {\n                color: $ideate-color;\n              }\n            }\n          }\n\n          .develop {\n            .userProfile__team__accord_body_groups_header {\n              background-color: $develop-color;\n            }\n\n            h5 {\n              color: $body-content-color;\n              font-weight: 600;\n\n              span {\n                color: $develop-color;\n              }\n            }\n          }\n\n          .implement {\n            .userProfile__team__accord_body_groups_header {\n              background-color: $implement-color;\n            }\n\n            h5 {\n              color: $body-content-color;\n              font-weight: 600;\n\n              span {\n                color: $implement-color;\n              }\n            }\n          }\n\n          &_header {\n            padding: 6px 10px;\n            border-radius: 2px;\n            background-color: var(--group_clr);\n            font-size: 14px;\n            font-weight: 600;\n            color: #fff;\n\n            &:not(:last-child) {\n              margin-bottom: 15px;\n            }\n          }\n\n          h5 {\n            display: flex;\n            flex-wrap: wrap;\n            align-items: center;\n            grid-gap: 3px;\n\n            &:not(:last-child) {\n              margin-bottom: 5px;\n            }\n\n            span {\n              width: 18px;\n              display: inline-flex;\n              justify-content: center;\n              align-items: center;\n              aspect-ratio: 1;\n              border-radius: 50%;\n              background: $color-neutral-light;\n              font-size: 0.8em;\n            }\n          }\n\n          ul {\n            margin: 0;\n            padding: 0;\n            list-style: none;\n\n            &:not(:last-child) {\n              margin-bottom: 15px;\n            }\n\n            li:not(:last-child) {\n              margin-bottom: 3px;\n            }\n          }\n        }\n      }\n    }\n    &__spcltxt {\n      font-size: 12px;\n      padding: 10px 16px;\n      font-style: italic;\n    }\n  }\n\n  &__graph {\n    .wrapper-content {\n      &--pd-0 {\n        padding: 0;\n      }\n    }\n\n    &_header {\n      background-color: $color-neutral-light;\n      padding: 9px 17px;\n      font-size: 14px;\n      font-weight: 700;\n      color: $body-content-color;\n      border-radius: 5px 5px 0 0;\n\n      span {\n        font-weight: 600;\n\n        .tooltip-text {\n          display: none;\n        }\n\n        &.info-text {\n          position: relative;\n\n          &:hover {\n            cursor: pointer;\n\n            .tooltip-text {\n              display: none;\n              position: absolute;\n              display: inline-block;\n              min-width: 240px;\n              bottom: calc(100% + 10px);\n              background-color: #fff;\n              left: 50%;\n              transform: translateX(-50%);\n              padding: 5px;\n              border-radius: 4px;\n              text-align: center;\n              z-index: 99;\n\n              &::before {\n                content: \"\";\n                width: 16px;\n                height: 8px;\n                clip-path: polygon(0 0, 100% 0, 50% 100%);\n                background-color: $clrWhite;\n                position: absolute;\n                top: 99%;\n                left: 50%;\n                transform: translateX(-50%);\n              }\n            }\n          }\n        }\n      }\n    }\n\n    &__plan {\n      width: 85%;\n      margin-left: auto;\n      h5 {\n        font-size: 14px;\n        font-weight: 600;\n        border-bottom: 1px solid $color-grey-1;\n        padding-bottom: 10px;\n        margin: 0;\n      }\n\n      &-pf {\n        color: $body-content-color;\n        opacity: 0.6;\n\n        .teams__profile_inner {\n          padding-inline: 5px;\n          border-right: 1px solid $color-grey-1;\n\n          &:last-child {\n            border-right: 0;\n          }\n\n          .nobg {\n            background-color: transparent !important;\n            font-weight: 400 !important;\n          }\n        }\n      }\n\n      &--our {\n        position: relative;\n        z-index: 999;\n\n        h5 {\n          padding-bottom: 0;\n          border: 0;\n        }\n\n        textarea {\n          border: 1px solid $border-color;\n        }\n\n        .cross_icn {\n          width: 22px;\n          height: 22px;\n          border: 1px solid #e7eaec;\n          position: relative;\n          border-radius: 50%;\n          display: flex;\n          align-items: center;\n          justify-content: center;\n          margin-right: 5px;\n        }\n\n        .cancel_btn {\n          color: $body-content-color;\n          border: 0;\n          font-family: \"open sans\", \"Helvetica Neue\", Helvetica, Arial,\n            sans-serif;\n          font-size: 14px;\n          font-weight: 700;\n          transition: all ease 0.3s;\n          padding-right: 7px;\n        }\n\n        .save_btn {\n          display: inline-block;\n          font-size: 10px;\n          font-weight: bold;\n          border: 1px solid #e7eaec;\n          border-radius: 20px;\n          padding: 3px 6px;\n        }\n      }\n    }\n\n    &__lead {\n      width: 87%;\n      margin-left: auto;\n    }\n  }\n\n  .team-compo {\n    display: flex;\n    flex-direction: column;\n    flex-wrap: wrap;\n    grid-gap: 30px;\n\n    .profile-section {\n      margin-bottom: 0;\n      flex: 1.2;\n    }\n\n    .below-chart {\n      flex: 1;\n      box-shadow: none;\n      border-radius: 4px;\n\n      @media #{$tablet} {\n        flex: auto;\n      }\n    }\n  }\n\n  .team-graph .chart-container {\n    max-width: 100% !important;\n  }\n}\n\n.teams {\n  &_cont {\n    &--mxwd {\n      max-width: 357px;\n    }\n  }\n\n  &__row-autofit {\n    display: grid;\n    margin: 0;\n    grid-template-columns: repeat(auto-fit, minmax(0, 230px));\n    grid-gap: calc(2 * var(--gap-default));\n\n    @media #{$mobile} {\n      grid-template-columns: 1fr;\n    }\n  }\n\n  &__col-autofit {\n    width: 100% !important;\n    padding-inline: 0;\n  }\n\n  &--b-e {\n    border: 2px solid $color-neutral-light;\n    border-radius: 4px;\n  }\n\n  &--brt-0 {\n    border-top-right-radius: 0;\n    border-top-left-radius: 0;\n  }\n\n  &__col-4 {\n    @media #{$desktop} {\n      width: 50%;\n    }\n\n    @media #{$pc} {\n      width: 100%;\n    }\n  }\n\n  &__col-6 {\n    @media #{$pc} {\n      width: 100%;\n    }\n  }\n\n  &__cell {\n    min-height: 100%;\n    display: flex;\n    flex-direction: column;\n\n    @media #{$mobile} {\n      margin-right: 0;\n    }\n\n    &:hover {\n      .teams__header_btn {\n        opacity: 1;\n        background-color: $develop-color;\n      }\n    }\n  }\n\n  &__header {\n    background-color: $color-neutral-light;\n    padding: 9px 15px 9px 18px;\n    border-radius: 5px 5px 0 0;\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    grid-gap: 10px;\n\n    &--wbg {\n      background-color: $clrWhite;\n    }\n\n    &--bdr {\n      border: 1px solid $color-grey-1;\n    }\n\n    &_title {\n      font-size: 12px;\n      font-family: $font-stack;\n      color: $body-content-color;\n      font-weight: 700;\n      flex: 1;\n\n      &--capsbrk {\n        text-transform: capitalize;\n        word-break: break-all;\n      }\n\n      .tm_name {\n        &:hover {\n          .short_name {\n            display: none;\n          }\n          .full_name {\n            display: inline-block;\n          }\n        }\n\n        .full_name {\n          display: none;\n        }\n      }\n\n      &__contr {\n        gap: 10px;\n\n        .roster {\n          color: #fff;\n          background-color: $body-content-color;\n          border: 1px solid $color-light-grey;\n          border-radius: 50%;\n          width: 20px;\n          height: 20px;\n          text-align: center;\n          font-size: 10px;\n          padding-top: 1px;\n\n          &__name {\n            display: none;\n            width: 150px;\n            color: #676a6c;\n            background-color: #fff;\n            text-align: center;\n            border-radius: 6px;\n            padding: 6px;\n            box-shadow: 0 0 18px rgba(0, 0, 0, 0.1);\n            font-size: 13px;\n            font-family: \"Open Sans\", sans-serif;\n            line-height: 1.5;\n            position: absolute;\n            top: -35px;\n            left: -16px;\n            z-index: 1;\n          }\n\n          &:hover {\n            .roster__name {\n              display: block;\n            }\n          }\n        }\n      }\n    }\n\n    &_btn {\n      background-color: $color-light-grey;\n      color: $clrWhite;\n      font-weight: 700;\n      opacity: 0.6;\n      font-size: 10px;\n    }\n\n    button {\n      background-color: $clrWhite;\n      border-radius: 2px;\n      padding: 4px 9px;\n      font-size: 8px;\n      font-weight: 700;\n      color: $body-content-color;\n      font-family: $font-stack;\n      padding: 4px 9px;\n    }\n\n    .disable {\n      opacity: 0.5;\n      cursor: not-allowed;\n    }\n  }\n\n  &__profile {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    grid-gap: 10px 20px;\n    padding: 13px 19px 10px;\n\n    &--pd {\n      padding-top: 20px;\n      padding-bottom: 0;\n      min-height: 46px;\n    }\n\n    &--bdrtop {\n      border-top: 1px solid $color-grey-1;\n    }\n\n    &--nflx {\n      display: block;\n      padding: 13px 9px 10px;\n    }\n\n    &_inner {\n      display: flex;\n      flex-wrap: wrap;\n      align-items: center;\n      grid-gap: 10px;\n\n      &__pfn {\n        line-height: 1;\n      }\n\n      .nobg {\n        background-color: #fff;\n        font-weight: normal;\n        padding: 0;\n        display: inline-block;\n      }\n\n      &--rytbdr {\n        border-right: 1px solid $color-grey-1;\n\n        &:last-child {\n          border-right: 0;\n        }\n      }\n\n      ::ng-deep .profile_types {\n        margin-left: 0;\n      }\n\n      &--gap5 {\n        grid-gap: 5px;\n\n        .trans_scale {\n          transform: scale(0.8);\n        }\n      }\n\n      span {\n        display: inline-block;\n        background-color: #d4d4d4;\n        color: #676a6c;\n        padding: 4px;\n        font-size: 10px;\n        border-radius: 2px;\n        font-weight: 700;\n        text-align: center;\n\n        &.txt {\n          background-color: transparent;\n          display: block;\n          padding: 0;\n          text-align: left;\n          font-weight: 400;\n        }\n      }\n\n      @media #{$tablet} {\n        width: 100%;\n      }\n\n      &--usrPf {\n        width: 90%;\n        margin-left: auto;\n        padding-top: 11px;\n      }\n    }\n\n    img {\n      margin-right: 5px;\n      width: 35px;\n    }\n\n    &_name {\n      color: $body-content-color;\n      font-size: 12px;\n      font-weight: 700;\n    }\n\n    span.lead {\n      @extend .lead;\n\n      @media #{$tablet} {\n        margin-left: auto;\n      }\n    }\n  }\n\n  &__tab_table {\n    padding: 20px;\n\n    ::ng-deep table {\n      padding: 0;\n      border: 1px solid $color-grey-1;\n      border-collapse: collapse;\n      min-width: 450px;\n\n      th,\n      td {\n        border: 1px solid $color-grey-1 !important;\n        padding: 5px;\n        font-size: 12px;\n\n        &:not(:first-child) {\n          text-align: center;\n        }\n      }\n\n      td {\n        font-weight: 600;\n      }\n\n      .records_select {\n        display: flex;\n        flex-wrap: wrap;\n        align-items: center;\n        grid-gap: 5px;\n        margin-bottom: 0;\n\n        label {\n          margin-bottom: 0;\n        }\n      }\n\n      select {\n        width: min(70px, 100%);\n\n        &:focus {\n          outline: none;\n        }\n      }\n    }\n  }\n\n  &__tab_content {\n    padding: 20px;\n\n    ::ng-deep .team-tls {\n      padding: 0;\n\n      &__inner {\n        padding-inline: 0;\n\n        &:not(:last-child) {\n          margin-bottom: 10px;\n        }\n\n        * {\n          font-size: 12px;\n          font-weight: 600;\n        }\n      }\n\n      ul {\n        margin: 0;\n        padding: 0 0 0 24px;\n\n        li:not(:last-child) {\n          margin-bottom: 5px;\n        }\n      }\n    }\n  }\n\n  .title-case.role {\n    span {\n      @extend .lead;\n    }\n  }\n\n  ::ng-deep &__buttons {\n    display: flex;\n    flex-wrap: wrap;\n    border-top: 1px solid $color-grey-1;\n    border-bottom: 1px solid $color-grey-1;\n\n    button {\n      flex: 1;\n      border: 0;\n      color: $body-content-color;\n      text-align: center;\n      font-size: 10px;\n      font-weight: 600;\n      padding: 12px;\n      background-color: transparent;\n      cursor: pointer;\n      position: relative;\n\n      &:hover {\n        background-color: $color-grey-1;\n\n        &::after {\n          // opacity: 1;\n        }\n      }\n\n      &.active::after {\n        content: \"\";\n        position: absolute;\n        bottom: 0;\n        right: 0;\n        left: 0;\n        height: 2px;\n        background-color: $low-develop-color;\n        opacity: 1;\n      }\n\n      &:not(:last-child) {\n        border-right: 1px solid $color-grey-1;\n      }\n    }\n  }\n\n  .profile_types.no-profile {\n    background-image: none !important;\n    width: auto;\n\n    &::after {\n      color: $body-content-color;\n      background-color: $color-light-grey;\n      content: \"No profile\";\n      padding: 5px 8px;\n      font-size: 10px;\n      left: -10px;\n      position: relative;\n      top: -6px;\n    }\n  }\n\n  ::ng-deep .team-graph {\n    &--wd {\n      width: 80%;\n    }\n\n    &--ma {\n      margin: 0 auto;\n    }\n\n    &--mva {\n      margin: auto 0;\n    }\n\n    &.wrapper-content {\n      padding: 16px 16px 0;\n      margin-bottom: 11px;\n    }\n  }\n\n  &__plan {\n    z-index: 99;\n    border-top: 1px solid $color-grey-1;\n\n    h5 {\n      font-size: 14px;\n      font-weight: 600;\n    }\n\n    p {\n      font-size: 12px;\n      opacity: 0.6;\n    }\n\n    textarea {\n      border: 1px solid $color-grey-1;\n      width: 100%;\n      padding: 10px;\n      resize: vertical;\n      font-size: 10px;\n\n      &:focus {\n        outline: none;\n        // font-size: 12px;\n      }\n    }\n\n    &--wd {\n      max-width: 85%;\n      margin-left: auto;\n    }\n\n    &--pdt {\n      padding-top: 36px;\n    }\n\n    &--bdr {\n      border: 1px solid $color-grey-1;\n      border-top: 0;\n      padding-inline: 10px;\n    }\n\n    &__my {\n      // border-bottom: 1px solid $color-grey-1;\n\n      &:not(:last-child) {\n        padding-bottom: 12px;\n      }\n\n      i {\n        font-size: 10px !important;\n      }\n\n      h5 {\n        margin: 0;\n        font-size: 10px;\n      }\n\n      .save_btn {\n        display: inline-block;\n        font-size: 10px;\n        font-weight: bold;\n        border: 1px solid $color-grey-1;\n        border-radius: 20px;\n        padding: 3px 6px;\n      }\n\n      .cross_icn {\n        width: 22px;\n        height: 22px;\n        border: 1px solid $color-grey-1;\n        position: relative;\n        border-radius: 50%;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        margin-right: 5px;\n      }\n\n      .cancel_btn {\n        color: $body-content-color;\n        border: 0;\n        font-family: \"open sans\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n        font-size: 14px;\n        font-weight: 700;\n        transition: all ease 0.3s;\n        padding-right: 7px;\n      }\n\n      &--bdr {\n        border-bottom: 1px solid $color-grey-1;\n      }\n\n      &--indiv {\n        h5,\n        i {\n          font-size: 14px !important;\n        }\n\n        textarea {\n          font-size: 12px;\n        }\n      }\n    }\n\n    &__our {\n      padding-bottom: 10px;\n    }\n\n    &__svd {\n      border: 1px solid $color-grey-1;\n      padding: 10px 5px;\n      border-radius: 5px;\n    }\n  }\n\n  &__body {\n    border: 1px solid $color-grey-1;\n    border-top: 0;\n    display: flex;\n    flex-direction: column;\n    flex: 1;\n\n    &--nobdr {\n      border: 0;\n    }\n  }\n\n  .team-table {\n    padding: 10px;\n\n    &-bg {\n      ::ng-deep .hide-ratio {\n        h5 {\n          display: none;\n        }\n      }\n\n      ::ng-deep .show-counter {\n        display: flex;\n        justify-content: center;\n\n        &.high-clarify,\n        &.low-clarify {\n          h5 {\n            border: 5px solid $clarify-color;\n            background-color: $clarify-color;\n            color: $clarify-color !important;\n            text-shadow: none !important;\n          }\n        }\n\n        &.high-ideate,\n        &.low-ideate {\n          h5 {\n            border: 5px solid $ideate-color;\n            background-color: $ideate-color;\n            color: $ideate-color !important;\n            text-shadow: none !important;\n          }\n        }\n\n        &.high-develop,\n        &.low-develop {\n          h5 {\n            border: 5px solid $develop-color;\n            background-color: $develop-color;\n            color: $develop-color !important;\n            text-shadow: none !important;\n          }\n        }\n\n        &.high-implement,\n        &.low-implement {\n          h5 {\n            border: 5px solid $implement-color;\n            background-color: $implement-color;\n            color: $implement-color !important;\n            text-shadow: none !important;\n          }\n        }\n\n        h5 {\n          height: 30px !important;\n          width: 30px !important;\n          border-radius: 50%;\n          margin-inline: auto;\n          display: flex;\n          justify-content: center;\n          align-items: center;\n          margin-bottom: 10px !important;\n          @media screen and (max-width: 480px) {\n            height: 20px !important;\n            width: 20px !important;\n          }\n        }\n      }\n\n      ::ng-deep .high-clarify.common-high.common-profile._bg_changer {\n        background-color: $color-light-grey !important;\n      }\n\n      ::ng-deep .high-ideate.common-high.common-profile._bg_changer {\n        background-color: $color-light-grey !important;\n      }\n\n      ::ng-deep .high-develop.common-high.common-profile._bg_changer {\n        background-color: $color-light-grey !important;\n      }\n\n      ::ng-deep .high-implement.common-high.common-profile._bg_changer {\n        background-color: $color-light-grey !important;\n      }\n\n      ::ng-deep .low-clarify.common-low.common-profile._bg_changer {\n        background-color: $color-light-grey !important;\n      }\n\n      ::ng-deep .low-ideate.common-low.common-profile._bg_changer {\n        background-color: $color-light-grey !important;\n      }\n\n      ::ng-deep .low-develop.common-low.common-profile._bg_changer {\n        background-color: $color-light-grey !important;\n      }\n\n      ::ng-deep .low-implement.common-low.common-profile._bg_changer {\n        background-color: $color-light-grey !important;\n      }\n    }\n\n    img {\n      width: 17%;\n    }\n\n    table {\n      border: 2px solid $color-neutral-light;\n      border-right: 0;\n\n      thead {\n        background-color: $color-grey-1;\n        padding: 7px;\n        font-size: 12px;\n      }\n\n      tbody {\n        tr {\n          td {\n            width: calc(100% / 3);\n            border-right: 2px solid $color-neutral-light;\n            padding: 7px;\n          }\n        }\n      }\n    }\n  }\n\n  ::ng-deep.ibox {\n    border: 0;\n\n    &-title {\n      border-top: 0;\n      padding: 8px 18px;\n      min-height: auto;\n      background-color: $color-neutral-light;\n      border-radius: 4px 4px 0 0;\n\n      h5 {\n        float: none;\n        font-size: 12px;\n        font-weight: 700;\n\n        &:last-child {\n          margin-bottom: 0;\n        }\n      }\n\n      &--fx {\n        h5 {\n          display: flex;\n        }\n      }\n    }\n\n    &-content {\n      padding: 0;\n      border: 1px solid $color-grey-1;\n      border-radius: 0 0 4px 4px;\n\n      table {\n        margin-bottom: 0;\n\n        th {\n          font-size: 10px;\n          color: $body-content-color;\n\n          .soryby_outer {\n            display: inline-flex;\n            flex-direction: column;\n            height: 12px;\n            line-height: 1;\n            position: relative;\n            width: 10px;\n            top: 2px;\n\n            & > div {\n              position: absolute;\n              left: 50%;\n              transform: translateX(-50%);\n\n              &:nth-child(1) {\n                top: 0;\n              }\n\n              &:nth-child(2) {\n                bottom: 0;\n              }\n            }\n          }\n        }\n\n        td {\n          color: $body-content-color;\n\n          &.title-case {\n            span {\n              border-radius: 2px;\n              background-color: $body-content-color;\n              color: $clrWhite;\n              padding: 2px 4px 3px;\n              font-size: 10px;\n              font-weight: 700;\n            }\n          }\n\n          &.one_one_adv {\n            a {\n              display: inline-block;\n              border: 2px solid $develop-color;\n              color: $develop-color;\n              font-weight: 700;\n              padding: 4px 10px;\n              border-radius: 4px;\n              font-size: clamp(10px, 1vw, 14px);\n              text-align: center;\n              min-width: 100px;\n\n              &:hover {\n                background-color: $develop-color;\n                color: $clrWhite;\n              }\n            }\n          }\n\n          a {\n            color: inherit;\n          }\n\n          .no_pf {\n            display: inline-block;\n            background-color: #d4d4d4;\n            color: $body-content-color;\n            padding: 4px;\n            font-size: 10px;\n            border-radius: 2px;\n            font-weight: 700;\n            text-align: center;\n          }\n        }\n\n        .records_select {\n          display: flex;\n          flex-wrap: wrap;\n          align-items: center;\n          grid-gap: 5px;\n          margin-bottom: 0;\n\n          label {\n            margin-bottom: 0;\n          }\n\n          select {\n            width: min(70px, 100%);\n          }\n        }\n      }\n    }\n  }\n}\n\n::ng-deep .for-team-compo {\n  display: none;\n}\n\n.f-m-inline-0 {\n  margin-inline: 0 !important;\n}\n@media screen and (max-width: 1024px) {\n  .f-col-sm-12 {\n    width: 100%;\n  }\n}\nspan.sortby {\n  left: 0px;\n  width: 100%;\n  height: 100%;\n  z-index: 99999;\n  text-align: right;\n  position: absolute;\n  padding-right: 14px;\n}\n\n.art_dropdown_right {\n  .circle__dropdown {\n    right: 0;\n    left: auto;\n\n    &::after {\n      right: 17%;\n      left: auto;\n    }\n  }\n}\n\n.art_dropdown_bottom {\n  .circle__dropdown {\n    top: calc(100% + 10px);\n    right: 0;\n    bottom: auto;\n    left: auto;\n\n    &::after {\n      top: auto;\n      right: 17%;\n      bottom: 99%;\n      left: auto;\n      clip-path: polygon(50% 0, 100% 100%, 0 100%);\n    }\n  }\n}\n\n::ng-deep.team_meet {\n  padding-block: 29px;\n  &--pd {\n    padding-left: 3%;\n    padding-right: 7%;\n  }\n\n  & > *:not(:last-child) {\n    margin-bottom: 42px;\n  }\n\n  &__block {\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n\n    @media #{$pc} {\n      grid-template-columns: 1fr;\n      grid-row-gap: 30px;\n    }\n  }\n\n  &__col {\n    padding: 49px 35px;\n\n    @media #{$mobile} {\n      padding: 15px;\n    }\n\n    & > :not(:last-child) {\n      margin-bottom: 22px;\n    }\n\n    &--left {\n      border-radius: 4px 0px 0px 4px;\n      background-color: $color-neutral-light;\n\n      @media #{$mobile} {\n        border-radius: 4px;\n      }\n    }\n\n    &--right {\n      border-radius: 0px 4px 4px 0px;\n      border: 1px solid $color-grey-1;\n\n      @media #{$mobile} {\n        border-radius: 4px;\n      }\n\n      .team_meet__col_art {\n        border: 1px solid $color-grey-1;\n      }\n    }\n\n    &_header {\n      display: flex;\n      flex-wrap: wrap;\n      grid-gap: 20px;\n\n      &_left {\n        flex: 1;\n\n        h2 {\n          font-size: 24px;\n          font-weight: 700;\n          color: $body-content-color;\n\n          span {\n            display: block;\n            font-size: 16px;\n            line-height: 1.5;\n          }\n        }\n      }\n\n      &_right {\n        width: 125px;\n      }\n    }\n\n    &_desc {\n      p,\n      li {\n        color: #5c5d60;\n        font-size: 14px;\n        font-weight: 600;\n        line-height: 157%;\n\n        a {\n          text-decoration: underline;\n        }\n\n        button {\n          background-color: transparent;\n          border: 0;\n          color: $anchor-color;\n          cursor: pointer;\n        }\n      }\n    }\n\n    &_art {\n      border-radius: 4px;\n      background-color: #fff;\n\n      &_header {\n        border-bottom: 1px solid $color-grey-1;\n        padding: 10px 22px;\n        color: $body-content-color;\n        font-size: 14px;\n        font-weight: 700;\n      }\n\n      &_body {\n        padding: clamp(20px, 6vw, 90px) 16px;\n        text-align: center;\n\n        img {\n          max-width: 715px;\n          width: 100%;\n          display: block;\n          margin-inline: auto;\n        }\n\n        &_wrapper {\n          max-width: 715px;\n          width: 100%;\n          margin-inline: auto;\n        }\n\n        &_inner {\n          margin-top: clamp(140px, 11vw, 150px);\n          position: relative;\n          padding-bottom: 28%;\n        }\n      }\n\n      &_grid {\n        --lineHeight: 16%;\n        --line_top_to_bottom: rotate(30deg);\n        --line_bottom_to_top: rotate(-30deg);\n        display: grid;\n        grid-template-columns: repeat(4, 12%);\n        justify-content: space-between;\n        grid-gap: 20px;\n        position: absolute;\n        top: 0;\n        left: 0;\n        width: 100%;\n        height: 100%;\n        z-index: 0;\n\n        &.p_id_7 {\n          .clarify {\n            background-color: $clarify-color;\n            align-self: start;\n\n            &::before {\n              transform: var(--line_top_to_bottom);\n            }\n\n            .circle__dropdown {\n              background-color: $clarify-color;\n              display: block;\n            }\n          }\n\n          .develop {\n            &::before {\n              transform: var(--line_bottom_to_top);\n            }\n          }\n\n          .implement {\n            background-color: $implement-color;\n            align-self: start;\n\n            @extend .art_dropdown_right;\n\n            .circle__dropdown {\n              background-color: $implement-color;\n              display: block;\n            }\n          }\n        }\n\n        &.p_id_6 {\n          .clarify {\n            background-color: $clarify-color;\n            align-self: start;\n\n            &::before {\n              transform: var(--line_top_to_bottom);\n            }\n\n            .circle__dropdown {\n              display: block;\n            }\n          }\n\n          .ideate {\n            &::before {\n              transform: var(--line_bottom_to_top);\n            }\n          }\n\n          .develop {\n            background-color: $develop-color;\n            align-self: start;\n\n            &::before {\n              transform: var(--line_top_to_bottom);\n            }\n\n            .circle__dropdown {\n              display: block;\n            }\n          }\n        }\n\n        &.p_id_1 {\n          .clarify {\n            background-color: $clarify-color;\n            align-self: start;\n\n            &::before {\n              transform: var(--line_top_to_bottom);\n            }\n\n            .circle__dropdown {\n              display: block;\n            }\n          }\n        }\n\n        &.p_id_3 {\n          .ideate {\n            &::before {\n              transform: var(--line_bottom_to_top);\n            }\n          }\n\n          .develop {\n            background-color: $develop-color;\n            align-self: start;\n\n            &::before {\n              transform: var(--line_top_to_bottom);\n            }\n\n            .circle__dropdown {\n              display: block;\n            }\n          }\n        }\n\n        &.p_id_9 {\n          .clarify {\n            &::before {\n              transform: var(--line_bottom_to_top);\n            }\n          }\n\n          .ideate {\n            background-color: $ideate-color;\n            align-self: start;\n\n            &::before {\n              transform: var(--line_top_to_bottom);\n            }\n\n            .circle__dropdown {\n              display: block;\n            }\n          }\n\n          .develop {\n            &::before {\n              transform: var(--line_bottom_to_top);\n            }\n          }\n\n          .implement {\n            background-color: $implement-color;\n            align-self: start;\n\n            @extend .art_dropdown_right;\n\n            .circle__dropdown {\n              display: block;\n            }\n          }\n        }\n\n        &.p_id_5 {\n          .clarify {\n            background-color: $clarify-color;\n            align-self: start;\n\n            .circle__dropdown {\n              display: block;\n            }\n          }\n\n          .ideate {\n            background-color: $ideate-color;\n            align-self: start;\n\n            .circle__dropdown {\n              display: block;\n            }\n\n            &::before {\n              transform: var(--line_top_to_bottom);\n            }\n          }\n        }\n\n        &.p_id_10 {\n          @extend .art_dropdown_right;\n\n          .ideate {\n            &::before {\n              transform: var(--line_bottom_to_top);\n            }\n          }\n\n          .develop {\n            background-color: $develop-color;\n            align-self: start;\n\n            .circle__dropdown {\n              display: block;\n            }\n          }\n\n          .implement {\n            background-color: $implement-color;\n            align-self: start;\n\n            .circle__dropdown {\n              display: block;\n            }\n          }\n        }\n\n        &.p_id_11 {\n          .clarify {\n            background-color: $clarify-color;\n            align-self: start;\n\n            .circle__dropdown {\n              display: block;\n            }\n          }\n\n          .ideate {\n            background-color: $ideate-color;\n            align-self: start;\n\n            .circle__dropdown {\n              display: block;\n            }\n          }\n\n          .develop {\n            background-color: $develop-color;\n            align-self: start;\n\n            .circle__dropdown {\n              display: block;\n            }\n\n            &::before {\n              transform: var(--line_top_to_bottom);\n            }\n          }\n        }\n\n        &.p_id_12 {\n          .clarify {\n            background-color: $clarify-color;\n            align-self: start;\n\n            .circle__dropdown {\n              display: block;\n            }\n          }\n\n          .ideate {\n            background-color: $ideate-color;\n            align-self: start;\n\n            .circle__dropdown {\n              display: block;\n            }\n\n            &::before {\n              transform: var(--line_top_to_bottom);\n            }\n          }\n\n          .develop {\n            &::before {\n              transform: var(--line_bottom_to_top);\n            }\n          }\n\n          .implement {\n            background-color: $implement-color;\n            align-self: start;\n\n            @extend .art_dropdown_right;\n\n            .circle__dropdown {\n              display: block;\n            }\n          }\n        }\n\n        &.p_id_2 {\n          .clarify {\n            &::before {\n              transform: var(--line_bottom_to_top);\n            }\n          }\n\n          .ideate {\n            background-color: $ideate-color;\n            align-self: start;\n\n            .circle__dropdown {\n              display: block;\n            }\n\n            &::before {\n              transform: var(--line_top_to_bottom);\n            }\n          }\n        }\n\n        &.p_id_4 {\n          .develop {\n            &::before {\n              transform: var(--line_bottom_to_top);\n            }\n          }\n\n          .implement {\n            background-color: $implement-color;\n            align-self: start;\n\n            @extend .art_dropdown_right;\n\n            .circle__dropdown {\n              display: block;\n            }\n          }\n        }\n\n        &.p_id_14 {\n          .circle_dropdown_integrator {\n            display: block;\n          }\n\n          .circle {\n            align-self: start;\n\n            &.develop {\n              @extend .art_dropdown_bottom;\n            }\n\n            &.implement {\n              @extend .art_dropdown_right;\n            }\n          }\n        }\n\n        &.p_id_13 {\n          @extend .art_dropdown_right;\n\n          .clarify {\n            &::before {\n              transform: var(--line_bottom_to_top);\n            }\n          }\n\n          .ideate {\n            background-color: $ideate-color;\n            align-self: start;\n\n            .circle__dropdown {\n              display: block;\n            }\n          }\n\n          .develop {\n            background-color: $develop-color;\n            align-self: start;\n\n            .circle__dropdown {\n              display: block;\n            }\n          }\n\n          .implement {\n            background-color: $implement-color;\n            align-self: start;\n\n            .circle__dropdown {\n              display: block;\n            }\n          }\n        }\n\n        &.p_id_15 {\n          .clarify {\n            background-color: $clarify-color;\n            align-self: start;\n\n            &::before {\n              transform: var(--line_top_to_bottom);\n            }\n\n            .circle__dropdown {\n              display: block;\n            }\n          }\n\n          .ideate {\n            &::before {\n              transform: var(--line_bottom_to_top);\n            }\n          }\n\n          .develop {\n            background-color: $develop-color;\n            align-self: start;\n\n            @extend .art_dropdown_right;\n\n            .circle__dropdown {\n              display: block;\n            }\n          }\n\n          .implement {\n            background-color: $implement-color;\n            align-self: start;\n\n            @extend .art_dropdown_right;\n\n            .circle__dropdown {\n              display: block;\n            }\n          }\n        }\n\n        &.p_id_8 {\n          .clarify {\n            &::before {\n              transform: var(--line_bottom_to_top);\n            }\n          }\n\n          .ideate {\n            background-color: $ideate-color;\n            align-self: start;\n\n            .circle__dropdown {\n              display: block;\n            }\n          }\n\n          .develop {\n            background-color: $develop-color;\n            align-self: start;\n\n            &::before {\n              transform: var(--line_top_to_bottom);\n            }\n\n            .circle__dropdown {\n              display: block;\n            }\n          }\n        }\n      }\n\n      .circle {\n        width: 100%;\n        aspect-ratio: 1;\n        background: $color-neutral-light;\n        border-radius: 50%;\n        align-self: end;\n        position: relative;\n\n        &:not(:last-child)::before {\n          content: \"\";\n          position: absolute;\n          top: calc(50% - (var(--lineHeight) / 2));\n          height: var(--lineHeight);\n          margin-block: auto;\n          width: 235%;\n          background: $color-neutral-light;\n          z-index: -1;\n          transform-origin: left;\n        }\n\n        &.clarify {\n          .circle__dropdown {\n            background-color: $clarify-color;\n          }\n        }\n\n        &.ideate {\n          .circle__dropdown {\n            background-color: $ideate-color;\n          }\n        }\n\n        &.develop {\n          .circle__dropdown {\n            background-color: $develop-color;\n          }\n        }\n\n        &.implement {\n          .circle__dropdown {\n            background-color: $implement-color;\n          }\n        }\n\n        &__dropdown {\n          position: absolute;\n          bottom: calc(100% + 10px);\n          padding: 7px;\n          border-radius: 5px;\n          text-align: left;\n          background: $color-neutral-light;\n          width: 230%;\n          display: none;\n\n          &::after {\n            content: \"\";\n            position: absolute;\n            top: 99%;\n            left: 15%;\n            width: 20px;\n            height: 8px;\n            background-color: inherit;\n            clip-path: polygon(0 0, 100% 0, 50% 100%);\n          }\n\n          & > * {\n            &:first-child {\n              margin-top: 0;\n            }\n\n            &:last-child {\n              margin-bottom: 0;\n            }\n          }\n\n          ul,\n          ol {\n            padding-left: 0;\n          }\n\n          li {\n            position: relative;\n            list-style: none;\n            padding-left: 8px;\n\n            &::before {\n              content: \"\";\n              position: absolute;\n              top: 50%;\n              transform: translateY(-50%);\n              left: 0;\n              width: 4px;\n              aspect-ratio: 1;\n              background-color: $clrWhite;\n              border-radius: 50%;\n            }\n          }\n\n          p,\n          li {\n            font-size: clamp(8px, 1vw, 14px);\n            line-height: 1.3;\n            font-weight: 600;\n            color: #fff;\n\n            &:not(:last-child) {\n              margin-bottom: 5px;\n            }\n          }\n        }\n      }\n\n      .circle_dropdown_integrator {\n        position: absolute;\n        bottom: calc(100% + 20px);\n        left: 50%;\n        transform: translateX(-50%);\n        padding: 7px;\n        border-radius: 5px;\n        text-align: left;\n        background: $body-content-color;\n        width: 27.597%;\n        display: none;\n\n        &::after {\n          content: \"\";\n          position: absolute;\n          top: 99%;\n          left: 50%;\n          transform: translateX(-50%);\n          width: 20px;\n          height: 8px;\n          background-color: inherit;\n          clip-path: polygon(0 0, 100% 0, 50% 100%);\n        }\n\n        & > * {\n          &:first-child {\n            margin-top: 0;\n          }\n\n          &:last-child {\n            margin-bottom: 0;\n          }\n        }\n\n        ul,\n        ol {\n          padding-left: 0;\n        }\n\n        li {\n          position: relative;\n          list-style: none;\n          padding-left: 8px;\n\n          &::before {\n            content: \"\";\n            position: absolute;\n            top: 50%;\n            transform: translateY(-50%);\n            left: 0;\n            width: 4px;\n            aspect-ratio: 1;\n            background-color: $clrWhite;\n            border-radius: 50%;\n          }\n        }\n\n        p,\n        li {\n          font-size: clamp(8px, 1vw, 14px);\n          line-height: 1.3;\n          font-weight: 600;\n          color: #fff;\n\n          &:not(:last-child) {\n            margin-bottom: 5px;\n          }\n        }\n      }\n    }\n  }\n\n  &__challenges {\n    &_header {\n      border-radius: 4px 4px 0px 0px;\n      background-color: $color-neutral-light;\n      padding: 9px 22px;\n\n      & > :last-child {\n        margin-bottom: 0;\n      }\n\n      h2 {\n        font-size: 16px;\n        font-weight: 700;\n        color: $body-content-color;\n      }\n    }\n\n    &_grid {\n      --col_per_row: 4;\n      display: grid;\n      grid-template-columns: repeat(var(--col_per_row), 1fr);\n      grid-gap: 18px;\n      padding: 25px 41px;\n      border: 1px solid $color-grey-1;\n      border-top: 0;\n      border-radius: 0 0 4px 4px;\n\n      @media #{$pc} {\n        --col_per_row: 2;\n      }\n\n      @media #{$mobile} {\n        --col_per_row: 1;\n        padding: 20px;\n      }\n    }\n\n    &_col {\n      border-radius: 4px;\n      border: 1px solid $color-grey-1;\n      background-color: #fff;\n      padding: 27px 20px 30px;\n      text-align: center;\n\n      & > :last-child {\n        margin-bottom: 0;\n      }\n\n      h3 {\n        font-size: 16px;\n        text-transform: uppercase;\n        font-weight: 700;\n\n        &:not(:last-child) {\n          margin-bottom: 18px;\n        }\n      }\n\n      &.clarify {\n        .team_meet__challenges_profile {\n          div.high {\n            background-color: $clarify-color;\n          }\n        }\n      }\n\n      &.ideate {\n        .team_meet__challenges_profile {\n          div.high {\n            background-color: $ideate-color;\n          }\n        }\n      }\n\n      &.develop {\n        .team_meet__challenges_profile {\n          div.high {\n            background-color: $develop-color;\n          }\n        }\n      }\n\n      &.implement {\n        .team_meet__challenges_profile {\n          div.high {\n            background-color: $implement-color;\n          }\n        }\n      }\n    }\n\n    &_profile {\n      display: grid;\n      grid-template-columns: repeat(2, 1fr);\n      grid-gap: 10px;\n      width: 111px;\n      margin-inline: auto;\n\n      // &:not(:last-child) {\n      //     margin-bottom: 26px;\n      // }\n\n      & > div {\n        aspect-ratio: 1;\n        border-radius: 50%;\n        background-color: $color-light-grey;\n      }\n    }\n\n    &_integrator {\n      border: 1px solid $color-grey-1;\n      border-radius: 0 0 4px 4px;\n\n      &_inner {\n        padding: 25px 41px;\n\n        & > :not(:last-child) {\n          margin-bottom: 27px;\n          padding-bottom: 27px;\n          border-bottom: 1px solid $color-grey-1;\n        }\n      }\n\n      &_grid {\n        display: flex;\n        flex-wrap: wrap;\n        justify-content: space-between;\n        width: min(1400px, 100%);\n        margin-inline: auto;\n        grid-row-gap: 10px;\n\n        @media #{$tablet} {\n          display: grid;\n          grid-template-columns: repeat(2, 1fr);\n          grid-gap: 30px;\n        }\n\n        @media #{$mobile} {\n          grid-template-columns: repeat(1, 1fr);\n        }\n      }\n\n      &_col {\n        width: 111px;\n        text-align: center;\n\n        @media #{$tablet} {\n          width: 100%;\n        }\n\n        h3 {\n          font-size: 16px;\n          text-transform: uppercase;\n          font-weight: 700;\n\n          &:not(:last-child) {\n            margin-bottom: 16px;\n          }\n        }\n      }\n\n      &_profile {\n        display: grid;\n        grid-template-columns: repeat(2, 1fr);\n        grid-gap: 10px;\n        width: 111px;\n        margin-inline: auto;\n\n        & > div {\n          aspect-ratio: 1;\n          background-color: $body-content-color;\n          border-radius: 50%;\n        }\n\n        &.clarify {\n          div.high {\n            background-color: $clarify-color;\n          }\n        }\n\n        &.ideate {\n          div.high {\n            background-color: $ideate-color;\n          }\n        }\n\n        &.develop {\n          div.high {\n            background-color: $develop-color;\n          }\n        }\n\n        &.implement {\n          div.high {\n            background-color: $implement-color;\n          }\n        }\n      }\n\n      &_info {\n        text-align: center;\n        width: min(647px, 100%);\n        margin-inline: auto;\n\n        p {\n          font-size: 14px;\n          font-weight: 600;\n          color: $body-content-color;\n        }\n      }\n    }\n  }\n\n  &__agreement {\n    &_header {\n      border-radius: 4px 4px 0px 0px;\n      background-color: $color-neutral-light;\n      padding: 9px 22px;\n\n      h3 {\n        font-size: 16px;\n        font-weight: 700;\n        color: $body-content-color;\n      }\n    }\n\n    &_body {\n      border-radius: 0px 0px 4px 4px;\n      border: 1px solid $color-grey-1;\n    }\n\n    &_tab_nav {\n      ul {\n        padding: 0;\n        margin: 0;\n        display: flex;\n        flex-wrap: wrap;\n        border-bottom: 1px solid $color-grey-1;\n\n        li {\n          list-style: none;\n\n          @media #{$mobile} {\n            width: 100%;\n          }\n        }\n\n        @media #{$mobile-up} {\n          li:not(:last-child) {\n            border-right: 1px solid $color-grey-1;\n          }\n        }\n      }\n\n      button {\n        color: $body-content-color;\n        font-size: 12px;\n        font-weight: 600;\n        opacity: 0.9;\n        min-width: 219px;\n        border: 0;\n        background-color: transparent;\n        padding: 9px 23px;\n        position: relative;\n        border-radius: 0;\n        cursor: pointer;\n\n        @media #{$mobile} {\n          width: 100%;\n        }\n\n        &.active {\n          font-weight: 700;\n\n          &::after {\n            opacity: 1;\n          }\n        }\n\n        &::after {\n          content: \"\";\n          position: absolute;\n          right: 0;\n          bottom: 0;\n          left: 0;\n          background-color: $develop-color;\n          height: 2px;\n          opacity: 0;\n        }\n      }\n    }\n\n    &_tab_content {\n      padding: 24px 20px;\n\n      form > *:not(:last-child) {\n        margin-bottom: 16px;\n      }\n\n      input,\n      textarea {\n        border-radius: 4px;\n        border: 1px solid $color-grey-1;\n        height: 122px;\n        resize: none;\n        padding: 11px 15px;\n        width: 100%;\n\n        &:focus {\n          outline: none;\n        }\n      }\n\n      input {\n        height: 34px;\n      }\n\n      input[type=\"submit\"] {\n        border-radius: 4px;\n        background: $develop-color;\n        font-size: 14px;\n        font-weight: 600;\n        text-align: center;\n        color: #fff;\n        border: 0;\n        width: auto;\n        padding: 7px 27px;\n        cursor: pointer;\n        transition: 0.3s;\n\n        &:hover {\n          background-color: $body-content-color;\n        }\n      }\n    }\n  }\n}\n\n::ng-deep._no_profile_ {\n  height: 18px;\n  width: 18px;\n  border-radius: 50%;\n  color: $color-red;\n  font-size: 8px;\n  background: $color-neutral-light;\n\n  &._bgw_ {\n    background-color: $clrWhite;\n  }\n}\n\n::ng-deep.missing-profiles {\n  background-color: $color-light-grey;\n\n  h5,\n  i {\n    color: $body-content-color;\n  }\n}\n\n// advice_sidebar\n.advice_sidebar {\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  overflow-y: auto;\n  width: calc(100% - 70px);\n  max-width: 240px;\n  background-color: #fff;\n  z-index: 999;\n  box-shadow: 0px 4px 24px 0px rgba(0, 0, 0, 0.05);\n\n  &__wrapper {\n    padding: 10px;\n  }\n\n  &__header {\n    background-color: $color-neutral-light;\n    padding: 10px 35px 10px 15px;\n    border-radius: 4px;\n    font-size: 16px;\n    font-weight: 700;\n    color: $body-content-color;\n    position: relative;\n\n    &:not(:last-child) {\n      margin-bottom: 15px;\n    }\n  }\n\n  &__list {\n    padding-inline: 15px;\n\n    & > :not(:last-child) {\n      margin-bottom: 15px;\n    }\n\n    h5 {\n      font-weight: 700;\n      font-size: 14px;\n      margin-top: 0;\n\n      &:not(:last-child) {\n        margin-bottom: 5px;\n      }\n    }\n\n    ul {\n      margin: 0;\n      padding: 0;\n      list-style: none;\n    }\n\n    p,\n    li {\n      font-weight: 600;\n      font-size: 12px;\n\n      &:not(:last-child) {\n        margin-bottom: 10px;\n      }\n    }\n  }\n\n  &__close {\n    --line_thickness: 2px;\n    --line_length: 70%;\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    right: 10px;\n    margin-block: auto;\n    width: 18px;\n    aspect-ratio: 1;\n    background-color: transparent;\n    border: 0;\n    padding: 0;\n    cursor: pointer;\n\n    &:hover > div::before,\n    &:hover > div::after {\n      background-color: $develop-color;\n    }\n\n    div {\n      position: absolute;\n      inset: 0;\n      transform: rotate(45deg);\n\n      &::before,\n      &::after {\n        content: \"\";\n        position: absolute;\n        top: 50%;\n        left: 50%;\n        transform: translate(-50%, -50%);\n        background-color: $body-content-color;\n        transition: all ease 0.3s;\n      }\n\n      &::before {\n        width: var(--line_thickness);\n        height: var(--line_length);\n      }\n\n      &::after {\n        width: var(--line_length);\n        height: var(--line_thickness);\n      }\n    }\n  }\n}\n\n::ng-deep.fa-chevron-up {\n  transition: all 0.3s ease;\n\n  &.active {\n    transform: rotate(180deg);\n  }\n}\n\n.txt_trnsfrm {\n  text-transform: capitalize;\n}\n\n.planchk {\n  // accent-color: #639935;\n}\n\n.counter {\n  display: block;\n  // height: 20px;\n  // width: 20px;\n  // border: 1px solid $color-grey-1;\n  // border-radius: 50%;\n  text-align: left;\n  font-weight: normal;\n  padding-top: 2px;\n  font-size: 10px;\n}\n\n.gap10 {\n  gap: 10px;\n}\n\n// .pd_percn {\n//     padding-left: 3%;\n//     padding-right: 7%;\n// }\n\n// advice_sidebar end\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
